// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gf-page {
    background: #f5f6fa;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.gf-body {
    padding: 24px;
    flex: 1 1;
}

/* Sub-navbar */
.gf-subnav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2px;
    background: #e2e8f0;
    border-radius: 8px;
    padding: 3px;
    margin-bottom: 20px;
    width: 100%;
}
.gf-subnav-left { display: flex; gap: 2px; }
.gf-subnav-right { display: flex; gap: 2px; }
.gf-tab-faturar.active { background: #fff; color: #16a34a !important; box-shadow: 0 1px 4px rgba(0,0,0,0.1); }
.gf-tab-faturar:not(.active):hover { color: #15803d !important; }

/* Linha que contém o subnav + botão Listagens lado a lado */
.gf-nav-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}
.gf-nav-row .gf-subnav {
    margin-bottom: 0;  /* margem já está no gf-nav-row */
    flex-shrink: 0;
}
.btn-listagens-action {
    padding: 8px 18px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 6px;
    background: #3182ce;
    color: #fff;
    border: none;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s;
}
.btn-listagens-action:hover { background: #2b6cb0; }

/* Modal Listagens */
.lst-modal {
    max-width: 1550px; width: 98vw; min-width: min(98vw, 1200px); max-height: 92vh;
    /* Altura mínima para a caixa dos nomes caber aberta.

       A lista de clientes desce 360px por baixo do botão. Antes de se gerar a
       listagem a janela tinha 193px de altura e o corpo cortava-a a meio: via-se
       a caixa de procura e meia dúzia de nomes. Escolher vários assim era
       impossível. O 92vh de cima continua a mandar em ecrãs baixos, e o "min("
       impede que a janela fique maior do que o ecrã. */
    min-height: min(560px, 92vh);
    display: flex; flex-direction: column;
}
.lst-filters {
    display: flex; flex-wrap: wrap; gap: 14px;
    padding: 4px 0 14px; border-bottom: 1px solid #f1f5f9; margin-bottom: 14px;
    align-items: flex-end;
}
.lst-filter-group { display: flex; flex-direction: column; gap: 5px; }
.lst-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; color: #64748b; }
.lst-btn-group { display: flex; gap: 4px; }
.lst-btn {
    padding: 5px 12px; border-radius: 6px; font-size: 12px; font-weight: 500;
    background: #f8fafc; color: #475569; border: 1px solid #e2e8f0; cursor: pointer;
    transition: all 0.12s;
}
.lst-btn:hover  { background: #f1f5f9; }
.lst-btn.active { background: #3182ce; color: #fff; border-color: #3182ce; }
.lst-date-row   { display: flex; align-items: center; gap: 6px; }
.lst-date-input {
    padding: 5px 8px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 12px;
    color: #374151; background: #fff;
}
.lst-date-input:focus { border-color: #3b82f6; outline: none; }
.lst-select {
    padding: 5px 10px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 12px;
    color: #374151; background: #fff; min-width: 200px;
}
.lst-select:focus { border-color: #3b82f6; outline: none; }

/* Escolha de vários fornecedores nas listagens.
   O painel abre por cima do resto dos filtros. Fica com altura limitada e
   rolamento próprio porque a lista de fornecedores passa de uma centena, e um
   painel a toda a altura sairia fora da janela do modal, que tem rolamento. */
.lst-multi { position: relative; }
.lst-multi-btn {
    display: flex; align-items: center; justify-content: space-between; gap: 8px;
    min-width: 240px; max-width: 320px;
    padding: 5px 10px; border: 1px solid #e2e8f0; border-radius: 6px;
    font-size: 12px; color: #374151; background: #fff; cursor: pointer;
    font-family: inherit; text-align: left;
}
.lst-multi-btn:hover { border-color: #cbd5e1; }
.lst-multi-btn:focus-visible { outline: 2px solid #3b82f6; outline-offset: 1px; }
.lst-multi-btn.ativo { border-color: #3182ce; color: #1e429f; font-weight: 600; }
.lst-multi-rotulo { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.lst-multi-seta { color: #94a3b8; flex: 0 0 auto; }

.lst-multi-painel {
    position: absolute; top: calc(100% + 4px); left: 0; z-index: 40;
    width: 320px; background: #fff;
    border: 1px solid #e2e8f0; border-radius: 8px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);
    padding: 8px; display: flex; flex-direction: column; gap: 6px;
}
.lst-multi-busca {
    padding: 5px 8px; border: 1px solid #e2e8f0; border-radius: 6px;
    font-size: 12px; color: #374151; font-family: inherit;
}
.lst-multi-busca:focus { border-color: #3b82f6; outline: none; }
.lst-multi-acoes { display: flex; gap: 6px; }
.lst-multi-acoes button {
    flex: 1 1; padding: 4px 6px; border-radius: 5px; font-size: 11px;
    background: #f8fafc; color: #475569; border: 1px solid #e2e8f0;
    cursor: pointer; font-family: inherit;
}
.lst-multi-acoes button:hover { background: #f1f5f9; }
.lst-multi-lista { max-height: 280px; overflow-y: auto; overscroll-behavior: contain; }
.lst-multi-item {
    display: flex; align-items: flex-start; gap: 7px;
    padding: 4px 5px; border-radius: 5px; font-size: 12px;
    color: #374151; cursor: pointer; line-height: 1.35;
}
.lst-multi-item:hover { background: #f8fafc; }
.lst-multi-item input { margin-top: 2px; flex: 0 0 auto; cursor: pointer; }
.lst-multi-vazio, .lst-multi-nota {
    margin: 0; padding: 6px 5px; font-size: 11px; color: #94a3b8;
}
.lst-multi-nota { border-top: 1px solid #f1f5f9; }

/* O estado "Não pagos" não faz sentido quando se lista por data de pagamento. */
.lst-btn:disabled { opacity: 0.45; cursor: not-allowed; }
.lst-btn:disabled:hover { background: #f8fafc; }
.lst-btn-gerar {
    padding: 7px 20px; border-radius: 7px; font-size: 13px; font-weight: 600;
    background: #3182ce; color: #fff; border: none; cursor: pointer; transition: background 0.15s;
    align-self: flex-end;
}
.lst-btn-gerar:hover    { background: #2b6cb0; }
.lst-btn-gerar:disabled { background: #93c5fd; cursor: not-allowed; }

.lst-summary {
    display: flex; align-items: center; gap: 20px; flex-wrap: wrap;
    padding: 8px 12px; background: #f8fafc; border-radius: 8px; margin-bottom: 12px;
    font-size: 13px; color: #475569;
}
.lst-em-falta-total { color: #9a3412; }
.lst-empty { text-align: center; color: #94a3b8; padding: 24px; }

.lst-btn-excel {
    margin-left: auto;
    padding: 8px 12px; border-radius: 6px; font-size: 13px; font-weight: 600;
    background: #f0fdf4; color: #16a34a; border: 1px solid #16a34a;
    cursor: pointer; white-space: nowrap; transition: background 0.15s;
}
.lst-btn-excel:hover    { background: #dcfce7; }
.lst-btn-excel:disabled { opacity: 0.5; cursor: not-allowed; }

.lst-table-wrap { overflow: auto; flex: 1 1; border-radius: 8px; border: 1px solid #e5e7eb; }
.lst-table { width: 100%; }
.lst-tfoot td {
    background: #f8f9fb; border-top: 2px solid #e2e8f0;
    padding: 8px 10px; font-size: 12px;
}

.gf-subnav-btn {
    padding: 8px 20px;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    color: #64748b;
    background: transparent;
    transition: all 0.15s;
}
.gf-subnav-btn:hover { color: #1e293b; background: rgba(255,255,255,0.6); }
.gf-subnav-btn.active { background: #fff; color: #3182ce; box-shadow: 0 1px 4px rgba(0,0,0,0.1); }

.gf-content {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 8px rgba(0,0,0,0.07);
    padding: 24px;
}

/* ---- Scanner ---- */

.gf-modo-tabs {
    display: flex;
    gap: 6px;
    margin-bottom: 20px;
}

.gf-modo-btn {
    padding: 7px 16px;
    border: 1px solid #dde1e7;
    border-radius: 6px;
    background: #f8f9fb;
    color: #555;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
}
.gf-modo-btn:hover { background: #e5e7eb; }
.gf-modo-btn.active { background: #3182ce; color: #fff; border-color: #3182ce; }

.gf-input-area {
    background: #f8f9fb;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 24px;
    margin-bottom: 20px;
}

/* Pistola mode */
.gf-pistola {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 10px 0;
}

.gf-pistola-icon { font-size: 40px; }

.gf-pistola-hint {
    text-align: center;
    color: #555;
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
}

.gf-pistola-row {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    max-width: 560px;
}

.gf-atcud-input {
    flex: 1 1;
    padding: 12px 16px;
    border: 2px solid #3182ce;
    border-radius: 8px;
    font-size: 15px;
    font-family: monospace;
    text-align: center;
    background: #fff;
    outline: none;
    min-width: 0;
}
.gf-atcud-input:focus { box-shadow: 0 0 0 3px rgba(49,130,206,0.15); }

.gf-pistola-tip {
    font-size: 11px;
    color: #9ca3af;
    margin: 0;
}

.gf-scanner-ef-search {
    width: 100%;
    max-width: 560px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.gf-scanner-ef-label {
    font-size: 12px;
    font-weight: 600;
    color: #4a5568;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

/* Manual mode */
.gf-manual-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 14px;
    margin-bottom: 0;
}
@media (max-width: 700px) { .gf-manual-grid { grid-template-columns: 1fr; } }

.gf-field { display: flex; flex-direction: column; gap: 4px; }
.gf-field label { font-size: 10px; font-weight: 700; color: #888; text-transform: uppercase; letter-spacing: 0.5px; }
.gf-field input {
    padding: 8px 10px;
    border: 1px solid #dde1e7;
    border-radius: 5px;
    font-size: 13px;
    background: #fff;
}
.gf-field input:focus { outline: none; border-color: #3182ce; }

/* Bulk mode */
.gf-bulk { display: flex; flex-direction: column; gap: 20px; }
.gf-bulk-dropzone {
    border: 2px dashed #cbd5e1;
    border-radius: 12px;
    background: #fff;
    padding: 40px;
    text-align: center;
    transition: all 0.2s;
    cursor: pointer;
}
.gf-bulk-dropzone:hover, .gf-bulk-dropzone.dragging { border-color: #3182ce; background: #f0f9ff; }
.gf-bulk-label { display: flex; flex-direction: column; align-items: center; gap: 10px; cursor: pointer; }
.gf-bulk-icon { font-size: 40px; }
.gf-bulk-label strong { color: #1e293b; font-size: 15px; }
.gf-bulk-label p { color: #64748b; font-size: 13px; margin: 0; }

/* Progress Bar */
.gf-bulk-progress-container {
    background: #e2e8f0;
    border-radius: 100px;
    height: 12px;
    width: 100%;
    position: relative;
    overflow: hidden;
    margin: 10px 0;
}
.gf-bulk-progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #3b82f6, #3182ce);
    transition: width 0.3s ease;
}
.gf-bulk-progress-text {
    display: block;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    margin-top: 5px;
}

.gf-bulk-list {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.gf-bulk-list h4 { margin: 0; color: #334155; }
.btn-bulk-process {
    background: #059669;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
}
.btn-bulk-process:hover { background: #047857; }

/* Botões de ação (modal/formulário) */
.gf-actions-form {
    display: flex;
    gap: 10px;
    margin-top: 16px;
    align-items: center;
}

.btn-gf-search {
    background: #3182ce;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 9px 18px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.btn-gf-search:hover:not(:disabled) { background: #2b6cb0; }
.btn-gf-search:disabled { opacity: 0.6; cursor: not-allowed; }

/* Pesquisa das Faturas Fornecedor: botão (modo manual) e interruptor Auto. */
.gf-search-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    white-space: nowrap;
}
/* Texto escrito mas ainda não aplicado à listagem. */
.gf-search-btn.pendente { outline: 2px solid #f0b429; outline-offset: 2px; }

.gf-search-auto {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #fff;
    color: #64748b;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
}
.gf-search-auto:hover { background: #f8fafc; }
.gf-search-auto-track {
    position: relative;
    width: 30px;
    height: 16px;
    border-radius: 999px;
    background: #cbd5e1;
    transition: background .15s;
    flex: 0 0 auto;
}
.gf-search-auto-thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
    transition: transform .15s;
}
.gf-search-auto.on { color: #1e3a5f; }
.gf-search-auto.on .gf-search-auto-track { background: #3182ce; }
.gf-search-auto.on .gf-search-auto-thumb { transform: translateX(14px); }

.btn-gf-clear {
    background: #f3f4f6;
    border: 1px solid #dde1e7;
    color: #555;
    border-radius: 6px;
    padding: 9px 16px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.btn-gf-clear:hover { background: #e5e7eb; }

/* Erro */
.gf-erro {
    background: #fee2e2;
    color: #dc2626;
    padding: 10px 14px;
    border-radius: 6px;
    font-size: 13px;
    margin-bottom: 16px;
}

.gf-info {
    background: #eff6ff;
    color: #1d4ed8;
    border: 1px solid #bfdbfe;
    padding: 10px 14px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 16px;
}

/* Info da fatura analisada */
.gf-fatura-info {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    background: #f0f9ff;
    border: 1px solid #bae6fd;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 13px;
    color: #0c4a6e;
    margin-bottom: 16px;
}

/* Resultados */
.gf-resultados-header-bulk {
    margin-bottom: 15px;
}
.gf-resultados-header-bulk h3 { margin: 0; font-size: 15px; color: #1a1a2e; }

.gf-result-hint {
    font-size: 12px;
    color: #64748b;
    margin: 4px 0 0 0;
    font-style: italic;
}

/* Tabelas */
.gf-table-wrap { overflow: auto; border-radius: 8px; border: 1px solid #e5e7eb; }

.gf-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
}
.gf-table thead tr { background: #f8f9fb; }
.gf-table th {
    padding: 6px 6px;
    text-align: left;
    font-weight: 700;
    color: #555;
    border-bottom: 1px solid #e5e7eb;
    font-size: 10px;
    text-transform: uppercase;
    white-space: nowrap;
}
.gf-table td { padding: 6px 6px; border-bottom: 1px solid #f3f4f6; vertical-align: middle; }

/* Títulos ao centro. Vai com o "table." à frente de propósito: o App.css tem
   um ".standard-table th { text-align: left }" que estas tabelas também
   apanham, e sem o elemento extra as duas regras empatavam — ganhava a que
   viesse depois, que é a de lá.

   Só os títulos. O conteúdo das células mantém o alinhamento de cada coluna:
   texto à esquerda, montantes à direita, que é o que os deixa alinhar pela
   casa decimal. */
table.gf-table th { text-align: center; }

.gf-row { transition: background 0.1s; }
.gf-row-click { cursor: pointer; }
.gf-row-click:hover, .gf-row:hover { background: #f8f9fb; }

/* Row colors by match type */
.gf-row.gf-exato { background: #f0fdf4; }
.gf-row.gf-exato:hover { background: #dcfce7; }
.gf-row.gf-aproximado { background: #fffbeb; }
.gf-row.gf-aproximado:hover { background: #fef3c7; }

.match-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px; height: 22px;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 900;
}
.match-exato  { background: #dcfce7; color: #059669; }
.match-aproximado { background: #fef3c7; color: #d97706; }

/* O nowrap é preciso: sem ele o "EF-2026-37236" parte-se no hífen e a coluna
   fica com o número em duas linhas. */
.gf-num    { font-weight: 600; color: #3182ce; white-space: nowrap; }
.gf-orc-badge {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    color: #1e40af;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    display: inline-block;
}
.gf-ef-tag {
    display: inline-block;
    background: #ede9fe;
    color: #6d28d9;
    border: 1px solid #c4b5fd;
    padding: 3px 8px;
    border-radius: 12px;
    font-weight: 700;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
    cursor: pointer;
}
.gf-ef-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
}
.gf-ef-carousel {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}
.gf-ef-carousel-nav {
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    color: #475569;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    transition: background 0.1s, border-color 0.1s;
}
.gf-ef-carousel-nav:hover {
    background: #e2e8f0;
    border-color: #94a3b8;
    color: #1e293b;
}
.gf-ef-carousel-count {
    font-size: 10px;
    color: #64748b;
    font-weight: 600;
    margin-left: 2px;
    white-space: nowrap;
}
.gf-line-tag {
    color: #64748b;
    font-size: 11px;
}
.gf-proj   { max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

.tc { text-align: center; }
.tr { text-align: right; }
.pos { color: #059669; font-weight: 600; }
.neg { color: #dc2626; font-weight: 600; }

.btn-ver-orc {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    color: #1e40af;
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
}
.btn-ver-orc:hover { background: #dbeafe; }

.btn-faturar-row {
    background: #f0fdf4;
    border: 1px solid #86efac;
    color: #15803d;
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
}
.btn-faturar-row:hover:not(:disabled) { background: #dcfce7; }
.btn-faturar-row:disabled { opacity: 0.5; cursor: default; }

.gf-inline-input {
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 11px;
    width: 100%;
    /* 78px chegam para "FT 2026/001", que é o formato usado. O espaço que sobra
       vai para o nome do cliente, que é quem precisa dele. */
    min-width: 78px;
    box-sizing: border-box;
}
/* O campo do numero: o texto que la vai e sempre curto (FT 2026/001), e a
   largura a mais so afastava a data do cliente. */
.gf-inline-input:not([type="date"]) { max-width: 84px; }
/* A data tem de mostrar "dd/mm/aaaa" e o ícone do calendário; abaixo dos 112px
   o browser come o ano ou o ícone. É o mínimo em que ainda se lê inteira. */
.gf-inline-input[type="date"] { min-width: 126px; max-width: 132px; }
/* Campo de data por preencher: sem o "dd/mm/aaaa" a fazer de marca de água.

   O texto é desenhado pelo próprio browser — não há placeholder que o tire.
   Torna-se transparente enquanto estiver vazio e volta a aparecer mal se toque
   no campo, senão quem lá vai escrever não vê onde vai o dia e onde vai o mês.
   O ícone do calendário fica, que é o que diz que aquilo é uma data. */
.gf-inline-input[type="date"].vazia::-webkit-datetime-edit { color: transparent; }
.gf-inline-input[type="date"].vazia:focus::-webkit-datetime-edit { color: inherit; }
.gf-inline-input:focus { outline: none; border-color: #6366f1; box-shadow: 0 0 0 2px #e0e7ff; }

/* Tabela Faturas Fornecedor */
/* Faturas pagas: fundo verde, a par do vermelho das não associadas. Substitui o
   antigo opacity 0.55 — com a linha esbatida, o verde ficava lavado e não se
   distinguia. O seletor é mais específico do que .gf-row-pendente de propósito:
   uma fatura paga mas sem encomenda associada deve ler-se como paga. */
/* Verde mais escuro, mesma transparência: muda-se a cor de base (green-300 →
   green-500) e mantém-se o alfa, para o grau de esbatimento não se alterar. */
.gf-table tr.gf-row-pago { background: rgba(34, 197, 94, 0.18) !important; }
.gf-table tr.gf-row-pago:hover { background: rgba(34, 197, 94, 0.28) !important; }
/* As células apanham fundos OPACOS em hover vindos de três regras diferentes:
   .standard-table tr:hover td (App.css:270, #f8fafc), .gf-row-clickable:hover td
   (linha ~1415 deste ficheiro, #eff6ff) e a variante do tema "simple".
   Na ordem de pintura das tabelas o fundo da CÉLULA fica por cima do fundo da
   LINHA, logo tapam o verde — e o !important da regra do verde não lhes chega,
   porque só arbitra declarações no mesmo elemento, e ali são elementos distintos.
   Repõe-se transparente com especificidade superior às três. A coluna do × fica
   de fora: precisa de fundo opaco por ser sticky, e já recebe o verde por
   gradiente logo a seguir. */
.gf-table tr.gf-row-pago:hover td:not(.gf-td-del) {
    background: transparent;
}

/* A coluna do × é sticky com fundo branco opaco (para o conteúdo lhe passar por
   baixo ao deslizar a tabela), logo não apanha o verde da linha e destacava-se
   como um retângulo branco — sobretudo ao passar o rato, com o verde mais forte.
   O gradiente aplica o mesmo verde POR CIMA do branco: a célula continua opaca,
   mas fica com a cor da linha. */
.gf-table tr.gf-row-pago td.gf-td-del {
    background-color: #fff;
    background-image: linear-gradient(rgba(34, 197, 94, 0.18), rgba(34, 197, 94, 0.18));
}
.gf-table tr.gf-row-pago:hover td.gf-td-del {
    background-image: linear-gradient(rgba(34, 197, 94, 0.28), rgba(34, 197, 94, 0.28));
}
/* Conteúdo esbatido, fundo não: o opacity vai nas células e não na linha. Posto
   na linha, esbateria também o verde e anulava o ajuste acima. */
.gf-table tr.gf-row-pago td { opacity: 0.525; }
/* A data de pagamento fica de fora do esbatimento: só existe em linhas pagas,
   logo apanharia o desvanecimento todo e nunca se leria a preto. Como o opacity
   está em cada célula, basta repor 1 nesta — de dentro do elemento esbatido não
   seria possível anulá-lo. */
.gf-table tr.gf-row-pago td.gf-td-pagoed { opacity: 1; }

/* Não associadas: sem fundo. O vermelho na linha inteira era ruído — o estado
   já está dito no badge da coluna ASSOCIAÇÃO. A classe continua a ser aplicada
   no JSX, para bastar repor estas duas linhas se um dia se quiser de volta. */
.gf-row-sugerida { background: #fefce8 !important; }
.gf-row-sugerida:hover { background: #fef9c3 !important; }
.gf-btn-associar-ef {
    background: #b45309;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s;
}
.gf-btn-associar-ef:hover { background: #92400e; }
.gf-cell-date { font-size: 12px; font-weight: 600; white-space: nowrap; color: #1e293b; max-width: 80px; }
.gf-cell-time { display: block; font-size: 11px; color: #94a3b8; font-weight: 400; margin-top: 1px; }
/* Única coluna sem largura fixa: absorve todo o espaço que as outras libertam,
   até este limite. Subiu de 200px porque muitos nomes ficavam truncados. */
.gf-fornecedor-cell { max-width: 340px; }
.gf-fornecedor-nome { display: block; font-size: 13px; font-weight: 600; color: #1e293b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.gf-fornecedor-pendente { display: block; font-size: 13px; font-weight: 600; color: #9a3412; white-space: nowrap; }
.gf-nif-tag { display: block; font-size: 11px; color: #64748b; margin-top: 2px; white-space: nowrap; }
.gf-cell-doc { font-size: 13px; font-weight: 700; color: #374151; }
.gf-cell-valor { font-weight: 700; font-size: 13px; white-space: nowrap; }

.gf-em-falta {
    display: inline-block; font-size: 12px; font-weight: 700;
    padding: 2px 7px; border-radius: 10px;
}
.gf-em-falta.parc { background: #ffedd5; color: #9a3412; border: 1px solid #fb923c; }

.gf-td-acoes   { white-space: nowrap; }
.gf-td-pagoed  { white-space: nowrap; }
.gf-td-emfalta { white-space: nowrap; }
.gf-td-del     { width: 24px; text-align: center; padding: 0 6px 0 0; position: sticky; right: 0; background: #fff; }

/* Coluna V. EF — cruzamento entre o encomendado e o faturado.
   Coincide: visto verde discreto. Diverge: o desvio, a vermelho e legível. */
/* 13px — o mesmo da coluna VALOR, para as duas se lerem ao mesmo nível. */
.gf-ef-ok  { color: #16a34a; font-size: 13px; font-weight: 700; }
.gf-ef-dif,
.gf-ef-sug {
    color: #b91c1c;
    font-family: inherit;
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;
}

/* Tabela de faturas: todos os títulos centrados, independentemente do
   alinhamento do conteúdo por baixo. Restringido a esta tabela para não mexer
   nas outras da Gestão Financeira. O seletor tem precedência sobre .tc/.tr. */
.gf-table.gf-table-faturas th {
    text-align: center;
}
.gf-table.gf-table-faturas th .col-filter-wrap {
    justify-content: center;
}

/* Conteúdo centrado nas colunas de data, nº de documento, estados e ações.
   Ficam de fora o FORNECEDOR (texto corrido, lê-se melhor à esquerda) e as
   colunas de montantes, que se mantêm à direita para os valores alinharem
   pela casa decimal. */
.gf-table.gf-table-faturas td.gf-cell-date,
.gf-table.gf-table-faturas td.gf-cell-doc,
.gf-table.gf-table-faturas td.gf-col-tight,
.gf-table.gf-table-faturas td.gf-td-acoes,
.gf-table.gf-table-faturas td.gf-td-pagoed,
.gf-table.gf-table-faturas td.gf-td-emfalta {
    text-align: center;
}

/* Colunas de estado (Doc., Verificação, Digitalização, Associação): encolhem ao
   conteúdo e com pouco respiro lateral, para os badges ficarem juntos. A largura
   que sobra vai para as colunas de texto — fornecedor e nº de documento.
   width:1% + nowrap é a forma de dizer "só o necessário" numa tabela auto. */
.gf-table th.gf-col-tight,
.gf-table td.gf-col-tight {
    width: 1%;
    white-space: nowrap;
    padding-left: 3px;
    padding-right: 3px;
}

/* Checkbox de seleção maior que o tamanho por omissão do browser (~13px): a
   coluna é estreita e o alvo de clique ficava pequeno. */
.gf-table.gf-table-faturas input[type="checkbox"] {
    width: 17px;
    height: 17px;
    cursor: pointer;
    vertical-align: middle;
}

/* Nestas colunas é o TÍTULO que dita a largura, não o conteúdo: "DATA REGISTO"
   ocupa bem mais do que "28/07/2026". Aperta-se tudo o que não é o texto em si —
   espaçamento entre letras, respiro do botão, intervalo até à seta e o tamanho
   da própria seta. */
.gf-table.gf-table-faturas th.gf-col-tight .col-filter-btn {
    padding: 2px 1px;
    gap: 1px;
    letter-spacing: 0;
}
.gf-table.gf-table-faturas th.gf-col-tight .col-filter-arrow {
    font-size: 8px;
}

/* Associação: quem dita a largura desta coluna é o carrossel de EF das linhas
   que têm encomendas (‹ EF-2026-0080 › 1/12), e não o título. O título, ao ficar
   centrado nessa largura, parece afastado da DIGITALIZAÇÃO — por isso o que
   aproxima as colunas é encolher o carrossel, não mexer no espaçamento. */
.gf-table.gf-table-faturas .gf-ef-carousel { gap: 1px; }
.gf-table.gf-table-faturas .gf-ef-carousel-nav {
    width: 14px;
    height: 14px;
    font-size: 11px;
    border-radius: 3px;
}
.gf-table.gf-table-faturas .gf-ef-carousel-count {
    font-size: 9px;
    margin-left: 1px;
}
.gf-table.gf-table-faturas .gf-ef-chips { gap: 2px; }

/* Pills — mesmo padrão dos orçamentos */
.gf-badge {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
}
.badge-green  { background: #d1fae5; color: #065f46; }
.badge-yellow { background: #fef3c7; color: #92400e; }
.gf-badge-clickable { cursor: pointer; }
.gf-badge-clickable:hover { filter: brightness(0.93); }
.badge-orange { background: #ffedd5; color: #9a3412; }
.badge-gray   { background: #f3f4f6; color: #374151; }
.badge-warn   { background: #fff7ed; color: #9a3412; }
.badge-red    { background: #fee2e2; color: #991b1b; }
.badge-blue   { background: #dbeafe; color: #1e40af; }

.btn-pago {
    padding: 3px 10px; border-radius: 12px; font-size: 10px; font-weight: 700;
    text-transform: uppercase; letter-spacing: 0.3px; cursor: pointer;
    border: 1px solid #e2e8f0; background: #f3f4f6; color: #374151; white-space: nowrap;
}
/* Largura fixa igual para todos os estados */
.btn-pago-fixed {
    min-width: 76px;
    text-align: center;
}
.btn-pago.pago      { background: #d1fae5; color: #065f46; border-color: #6ee7b7; }
.btn-pago.nao-pago  { background: #fee2e2; color: #991b1b; border-color: #fca5a5; }
.btn-pago.parc-pago { background: #ffedd5; color: #9a3412; border-color: #fb923c; }
.btn-pago:hover { border-color: #94a3b8; background: #e2e8f0; }
.btn-pago.pago:hover { background: #a7f3d0; }
.btn-pago.nao-pago:hover { background: #fecaca; }
.btn-pago.parc-pago:hover { background: #fed7aa; }

.gf-row-parc-pago { opacity: 0.7; }

.btn-add-pagamento {
    width: 18px; height: 18px; border-radius: 50%;
    font-size: 13px; font-weight: 700; line-height: 1;
    border: 1px solid #fb923c; background: #fff7ed; color: #9a3412;
    cursor: pointer; display: flex; align-items: center; justify-content: center;
    padding: 0; flex-shrink: 0;
}
.btn-add-pagamento:hover { background: #fed7aa; }

/* Barra de pagamento em lote — só aparece quando há faturas selecionadas */
.gf-lote-bar {
    display: flex; align-items: center; gap: 14px; flex-wrap: wrap;
    margin: 0 0 10px; padding: 10px 16px;
    background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px;
}
.gf-lote-count { font-weight: 700; color: #1e40af; font-size: 13px; }
.gf-lote-total { color: #334155; font-size: 13px; margin-right: auto; }

.gf-parc-falta-row {
    display: flex; align-items: center; gap: 8px;
    margin-top: 4px; padding: 8px 10px;
    background: #fff7ed; border: 1px solid #fb923c; border-radius: 6px;
}
.gf-parc-falta-label { font-size: 12px; color: #9a3412; font-weight: 600; }
.gf-parc-falta-val   { font-size: 13px; color: #7c2d12; font-weight: 700; flex: 1 1; }
.gf-parc-falta-badge {
    font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px;
    background: #ffedd5; color: #9a3412; border: 1px solid #fb923c;
    border-radius: 10px; padding: 2px 8px;
}

.gf-pag-historico {
    background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px;
    padding: 10px 12px; margin-bottom: 12px;
}
.gf-pag-historico-title {
    font-size: 11px; font-weight: 700; text-transform: uppercase;
    color: #64748b; letter-spacing: 0.5px; margin-bottom: 8px;
}
.gf-pag-historico-row {
    display: flex; align-items: center; gap: 8px;
    padding: 4px 0; border-bottom: 1px solid #e2e8f0;
    font-size: 13px;
}
.gf-pag-historico-row:last-of-type { border-bottom: none; }
.gf-pag-hist-n { color: #94a3b8; font-size: 11px; min-width: 20px; }
.gf-pag-hist-data { color: #374151; flex: 1 1; }
.gf-pag-hist-valor { font-weight: 700; color: #065f46; }
.gf-pag-historico-total {
    display: flex; align-items: center; gap: 8px;
    margin-top: 8px; padding-top: 8px; border-top: 2px solid #e2e8f0;
    font-size: 12px; font-weight: 700; color: #1e293b;
}
.gf-pag-historico-total span:nth-child(2) { color: #065f46; flex: 1 1; }
.gf-pag-hist-del {
    background: none; border: none; color: #dc2626; cursor: pointer;
    font-size: 14px; font-weight: 700; padding: 0 4px; line-height: 1;
    opacity: 0.5;
}
.gf-pag-hist-del:hover { opacity: 1; }

.gf-pago-cell {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
}
/* Botão pago + data empilhados verticalmente — mantido para compat */
.gf-pago-stack {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
}
.gf-pago-date {
    font-size: 10.5px;
    font-weight: 600;
    color: #1e293b;
    /* translúcido: deixa passar o verde da linha paga em vez de o tapar */
    background: rgba(148, 163, 184, 0.12);
    border: 1px solid rgba(148, 163, 184, 0.25);
    border-radius: 4px;
    padding: 2px 6px;
    line-height: 1.2;
    letter-spacing: 0.2px;
}

.gf-ef-tag-ok {
    background: #d1fae5;
    color: #065f46;
    border-color: #6ee7b7;
}
.gf-ef-tag-clickable {
    cursor: pointer;
    transition: background 0.12s, box-shadow 0.12s;
}
.gf-ef-tag-clickable:hover {
    background: #a7f3d0;
    box-shadow: 0 1px 4px rgba(6,95,70,0.18);
}

.btn-delete-icon {
    background: none; border: none; cursor: pointer;
    font-size: 12px; font-weight: 700; color: #ef4444;
    padding: 2px 5px; border-radius: 4px; line-height: 1;
    opacity: 0.5;
}
.btn-delete-icon:hover { opacity: 1; background: #fee2e2; }

.gf-ef-estado {
    display: inline-block;
    font-size: 10px;
    font-weight: 700;
    margin-left: 5px;
    padding: 1px 5px;
    border-radius: 3px;
    width: fit-content;
}
.ef-estado-pendente { background: #fef9c3; color: #854d0e; }
.ef-estado-enviada  { background: #dbeafe; color: #1e40af; }
.ef-estado-recebida { background: #dcfce7; color: #166534; }
.ef-estado-cancelada{ background: #fee2e2; color: #991b1b; }

.gf-actions { white-space: nowrap; display: flex; gap: 4px; align-items: center; flex-wrap: nowrap; }
/* Linha única: [status] [data pago em] [em falta] [×] */
.gf-actions-row {
    display: flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
    flex-wrap: nowrap;
}
.btn-assoc-ef {
    background: #f0fdf4;
    border: 1px solid #86efac;
    color: #166534;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
}
.btn-assoc-ef:hover { background: #dcfce7; }

.gf-no-result, .gf-empty {
    text-align: center;
    color: #9ca3af;
    padding: 30px;
    font-size: 14px;
}
.gf-loading { text-align: center; padding: 30px; color: #888; }

/* Secção header */
.gf-section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
}
.gf-section-header h3 { margin: 0; font-size: 15px; color: #1a1a2e; }
.gf-count { font-size: 12px; color: #888; }

/* Paginação */
.gf-pagination { display: flex; align-items: center; gap: 10px; margin-top: 12px; justify-content: center; }
.gf-pag-btn { background: #f0f0f0; border: 1px solid #d0d0d0; border-radius: 4px; padding: 4px 12px; font-size: 15px; cursor: pointer; }
.gf-pag-btn:disabled { opacity: 0.35; cursor: default; }
.gf-pag-info { font-size: 13px; color: #555; }

/* Filtros */
.gf-filtros {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
    flex-wrap: wrap;
}
.gf-input-f {
    flex: 1 1; min-width: 180px;
    padding: 7px 10px;
    border: 1px solid #dde1e7;
    border-radius: 6px;
    font-size: 13px;
}
.gf-select {
    padding: 7px 10px;
    border: 1px solid #dde1e7;
    border-radius: 6px;
    font-size: 13px;
    min-width: 140px;
}

/* EF estado badges */
.ef-estado {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    white-space: nowrap;
}
.ef-estado-aguarda    { background: #fef3c7; color: #92400e; }
.ef-estado-associada  { background: #dcfce7; color: #15803d; }

.txt-warn { color: #dc2626; font-weight: 600; }
.gf-fatura-info small { color: #888; margin-left: 5px; font-weight: normal; }

/* Pendentes bulk */
.bulk-pendentes-wrap { margin-top: 18px; border: 1px solid #fed7aa; border-radius: 10px; overflow: hidden; }
.bulk-pendentes-header { display: flex; align-items: center; gap: 10px; padding: 10px 16px; background: #fff7ed; border-bottom: 1px solid #fed7aa; }
.bulk-pendentes-title { font-weight: 700; font-size: 13px; color: #92400e; }
.bulk-pendentes-count { font-size: 12px; color: #b45309; background: #fef3c7; border-radius: 10px; padding: 1px 8px; }

/* Última importação bulk */
.bulk-last-import {
    margin-top: 18px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
}
.bulk-last-import-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    gap: 12px;
}
.bulk-last-import-header > div:first-child {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}
.bulk-last-import-title {
    font-size: 13px;
    font-weight: 700;
    color: #374151;
}
.bulk-last-import-date {
    font-size: 11.5px;
    color: #64748b;
    background: #e2e8f0;
    border-radius: 4px;
    padding: 2px 7px;
}
.bulk-last-import-count {
    font-size: 11px;
    color: #94a3b8;
}
.bulk-last-import-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}
.btn-bulk-undo {
    padding: 5px 12px;
    background: #fff7ed;
    border: 1px solid #fed7aa;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #c2410c;
    cursor: pointer;
    transition: background 0.15s;
}
.btn-bulk-undo:hover { background: #ffedd5; border-color: #fb923c; }
.btn-bulk-dismiss {
    padding: 4px 8px;
    background: none;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    font-size: 13px;
    color: #94a3b8;
    cursor: pointer;
    line-height: 1;
}
.btn-bulk-dismiss:hover { background: #f1f5f9; color: #475569; }

/* Bulk results */
.bulk-results-wrap { margin-top: 18px; }
.bulk-results-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
.bulk-results-header h4 { margin: 0; font-size: 14px; }
.bulk-legend { display: flex; gap: 8px; }
.bulk-leg { padding: 2px 8px; border-radius: 10px; font-size: 11px; font-weight: 700; }
.bulk-leg.matched  { background: #d1fae5; color: #065f46; }
.bulk-leg.warning  { background: #fef3c7; color: #92400e; }
.bulk-leg.new      { background: #ffedd5; color: #9a3412; }
.bulk-leg.duplicate{ background: #fee2e2; color: #991b1b; }
.bulk-leg.manual   { background: #f1f5f9; color: #475569; }

.bulk-row-matched    { background: #f0fdf4; }
.bulk-row-new        { background: #fff7ed; }
.bulk-row-warning    { background: #fefce8; }
.bulk-row-duplicate  { background: #fef2f2; }
.bulk-row-manual     { background: #f8fafc; }
.bulk-row-erro       { background: #fef2f2; }
.bulk-row-pending    { background: #f8fafc; color: #94a3b8; }
.bulk-row-processing { background: #eff6ff; }
.bulk-progress-label { display: flex; align-items: center; gap: 8px; font-weight: 600; color: #1d4ed8; }
.bulk-spinner        { animation: spin 1s linear infinite; display: inline-block; }
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

.bulk-filename { font-size: 12px; color: #475569; max-width: 200px; word-break: break-all; }
.bulk-msg { font-size: 11px; color: #64748b; }
.bulk-atcud-tag { background: #dbeafe; color: #1d4ed8; padding: 2px 6px; border-radius: 4px; font-size: 10px; font-weight: 700; }
.bulk-nif-tag   { background: #f3e8ff; color: #7c3aed; padding: 2px 6px; border-radius: 4px; font-size: 10px; font-weight: 700; }
.bulk-none-tag  { color: #94a3b8; }

.bulk-manual-file { font-size: 12px; color: #64748b; background: #f8fafc; border-radius: 4px; padding: 6px 10px; margin-bottom: 14px; }
.bulk-manual-note { margin-top: 12px; font-size: 12px; color: #64748b; font-style: italic; }

.gf-bulk-list { display: flex; align-items: center; gap: 14px; margin-top: 12px; padding: 10px 14px; background: #f8fafc; border-radius: 6px; }

/* EF fatura tag */
.ef-fatura-tag {
    display: inline-block;
    background: #dcfce7;
    color: #15803d;
    border-radius: 4px;
    padding: 2px 7px;
    font-size: 11px;
    font-weight: 600;
}
.ef-fatura-pendente { color: #94a3b8; font-size: 13px; }

/* Modal EF */
.gf-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 1000;
    display: flex; align-items: center; justify-content: center;
}
.gf-modal {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.18);
    width: 860px; max-width: 95vw;
    display: flex; flex-direction: column;
    max-height: 90vh;
    overflow: hidden;
}
.gf-modal-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 18px 22px 14px;
    border-bottom: 1px solid #e2e8f0;
}
.gf-modal-header h3 { margin: 0; font-size: 16px; color: #1e293b; }
.gf-modal-close {
    background: none; border: none; font-size: 22px; cursor: pointer;
    color: #64748b; line-height: 1; padding: 0 4px;
}
.gf-modal-close:hover { color: #dc2626; }
.gf-modal-body {
    padding: 18px 22px;
    overflow-y: auto;
    flex: 1 1;
}
.gf-modal-info-grid {
    display: grid; grid-template-columns: 1fr 1fr;
    gap: 10px 20px; margin-bottom: 14px;
}
.gf-modal-info-grid > div { display: flex; flex-direction: column; gap: 2px; }
.gf-modal-label { font-size: 11px; color: #64748b; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }
.gf-modal-desc { margin-bottom: 12px; }
.gf-modal-desc p { margin: 4px 0 0; font-size: 13px; color: #334155; line-height: 1.5; }
.gf-modal-sep { border: none; border-top: 1px solid #e2e8f0; margin: 14px 0; }
.gf-modal-section-title { margin: 0 0 12px; font-size: 13px; color: #3182ce; font-weight: 700; }
.gf-modal-fatura-form { display: flex; gap: 14px; flex-wrap: wrap; }
.gf-modal-fatura-form .gf-field { flex: 1 1; min-width: 160px; }
.gf-modal-despesa-status {
    display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
    background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px;
    padding: 8px 12px; margin-top: 10px;
}
.gf-modal-despesa-status .gf-modal-label { margin-right: 4px; }
.gf-save-ok { margin-top: 12px; background: #dcfce7; color: #15803d; border-radius: 6px; padding: 8px 14px; font-size: 13px; font-weight: 600; }
.gf-save-err { margin-top: 12px; background: #fee2e2; color: #991b1b; border-radius: 6px; padding: 8px 14px; font-size: 13px; }
.gf-modal-footer {
    display: flex; gap: 10px; justify-content: flex-end; align-items: stretch;
    padding: 14px 22px;
    border-top: 1px solid #e2e8f0;
    background: #f8fafc;
}
.gf-modal-footer button {
    white-space: nowrap; display: flex; align-items: center; justify-content: center;
}
.gf-modal-btn-desassoc {
    padding: 9px 16px; border-radius: 6px; font-size: 13px; font-weight: 600;
    border: 1px solid #fecaca; background: #fff1f2; color: #dc2626; cursor: pointer;
    margin-right: auto; white-space: nowrap;
}
.gf-modal-btn-desassoc:hover { background: #fee2e2; }
.gf-modal-btn-orc {
    padding: 9px 16px; border-radius: 6px; font-size: 13px; font-weight: 600;
    border: 1px solid #bfdbfe; background: #eff6ff; color: #1d4ed8; cursor: pointer;
}
.gf-modal-btn-orc:hover { background: #dbeafe; }

.gf-status-pending {
    background: #fff7ed;
    color: #c2410c;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 11px;
    border: 1px solid #ffedd5;
    font-weight: 500;
}

.btn-action-s {
    padding: 5px 10px;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 11px;
    color: #475569;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-action-s:hover {
    background: #e2e8f0;
    color: #1e293b;
}

.btn-action-s:hover {
    background: #e2e8f0;
    color: #1e293b;
}

.gf-btn-group {
    display: flex;
    gap: 2px;
    background: #fff;
    padding: 3px;
    border-radius: 8px;
    width: fit-content;
    border: 1px solid #e2e8f0;
}

.gf-btn-s {
    padding: 6px 14px;
    border: none;
    background: transparent;
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
}

/* Filtros de estado de pagamento: largura igual entre si, ditada pelo rótulo
   mais comprido ("Faturas por Pagar"), para o grupo não dançar ao mudar de
   seleção. */
.gf-btn-pag {
    min-width: 150px;
    text-align: center;
    justify-content: center;
}

.gf-btn-s.active {
    background: #3182ce;
    color: #fff;
    box-shadow: 0 2px 4px rgba(49, 130, 206, 0.2);
}

/* Dashboard Mini */
.gf-dashboard-mini {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 14px 20px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.gf-summary-cards {
    display: flex;
    gap: 24px;
    align-items: center;
    /* Em ecrã estreito passam para a linha de baixo em vez de se espremerem. */
    flex-wrap: wrap;
}

.gf-btn-refresh {
    padding: 6px 10px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    transition: background 0.15s;
}
.gf-btn-refresh:hover { background: #f1f5f9; }
.gf-btn-refresh:disabled { opacity: 0.5; cursor: default; }

.gf-card-mini {
    display: flex;
    flex-direction: column;
    /* Valor centrado sob o seu título. Alinhados à direita, o título e o número
       tinham larguras diferentes e só as pontas coincidiam — "TOTAL COMPRA"
       ficava visivelmente desencontrado do "74.831,01 €" por baixo. */
    align-items: center;
    /* O cartão encolhia até ao ponto de partir o valor em duas linhas —
       "23.396,82" numa e o "€" na seguinte. Não encolher abaixo do conteúdo. */
    flex-shrink: 0;
}

.gf-card-label {
    font-size: 10px;
    font-weight: 700;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

.gf-card-val {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    /* Valor e símbolo da moeda são uma coisa só: nunca se separam. */
    white-space: nowrap;
}

/* Date Range Filter Group */
.gf-filter-date-group {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    padding: 0 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    height: 40px;
}

.gf-filter-date-group label {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    margin-right: 4px;
    /* line-height 1 + flex: em maiúsculas não há descendentes, e com a entrelinha
       por omissão o texto assenta no topo da caixa e parece subido face às datas. */
    line-height: 1;
    display: flex;
    align-items: center;
    align-self: stretch;
}

.gf-filter-date-group .orc-input-date {
    border: none !important;
    padding: 0 !important;
    height: auto !important;
    font-size: 13px !important;
    width: 120px !important;
    box-shadow: none !important;
}

.gf-dash {
    color: #cbd5e1;
    font-weight: 400;
}

/* Common quick filter buttons (matching budgets) */
.orc-ano-btn {
    padding: 6px 18px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    color: #64748b;
    background: #fff;
    transition: all 0.15s;
    white-space: nowrap;
    margin-right: 6px;
}

.orc-ano-btn:hover {
    color: #1e293b;
    border-color: #94a3b8;
}

.orc-ano-btn.active {
    background: #3182ce;
    color: #fff;
    border-color: #3182ce;
}

/* Quick Filter Rows */
.gf-quick-filter-container {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.gf-quick-row {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
}

.gf-mode-row {
    background: #f1f5f9;
    padding: 4px;
    border-radius: 10px;
    width: fit-content;
    margin-bottom: 4px;
    border: 1px solid #e2e8f0;
}

.gf-mode-btn-s {
    padding: 6px 20px;
    border: none;
    background: transparent;
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
    border-radius: 7px;
    cursor: pointer;
    transition: all 0.2s;
}

.gf-mode-btn-s.active {
    background: #3182ce;
    color: #fff;
    box-shadow: 0 2px 5px rgba(49, 130, 206, 0.2);
}

.gf-months-grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 5px;
    width: 100%;
}

@media (max-width: 1100px) {
    .gf-months-grid { grid-template-columns: repeat(6, 1fr); }
}
@media (max-width: 600px) {
    .gf-months-grid { grid-template-columns: repeat(4, 1fr); }
}

.gf-month-btn {
    padding: 7px 4px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #fff;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s;
    text-align: center;
    white-space: nowrap;
}

.gf-month-btn:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    color: #1e293b;
}

.gf-month-btn.active {
    background: #3182ce;
    color: #fff;
    border-color: #3182ce;
    box-shadow: 0 2px 4px rgba(49, 130, 206, 0.2);
}




/* Linha clicável na tabela de faturas fornecedor */
.gf-row-clickable {
    cursor: pointer;
}
.gf-row-clickable:hover td {
    background: #eff6ff;
}

/* ── Modal edição de fatura — layout largo 2 colunas ── */
.gef-modal-wide {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.18);
    width: 920px;
    max-width: 97vw;
    max-height: 92vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.gef-modal-body-split {
    display: flex;
    flex: 1 1;
    overflow: hidden;
    min-height: 0;
}

/* Coluna esquerda — preview do documento */
.gef-col-preview {
    width: 46%;
    background: #f8fafc;
    border-right: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    gap: 10px;
    overflow-y: auto;
}

.gef-img-wrap {
    flex: 1 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    min-height: 0;
}

.gef-img-large {
    max-width: 100%;
    max-height: 60vh;
    object-fit: contain;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.gef-pdf-placeholder {
    width: 100%;
    padding: 40px 0;
    text-align: center;
    font-size: 40px;
    color: #94a3b8;
    border: 2px dashed #e2e8f0;
    border-radius: 8px;
    line-height: 1.4;
}

.gef-open-doc-btn {
    width: 100%;
    background: #3182ce;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
}
.gef-open-doc-btn:hover { background: #2563eb; }
.gef-open-doc-btn:disabled { opacity: 0.6; cursor: default; }

.gef-no-doc {
    width: 100%;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #94a3b8;
    font-size: 13px;
}
.gef-no-doc span { font-size: 36px; }

.gef-upload-label, .gef-replace-label {
    display: inline-block;
    padding: 6px 14px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 12px;
    color: #3182ce;
    cursor: pointer;
    transition: background 0.15s;
}
.gef-upload-label:hover, .gef-replace-label:hover { background: #eff6ff; }

.gef-replace-file {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    position: sticky;
    bottom: 0;
    background: #f8fafc;
    padding: 10px 0 2px;
    margin-top: auto;
    z-index: 2;
}

.gef-btn-apagar-doc {
    padding: 6px 12px;
    border: 1px solid #fca5a5;
    border-radius: 6px;
    font-size: 12px;
    color: #dc2626;
    background: #fff;
    cursor: pointer;
    transition: background 0.15s;
}
.gef-btn-apagar-doc:hover { background: #fef2f2; }

.gef-preview-hint {
    text-align: center;
    font-size: 11px;
    color: #3182ce;
    font-weight: 500;
    margin: 4px 0 0;
}

/* Lista de ficheiros pendentes de upload (multi-página) */
.gef-pending-files {
    width: 100%;
    border: 1px solid #c4b5fd;
    background: #f5f3ff;
    border-radius: 6px;
    padding: 8px 10px;
    margin-top: 6px;
    box-sizing: border-box;
}
.gef-pending-header {
    font-size: 11px;
    font-weight: 700;
    color: #6d28d9;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 6px;
}
.gef-pending-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.gef-pending-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px 8px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
    transition: background 0.1s, border-color 0.1s;
}
.gef-pending-item:hover { background: #f8fafc; }
.gef-pending-item.selected {
    background: #eff6ff;
    border-color: #3182ce;
}
.gef-pending-num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #6d28d9;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    flex-shrink: 0;
}
.gef-pending-name {
    flex: 1 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #1e293b;
}
.gef-pending-remove {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fca5a5;
    border-radius: 4px;
    width: 20px;
    height: 20px;
    padding: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    flex-shrink: 0;
}
.gef-pending-remove:hover { background: #fecaca; }

.gef-file-chosen {
    display: block;
    font-size: 11px;
    color: #64748b;
    margin-top: 4px;
    text-align: center;
    word-break: break-all;
}

/* Coluna direita — formulário */
.gef-col-form {
    flex: 1 1;
    padding: 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-height: 0;
}

.gef-row-2 {
    display: flex;
    gap: 10px;
}
.gef-row-2 .gf-field { flex: 1 1; min-width: 0; }

.gef-row-3 {
    display: flex;
    gap: 10px;
}
.gef-row-3 .gf-field { flex: 1 1; min-width: 0; }
.gef-row-3 select {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 13px;
    background: #fff;
    box-sizing: border-box;
}
.gef-col-form .gf-field input,
.gef-col-form .gf-field select {
    width: 100%;
    box-sizing: border-box;
    min-width: 0;
}
.gef-field-readonly {
    background: #f8fafc !important;
    color: #64748b !important;
}

/* Auto-match */
.gef-automatch-box {
    border: 1px solid #f59e0b;
    border-radius: 8px;
    padding: 10px 12px;
    background: #fffbeb;
}
.gef-automatch-title {
    font-size: 12px;
    font-weight: 600;
    color: #92400e;
    margin: 0 0 8px;
}
.gef-btn-fundir-inline {
    display: block;
    width: 100%;
    margin-top: 6px;
    background: #e53e3e;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 12px;
    cursor: pointer;
    transition: background 0.15s;
}
.gef-btn-fundir-inline:hover { background: #c53030; }
.gef-btn-fundir-inline:disabled { opacity: 0.6; cursor: default; }
.gef-btn-desassoc-inline {
    display: block;
    width: 100%;
    margin-top: 6px;
    background: #fff;
    color: #c05621;
    border: 1px solid #c05621;
    border-radius: 4px;
    padding: 5px 10px;
    font-size: 12px;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
}
.gef-btn-desassoc-inline:hover { background: #fff7ed; color: #9a3412; border-color: #9a3412; }

/* Fusão — estilos partilhados */
.gef-fusao-item {
    padding: 8px 12px;
    cursor: pointer;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    margin-top: 4px;
    transition: background 0.1s;
}
.gef-fusao-item:hover { background: #f8fafc; }
.gef-fusao-item.selected { background: #eff6ff; border-color: #3182ce; }
.gef-fusao-nome { display: block; font-size: 13px; font-weight: 600; color: #1e293b; }
.gef-fusao-meta { display: block; font-size: 11px; color: #64748b; margin-top: 2px; }
.gef-fusao-ef { color: #3182ce; font-weight: 600; }

.gef-form-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: auto;
    padding: 12px 0 2px;
    border-top: 1px solid #f1f5f9;
    position: sticky;
    bottom: 0;
    background: #fff;
    z-index: 2;
}

/* Botão ícone de documento na tabela */
button.gf-doc-link {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    padding: 2px 4px;
    border-radius: 4px;
    transition: background 0.15s;
}
button.gf-doc-link:hover { background: #e2e8f0; }

/* Zoom hover na imagem */
.gef-img-zoom-wrap {
    width: 100%;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #fff;
    flex: 1 1;
    min-height: 200px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}
.gef-img-zoom-wrap .gef-img-large {
    border: none;
    border-radius: 0;
    box-shadow: none;
    width: 100%;
    max-height: none;
    display: block;
}
.gef-pdf-wrap {
    width: 100%;
    flex: 1 1;
    min-height: 500px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
    display: flex;
}
.gef-pdf-iframe {
    width: 100%;
    height: 100%;
    min-height: 500px;
    border: none;
    display: block;
}

/* Pesquisa EF */
.gef-ef-search-box {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px 12px;
    background: #f8fafc;
}
.gef-ef-search-label {
    display: block;
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 8px;
}
.gef-ef-input {
    width: 100%;
    padding: 7px 10px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 13px;
    box-sizing: border-box;
    background: #fff;
}
.gef-ef-input:focus { outline: none; border-color: #3182ce; }
.gef-ef-results {
    margin-top: 6px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
    max-height: 200px;
    overflow-y: auto;
}
.gef-ef-item {
    padding: 8px 10px;
    cursor: pointer;
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.1s;
}
.gef-ef-item:last-child { border-bottom: none; }
.gef-ef-item:hover { background: #f8fafc; }
.gef-ef-item.selected { background: #eff6ff; border-left: 3px solid #3182ce; }
.gef-ef-item.gef-ef-item-associada { opacity: 0.7; }
.gef-ef-item.gef-ef-item-associada .gef-ef-num { color: #92400e; }
.gef-ef-num { font-size: 12px; font-weight: 700; color: #3182ce; margin-right: 6px; }
.gef-ef-info { font-size: 12px; color: #475569; }
.gef-ef-proj { color: #64748b; }
.gef-ef-val { font-weight: 600; color: #1e293b; }
.gef-ef-vazio { font-size: 12px; color: #94a3b8; margin: 6px 0 0; text-align: center; }
.gef-ef-atual {
    font-size: 13px;
    color: #16a34a;
    padding: 4px 0;
}

/* Multi-EF picker (nova fatura) */
.gef-pre-ef-box {
    border: 1px solid #bae6fd;
    border-radius: 8px;
    padding: 10px 12px;
    background: #f0f9ff;
    margin-bottom: 10px;
}
.gef-pre-ef-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 6px;
}
.gef-pre-ef-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    background: #fff;
    border: 1px solid #bae6fd;
    border-radius: 6px;
    font-size: 13px;
}

/* Associação M:N — lista de EFs, valor em falta, botão adicionar */
.gef-ef-assoc-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 8px;
}
.gef-ef-assoc-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
}
.gef-ef-assoc-info {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow: hidden;
}
/* Sem ellipsis: o valor da encomenda vem no fim da linha e era o primeiro a
   ser cortado — "EF 271…" em vez de "EF 271.000,00 €", que deixava o valor
   real da EF invisível precisamente no ecrã que o compara. A linha parte-se
   em duas quando não cabe. */
.gef-ef-assoc-info .gef-ef-info {
    white-space: normal;
    overflow-wrap: anywhere;
}
/* Consumo global da EF pelas várias faturas — informativo, não compete com o valor */
.gef-ef-consumo { color: #64748b; font-weight: 400; }
.gef-ef-assoc-aloc {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: #64748b;
}
.gef-ef-assoc-aloc label {
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0.04em;
}
.gef-ef-assoc-aloc input {
    width: 90px;
    padding: 5px 7px;
    border: 1px solid #cbd5e1;
    border-radius: 5px;
    font-size: 13px;
    font-weight: 600;
    text-align: right;
    color: #1e293b;
    background: #fff;
}
.gef-ef-assoc-aloc input:focus { outline: none; border-color: #3182ce; }
.gef-ef-assoc-remove {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fca5a5;
    border-radius: 6px;
    width: 26px;
    height: 26px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    line-height: 1;
}
.gef-ef-assoc-remove:hover:not(:disabled) { background: #fecaca; }
.gef-ef-assoc-remove:disabled { opacity: 0.5; cursor: not-allowed; }

/* Em coluna: o comparativo fatura/EF em cima, a conclusão por baixo. Antes era
   uma linha com os valores espalhados, o que impedia alinhá-los. */
.gef-ef-falta {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 10px 14px;
    border-radius: 6px;
    font-size: 12.5px;
    line-height: 1.45;
    margin-bottom: 8px;
}

/* Grelha das duas linhas de valores. As colunas dos números têm largura
   automática mas partilhada, o que põe os algarismos uns por baixo dos outros
   e torna a diferença visível de relance. */
/* Rótulo à esquerda, números à direita — a mesma régua nos dois blocos, para
   os valores caírem uns por baixo dos outros e se lerem em coluna. */
.gef-ef-comparativo,
.gef-ef-enc-topo,
.gef-ef-enc-linhas {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 3px 12px;
    align-items: baseline;
    font-variant-numeric: tabular-nums;
}
.gef-ef-enc-topo > *:nth-child(even),
.gef-ef-enc-linhas > *:nth-child(even) { text-align: right; white-space: nowrap; }
/* A conta da fatura fica à direita como os outros valores, mas SEM nowrap: é a
   linha mais comprida da caixa e num modal estreito tinha de transbordar para
   não partir. Aqui parte, que é o mal menor. */
.gef-ef-comparativo > *:nth-child(even) { text-align: right; overflow-wrap: anywhere; }
.gef-ef-lbl { font-weight: 600; }
.gef-ef-op { opacity: 0.55; }

/* A encomenda é um bloco à parte, separado por um traço: são factos de outra
   natureza que os da fatura, e sem a divisória liam-se como continuação.
   Traço a preto translúcido — assenta tanto no fundo verde como no âmbar. */
.gef-ef-encomenda {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.10);
}
/* Alinhados à esquerda com "Encomenda", sem indentação: a hierarquia já se lê
   pelo peso do rótulo de cima e pelo corpo mais pequeno destas linhas, e a
   margem só desencontrava o início dos textos. */
.gef-ef-enc-linhas { margin-top: 3px; font-size: 12px; opacity: 0.9; }
/* O que resta por faturar é o número que interessa reter da encomenda. */
.gef-ef-enc-resto { font-weight: 600; }
.gef-ef-enc-linhas em { font-style: normal; font-weight: 400; opacity: 0.75; }
/* Conclusão fora da grelha: se lá estivesse, o comprimento do texto ditava a
   largura das primeiras colunas e afastava o "+" do valor da base. */
.gef-ef-conclusao {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.10);
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}
.gef-ef-conclusao-val { margin-left: 8px; }
.gef-ef-falta-ok { background: #dcfce7; color: #166534; border: 1px solid #86efac; }
.gef-ef-falta-pend { background: #fef3c7; color: #92400e; border: 1px solid #fcd34d; }
.gef-ef-falta strong { font-weight: 700; }

.gef-ef-add-btn {
    width: 100%;
    padding: 8px 12px;
    background: #eff6ff;
    color: #1e40af;
    border: 1px dashed #93c5fd;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}
.gef-ef-add-btn:hover { background: #dbeafe; }
.gef-ef-add-cancel {
    margin-top: 6px;
    padding: 5px 10px;
    background: transparent;
    color: #64748b;
    border: none;
    font-size: 11px;
    cursor: pointer;
    text-decoration: underline;
}


/* ============================================================
   FILTROS DE COLUNA - Para Faturar
   ============================================================ */
.col-filter-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
}
.col-filter-btn {
    background: none;
    border: none;
    padding: 2px 4px;
    cursor: pointer;
    border-radius: 3px;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 10.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #94a3b8;
    transition: color 0.1s, background 0.1s;
}
.col-filter-btn:hover { color: #475569; background: #f1f5f9; }
.col-filter-btn.filtered { color: #3182ce; }
.col-filter-btn.sorted   { color: #7c3aed; }
.col-filter-btn.filtered.sorted { color: #3182ce; }
.col-filter-arrow { font-size: 9px; opacity: 0.7; }
.col-filter-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 500;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.14);
    padding: 8px 0;
    min-width: 180px;
    max-width: 260px;
}
/* Versão fixed — escapa ao overflow:auto do container da tabela */
.col-filter-dropdown-fixed {
    position: fixed !important;
    top: unset;
    left: unset;
    z-index: 2000;
}
.col-filter-footer {
    padding: 6px 10px 2px;
    border-top: 1px solid #f1f5f9;
    margin-top: 4px;
}
.col-filter-clear-btn {
    font-size: 11px; color: #ef4444; background: none; border: none;
    cursor: pointer; padding: 2px 4px; font-weight: 600;
}
.col-filter-clear-btn:hover { text-decoration: underline; }
.col-filter-sort {
    display: flex;
    gap: 4px;
    padding: 4px 10px 8px;
    border-bottom: 1px solid #f1f5f9;
    margin-bottom: 4px;
}
.col-filter-sort-btn {
    flex: 1 1;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    padding: 4px 8px;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.1s;
}
.col-filter-sort-btn:hover { background: #e2e8f0; color: #1e293b; }
.col-filter-sort-btn.active { background: #7c3aed; color: #fff; border-color: #7c3aed; }
.col-filter-search {
    width: calc(100% - 20px);
    margin: 0 10px 6px;
    padding: 5px 8px;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    font-size: 12px;
    outline: none;
    box-sizing: border-box;
}
.col-filter-search:focus { border-color: #3182ce; }
.col-filter-list { max-height: 200px; overflow-y: auto; padding: 2px 0; }
.col-filter-item {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 4px 12px;
    font-size: 12px;
    color: #374151;
    cursor: pointer;
    transition: background 0.1s;
}
.col-filter-item:hover { background: #f0f4ff; }
.col-filter-item input[type="checkbox"] {
    width: 13px; height: 13px; margin: 0;
    cursor: pointer; accent-color: #3182ce;
}

/* Cores margem */
.gf-table .pos { color: #16a34a; font-weight: 600; }
.gf-table .neg { color: #dc2626; font-weight: 600; }
.gf-card-val.pos { color: #16a34a; }
.gf-card-val.neg { color: #dc2626; }

/* Caixa de confirmação de apagar (substitui o window.confirm do browser) */
.gf-conf-box {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.22);
    /* A largura acompanha a frase em vez de a partir em duas linhas. */
    width: max-content; min-width: 380px; max-width: 92vw;
    padding: 26px 32px 20px;
    text-align: center;
}
.gf-conf-titulo {
    color: #dc2626;
    font-weight: 800;
    font-size: 18px;
    letter-spacing: 0.5px;
    margin-bottom: 10px;
}
.gf-conf-texto {
    color: #111827;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 22px;
    white-space: nowrap;
}
.gf-conf-botoes {
    display: flex;
    justify-content: center;
    gap: 10px;
}
.gf-conf-botoes button {
    min-width: 104px;
    padding: 8px 18px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.gf-conf-btn-cancelar {
    border: 1px solid #cbd5e1;
    background: #fff;
    color: #475569;
}
.gf-conf-btn-cancelar:hover { background: #f1f5f9; }
.gf-conf-btn-ok {
    border: 1px solid #dc2626;
    background: #dc2626;
    color: #fff;
}
.gf-conf-btn-ok:hover { background: #b91c1c; border-color: #b91c1c; }

/* ============================================================
   AVISO DE POSSÍVEL DUPLICAÇÃO

   Avisa, não impede: há faturas do mesmo fornecedor com o mesmo número que
   são legítimas — a de várias taxas de IVA lançada em linhas separadas é o
   caso desta casa. Três graus de gravidade, com cores distintas, porque um
   aviso que grita por tudo deixa de ser lido.
   ============================================================ */
.gf-aviso-dup {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin: 12px 0;
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid;
    font-size: 13.5px;
    line-height: 1.5;
}
.gf-aviso-dup.nivel-duplicado { background: #fef2f2; border-color: #fca5a5; color: #991b1b; }
.gf-aviso-dup.nivel-provavel  { background: #fff7ed; border-color: #fdba74; color: #9a3412; }
.gf-aviso-dup.nivel-confirmar { background: #fffbeb; border-color: #fcd34d; color: #92400e; }
.gf-aviso-dup-icone { font-size: 19px; line-height: 1.2; flex-shrink: 0; }
.gf-aviso-dup-texto { flex: 1 1; min-width: 0; }
.gf-aviso-dup-texto strong { display: block; margin-bottom: 2px; }
/* A garantia de que a fatura ficou gravada, em tom menor: é o que evita que o
   aviso seja lido como "não gravou". */
.gf-aviso-dup-nota { margin-top: 6px; font-size: 12.5px; opacity: 0.85; }
.gf-aviso-dup-x {
    flex-shrink: 0;
    background: transparent; border: 0; cursor: pointer;
    font-size: 20px; line-height: 1; color: inherit; opacity: 0.55; padding: 0 2px;
}
.gf-aviso-dup-x:hover { opacity: 1; }

/* ============================================================
   LINHAS DE IVA — faturas com mais do que uma taxa

   Transportes sobretudo: portagens isentas ao lado do serviço a 23%. Só
   aparece quando a fatura o exige; com uma taxa só, o formulário mantém os
   três campos de sempre.
   ============================================================ */
.gf-iva-linhas {
    border: 1px solid #cbd5e1;
    border-radius: 7px;
    padding: 9px 11px;
    background: #f8fafc;
    margin-bottom: 10px;
}
.gf-iva-cab, .gf-iva-linha, .gf-iva-total {
    display: grid;
    grid-template-columns: 96px 1fr 1fr 26px;
    gap: 8px;
    align-items: center;
}
.gf-iva-cab {
    font-size: 10.5px; font-weight: 700; color: #64748b;
    text-transform: uppercase; letter-spacing: .3px; margin-bottom: 4px;
}
.gf-iva-linha { margin-bottom: 5px; }
.gf-iva-linha select, .gf-iva-linha input {
    width: 100%; padding: 5px 7px; font-size: 13px;
    border: 1px solid #cbd5e1; border-radius: 5px; background: #fff;
}
.gf-iva-linha input { text-align: right; font-variant-numeric: tabular-nums; }
/* A soma fecha o bloco: é ela que tem de bater com o total da fatura. */
.gf-iva-total {
    border-top: 1px solid #cbd5e1; padding-top: 6px; margin-top: 2px;
    font-size: 12.5px; font-weight: 700; font-variant-numeric: tabular-nums;
}
.gf-iva-total span:nth-child(2), .gf-iva-total span:nth-child(3) { text-align: right; }
.gf-iva-x {
    background: transparent; border: 0; cursor: pointer;
    font-size: 17px; line-height: 1; color: #94a3b8; padding: 0;
}
.gf-iva-x:hover { color: #b91c1c; }
.gf-iva-mais {
    margin-top: 7px; background: #fff; border: 1px dashed #94a3b8;
    border-radius: 5px; padding: 4px 10px; font-size: 12px;
    color: #475569; cursor: pointer;
}
.gf-iva-mais:hover { background: #eff6ff; border-color: #3182ce; color: #1e40af; }
/* Fora do bloco, quando ainda não há linhas: discreto, para não sugerir que é
   o caminho normal — a esmagadora maioria das faturas tem uma taxa só. */
.gf-iva-mais-solto { margin: -4px 0 10px; font-size: 11.5px; border-style: dotted; }



/* ============================================================
   ESCOLHA DE CLIENTES — Orçamentos Faturados

   Fechada é uma linha só; abre em lista suspensa quando se vai escolher. Ter a
   lista sempre aberta enchia o ecrã de nomes que na maior parte do tempo não
   se está a usar. Escreve no mesmo filtro do cabeçalho da coluna Cliente, por
   isso os dois nunca discordam.
   ============================================================ */
.gf-clientes { position: relative; display: inline-flex; align-items: center; gap: 6px; margin-bottom: 10px; }
.gf-clientes-btn {
    display: inline-flex; align-items: center; gap: 8px;
    background: #fff; border: 1px solid #cbd5e1; border-radius: 7px;
    padding: 6px 12px; font-size: 13px; color: #334155; cursor: pointer;
}
.gf-clientes-btn:hover { border-color: #3182ce; color: #1e40af; }
.gf-clientes-btn.ativo { background: #eff6ff; border-color: #3182ce; color: #1e40af; font-weight: 600; }
.gf-clientes-seta { font-size: 11px; opacity: 0.6; }
.gf-clientes-limpar {
    background: transparent; border: 0; cursor: pointer;
    font-size: 12px; color: #94a3b8; padding: 2px 4px;
}
.gf-clientes-limpar:hover { color: #b91c1c; }
/* Sobreposta à tabela, não a empurrar: abrir a lista não deve mexer no que
   está por baixo. */
.gf-clientes-lista {
    position: absolute; top: calc(100% + 4px); left: 0; z-index: 40;
    width: 340px;
    background: #fff; border: 1px solid #cbd5e1; border-radius: 8px;
    box-shadow: 0 8px 22px rgba(0, 0, 0, .14);
    padding: 8px;
}
.gf-clientes-procura {
    width: 100%; padding: 5px 9px; margin-bottom: 6px; font-size: 12.5px;
    border: 1px solid #cbd5e1; border-radius: 6px;
}
.gf-clientes-procura:focus { outline: none; border-color: #3182ce; box-shadow: 0 0 0 2px #bee3f8; }
.gf-clientes-itens { max-height: 260px; overflow-y: auto; }
.gf-clientes-item {
    display: flex; align-items: center; gap: 8px;
    padding: 4px 6px; border-radius: 5px; cursor: pointer;
    font-size: 12.5px; color: #334155;
}
.gf-clientes-item:hover { background: #f1f5f9; }
.gf-clientes-item.escolhido { background: #eff6ff; color: #1e40af; font-weight: 600; }
.gf-clientes-item input { flex-shrink: 0; cursor: pointer; margin: 0; }
.gf-clientes-nome { flex: 1 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
/* Quantos orçamentos tem cada cliente no período — diz onde está o volume. */
.gf-clientes-n {
    flex-shrink: 0; font-size: 11px; color: #64748b;
    background: #f1f5f9; border-radius: 999px; padding: 1px 7px;
    font-variant-numeric: tabular-nums;
}
.gf-clientes-item.escolhido .gf-clientes-n { background: #dbeafe; color: #1e40af; }
.gf-clientes-vazio { display: block; font-size: 12.5px; color: #94a3b8; padding: 6px 2px; }

/* Coluna Cliente dos Orçamentos Faturados. Reserva-lhe largura própria: a
   tabela dava-lhe o que sobrava e apertava-a contra a coluna do projeto.

   340px sai da medição do texto renderizado, e não da contagem de letras: o
   "GASIB - SOCIEDAD IBÉRICA DE GAS LIQUEFEITO LDA" ocupa 302px e a célula leva
   14px de margem de cada lado, o que dá 330. Com os 310 de antes partia-se em
   duas linhas por 20px.

   (A medição antiga, mantida por história: 95% dos nomes têm até 47 caracteres,
   o que a 12px dá ~296px — e 47 é precisamente o comprimento do "MEO -
   Serviços de Comunicações Eletrónicas, S.A". Cobrir o nome mais comprido que
   existe (81 caracteres, a Acessomatic) exigiria mais de 500px e roubava o
   ecrã às restantes colunas; esses poucos passam a duas linhas, que se leem
   bem.) Mínimo e não fixo, para as outras colunas continuarem a poder crescer. */
.gf-table th.gf-col-cliente, .gf-table td.gf-col-cliente { min-width: 340px; }

/* Margem e Margem % lado a lado, quase encostadas: são o mesmo facto dito de
   duas maneiras e leem-se em conjunto. Com o espaçamento normal da tabela a
   percentagem parecia pertencer à coluna do número de fatura. */
.gf-table th.gf-col-margem, .gf-table td.gf-col-margem { padding-right: 2px; }
.gf-table th.gf-col-margem-pct, .gf-table td.gf-col-margem-pct {
    padding-left: 6px;
    width: 1%;              /* encolhe ao conteúdo em vez de esticar */
    white-space: nowrap;
}

/* ============================================================
   SUGESTÃO DE FORNECEDOR — só em faturas sem QR

   Com QR o nome e o NIF vêm lidos do documento; sem QR (as estrangeiras,
   tipicamente) escreve-se tudo à mão, e é aí que a lista poupa o trabalho e
   evita o NIF mal copiado. Continua a poder escrever-se livremente, para os
   fornecedores que ainda não estão registados.
   ============================================================ */
.gf-forn-campo { position: relative; }
.gf-forn-lista {
    position: absolute; top: 100%; left: 0; right: 0; z-index: 60;
    background: #fff; border: 1px solid #cbd5e1; border-radius: 8px;
    box-shadow: 0 8px 22px rgba(0, 0, 0, .16);
    max-height: 260px; overflow-y: auto; margin-top: 3px;
}
.gf-forn-cab {
    padding: 6px 10px; font-size: 11px; color: #64748b;
    background: #f8fafc; border-bottom: 1px solid #e2e8f0;
    position: sticky; top: 0;
}
.gf-forn-item {
    display: flex; align-items: baseline; gap: 10px; width: 100%;
    padding: 6px 10px; border: 0; background: transparent; cursor: pointer;
    text-align: left; font-size: 12.5px; color: #334155;
    border-bottom: 1px solid #f1f5f9;
}
.gf-forn-item:hover { background: #eff6ff; }
.gf-forn-nome { flex: 1 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
/* O NIF à vista na própria lista: é ele que vai ser preenchido, e ver-se antes
   de escolher evita o clique errado entre nomes parecidos. */
.gf-forn-nif {
    flex-shrink: 0; font-size: 11px; color: #64748b;
    font-family: ui-monospace, monospace;
}

/* ============================================================
   DUPLICAÇÃO — a decisão antes de gravar

   Não é um aviso a posteriori: nada foi gravado quando isto aparece. Fica por
   cima do modal da fatura de propósito, para não haver dúvida de que o gravar
   está suspenso à espera de resposta.
   ============================================================ */
.gf-dup-overlay {
    position: fixed; inset: 0; z-index: 4000;
    display: grid; place-items: center;
    background: rgba(15, 23, 42, .55);
    padding: 20px;
}
.gf-dup-caixa {
    /* A caixa encolhe até ao texto em vez de ter largura fixa: a mediana das
       frases reais dá 464px e o pior caso 709px, portanto uma largura fixa
       deixava metade da caixa vazia quase sempre. O tecto vem do pior caso. */
    width: max-content;
    max-width: min(800px, calc(100vw - 32px));
    background: #fff;
    border: 2px solid #dc2626;
    border-radius: 12px;
    padding: 20px 26px 18px;
    text-align: center;                 /* título e texto ao centro */
    box-shadow: 0 18px 45px rgba(15, 23, 42, .3);
}

.gf-dup-titulo {
    display: flex; align-items: center; justify-content: center; gap: 12px;
    font-size: 1.5rem; font-weight: 800; letter-spacing: .04em;
    color: #b91c1c;
    /* A piscar, com os sinais de sentido proibido de cada lado. */
    animation: gf-dup-piscar 1.1s ease-in-out infinite;
}
.gf-dup-sinal { font-size: 1.5rem; line-height: 1; }
@keyframes gf-dup-piscar {
    0%, 100% { opacity: 1; }
    50%      { opacity: .3; }
}
/* Quem tenha o sistema configurado para reduzir movimento não leva o pisca-pisca. */
@media (prefers-reduced-motion: reduce) {
    .gf-dup-titulo { animation: none; }
}

.gf-dup-texto {
    margin: 14px 0 20px;
    font-size: 1rem; line-height: 1.45; color: #1e293b;
    text-wrap: pretty;              /* se algum dia quebrar, que quebre bem */
}
.gf-dup-texto strong { color: #0f172a; }

.gf-dup-botoes { display: flex; justify-content: center; gap: 10px; }
.gf-dup-btn {
    min-width: 150px; padding: 10px 18px;
    border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;
    border: 1px solid transparent;
}
.gf-dup-apagar { background: #fff; color: #b91c1c; border-color: #fca5a5; }
.gf-dup-apagar:hover { background: #fef2f2; }
.gf-dup-lancar { background: #dc2626; color: #fff; }
.gf-dup-lancar:hover { background: #b91c1c; }
.gf-dup-btn:focus-visible { outline: 2px solid #1d4ed8; outline-offset: 2px; }

/* Keep all five work areas adjacent; list exports remain separate. */
.gf-nav-row .gf-subnav { flex:0 1 auto; justify-content:flex-start; gap:4px; flex-wrap:wrap; overflow:visible; }
.gf-nav-row .gf-subnav-right { margin-left:0; gap:4px; }
.gf-tab-faturar { position:relative; }
.gf-pending-count { display:inline-flex; align-items:center; justify-content:center; min-width:19px; height:19px; padding:0 5px; border-radius:7px; background:#fcf1d8; color:#885a12; border:1px solid #e1bf7b; font-size:10px; font-weight:600; line-height:1; margin-left:7px; box-sizing:border-box; }

.gf-nav-row .gf-subnav { width:auto; }
[data-maquetes-theme="liquido"] .gf-tab-faturar.active { color:#fff !important; }

/* Coluna da associação: todas as etiquetas com a mesma largura (EF e Consumo
   interno), para a coluna não ficar com pastilhas de tamanhos diferentes. */
.gf-td-assoc .gf-ef-tag {
    min-width: 118px;
    text-align: center;
    box-sizing: border-box;
}

/* Associação: etiqueta fixa na segunda coluna; setas e contador têm espaço próprio. */
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout {
    display: grid;
    grid-template-columns: 24px 145px 24px 32px;
    gap: 4px;
    align-items: center;
    width: max-content;
    margin-inline: auto;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout > :not(.gf-ef-carousel) {
    grid-column: 2;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel {
    display: contents;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-tag,
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout > .gf-badge,
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout > .gf-btn-associar-ef {
    grid-column: 2;
    width: 145px;
    min-width: 145px;
    box-sizing: border-box;
    min-height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-nav {
    grid-row: 1;
    grid-column: 1;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-nav ~ .gf-ef-carousel-nav {
    grid-column: 3;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-count {
    position: relative;
    left: 3px;
    grid-row: 1;
    grid-column: 4;
    margin: 0;
    text-align: left;
}

/* Tipografia da etiqueta EF usada em toda a coluna Associação. */
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout :is(.gf-ef-tag, .gf-badge, .gf-btn-associar-ef) {
    font-family: inherit !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    line-height: 1.3 !important;
    letter-spacing: 1px !important;
}

/* Espaço junto à Associação, medido a partir do conteúdo visível. */
html body .app-layout .main-content .gf-table-faturas :is(th, td):has(+ :is(.gf-th-assoc, .gf-td-assoc)) {
    padding-right: 0 !important;
    text-align: center;
}
html body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) {
    padding-left: 0 !important;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout {
    grid-template-columns: 6px 145px 18px 1px;
    column-gap: 0;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-nav {
    width: 18px !important;
    min-width: 18px !important;
    padding: 1px !important;
}

/* Todos os títulos da tabela de faturas com o mesmo tamanho de letra. */
html body .app-layout .main-content table.gf-table-faturas > thead > tr > th,
html body .app-layout .main-content table.gf-table-faturas > thead > tr > th .col-filter-btn {
    font-size: 12px !important;
}

html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-nav:first-child {
    width: 18px !important;
    min-width: 18px !important;
}

/* Mantém o título alinhado com as etiquetas de Associação. */
html body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) .gf-assoc-layout {
    margin-left: -10px;
    margin-right: -20px;
}

/* Margens iguais nas fronteiras Digitalização/Associação e Associação/€/EF. */
html body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) {
    padding-inline: 0 !important;
}
html body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) + :is(th, td) {
    padding-left: 0 !important;
    text-align: center;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-nav:first-child {
    justify-self: end;
}

/* A data de pagamento e o estado têm as mesmas dimensões na tabela. */
html body .app-layout .main-content .gf-table-faturas :is(.gf-td-acoes .btn-pago-fixed, .gf-td-pagoed .gf-pago-date) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 76px;
    min-width: 76px;
    height: 23px;
    min-height: 23px;
    vertical-align: middle;
}

/* Título e retângulos de Digitalização partilham o centro da coluna. */
html body .app-layout .main-content .gf-table-faturas th:has(+ .gf-th-assoc) .col-filter-wrap {
    justify-content: center;
}

/* Valores de €/EF centrados na respetiva coluna. */
html body .app-layout .main-content .gf-table-faturas td.gf-cell-ef-valor {
    text-align: center;
}

/* A seta seguinte usa o desenho da anterior, espelhado. */
.gf-ef-carousel-nav .gf-ef-next-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transform: scaleX(-1);
}

/* Reduz 6 px entre Verificação e Digitalização: 3 px de cada célula. */
html body .app-layout .main-content .gf-table-faturas :is(th, td):has(+ :is(th, td) + :is(.gf-th-assoc, .gf-td-assoc)) {
    padding-right: 0 !important;
}
html body .app-layout .main-content .gf-table-faturas :is(th, td):has(+ :is(.gf-th-assoc, .gf-td-assoc)) {
    padding-left: 0 !important;
}

/* Aproxima mais 11 px a Digitalização da Verificação. */
html body .app-layout .main-content .gf-table-faturas :is(th, td):has(+ :is(th, td) + :is(.gf-th-assoc, .gf-td-assoc)) > :is(.col-filter-wrap, .gf-badge) {
    margin-right: -11px;
}

/* Aproxima €/EF e Ações em 16 px: 6 px de margens internas e 10 px no conteúdo. */
html body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) + :is(th, td) {
    padding-right: 0 !important;
}
html body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) + :is(th, td) + :is(th, td) {
    padding-left: 0 !important;
}
html body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) + :is(th, td) + :is(th, td) > :is(.col-filter-wrap, .btn-pago-fixed) {
    margin-left: -10px;
}

/* Documento da encomenda do cliente em Para Faturar. */
.gf-table .gf-encomenda-cliente { text-align: center; }
.gf-encomenda-controlos { display: flex; align-items: center; justify-content: center; gap: 4px; }
.gf-encomenda-upload { position: relative; display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; cursor: pointer; }
.gf-encomenda-upload input[type=file] { position: absolute; inset: 0; opacity: 0; width: 100%; cursor: pointer; }

.gf-procura-id { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin: 0 0 12px; }
.gf-procura-id label { font-size: 12px; }
.gf-procura-id .gf-inline-input { width: 160px; }

.gf-table.standard-table :is(th, td).gf-numero-fatura-centro { text-align: center; }
.gf-table.standard-table .gf-numero-fatura-centro .col-filter-wrap { justify-content: center; }

/* Campos compactos e ações centradas na linha de Para Faturar. */
html body .app-layout .main-content .gf-table-para-faturar .gf-pf-numero { width: 1%; white-space: nowrap; text-align: center; }
html body .app-layout .main-content .gf-table-para-faturar .gf-pf-numero .gf-inline-input { width: 85px !important; min-width: 85px !important; max-width: 85px !important; box-sizing: border-box; text-align: center; }
html body .app-layout .main-content .gf-table-para-faturar td { vertical-align: middle; }
.gf-pf-acoes-conteudo { display: flex; align-items: center; gap: 4px; white-space: nowrap; }
html body .app-layout .main-content .gf-table .gf-encomenda-controlos .btn-ver-orc,
html body .app-layout .main-content .gf-table-para-faturar .gf-pf-acoes-conteudo :is(.btn-ver-orc, .fr-btn) { display: inline-flex; align-items: center; justify-content: center; height: 32px; min-height: 32px; margin: 0; padding: 3px 10px; box-sizing: border-box; }

/* Visual comum dos controlos, com Rascunho Fatura como referência. */
html body .app-layout .main-content .gf-table :is(.gf-pf-numero .gf-inline-input, .gf-encomenda-controlos .btn-ver-orc, .gf-pf-acoes-conteudo .btn-ver-orc, .gf-pf-acoes-conteudo .fr-btn) {
    height: 32px !important;
    min-height: 32px !important;
    max-height: 32px !important;
    box-sizing: border-box;
    border: 1px solid #bfd6ed !important;
    border-radius: 9px !important;
    background: #f4f9ff !important;
    color: #315c80 !important;
    font: 500 12px 'Segoe UI', sans-serif !important;
    padding: 3px 10px !important;
    box-shadow: none !important;
    letter-spacing: normal;
}
html body .app-layout .main-content .gf-table :is(.gf-pf-numero .gf-inline-input, .gf-encomenda-controlos .btn-ver-orc, .gf-pf-acoes-conteudo .btn-ver-orc, .gf-pf-acoes-conteudo .fr-btn):hover:not(:disabled) {
    background: #e1effc !important;
    border-color: #87b4dd !important;
}
html body .app-layout .main-content .gf-table :is(.gf-pf-numero .gf-inline-input, .gf-encomenda-controlos .btn-ver-orc, .gf-pf-acoes-conteudo .btn-ver-orc, .gf-pf-acoes-conteudo .fr-btn):focus-within {
    outline: 2px solid #327bb4;
    outline-offset: 2px;
}

/* Aproxima a encomenda do cliente das ações da linha. */
html body .app-layout .main-content .gf-table-para-faturar .gf-encomenda-cliente {
    width: 1%;
    white-space: nowrap;
    padding-right: 0 !important;
}
html body .app-layout .main-content .gf-table-para-faturar .gf-pf-acoes {
    width: 1%;
    padding-left: 0 !important;
}

html body .app-layout .main-content .gf-table-para-faturar .gf-pf-acoes-conteudo {
    margin-left: 0;
}

/* Aproxima Nº Fatura e Encomenda Cliente. */
html body .app-layout .main-content .gf-table-para-faturar .gf-pf-numero {
    padding-right: 0 !important;
}
html body .app-layout .main-content .gf-table-para-faturar .gf-encomenda-cliente {
    padding-left: 0 !important;
}

/* Redução adicional de 5 px entre Nº Fatura e Encomenda Cliente. */
html body .app-layout .main-content .gf-table-para-faturar .gf-pf-numero .gf-inline-input {
    margin-right: -5px;
}
html body .app-layout .main-content .gf-table-para-faturar th.gf-pf-numero {
    text-indent: 5px;
}


/* Desloca só o conteúdo, sem sobrepor o fundo da célula ao botão Ver. */
html body .app-layout .main-content .gf-table-para-faturar .gf-encomenda-cliente > :is(.gf-encomenda-titulo, .gf-encomenda-controlos) {
    position: relative;
    left: -4px;
}
.gf-encomenda-titulo { display: inline-block; }

/* Desloca apenas Ver, preservando a posição de Rascunho Fatura. */
html body .app-layout .main-content .gf-table-para-faturar .gf-pf-acoes-conteudo > .btn-ver-orc {
    position: relative;
    left: -8px;
}

/* O título Encomenda Cliente herda a tipografia dos restantes cabeçalhos. */
html body .app-layout .main-content .gf-table th.gf-encomenda-cliente .gf-encomenda-titulo {
    font: inherit !important;
    letter-spacing: inherit !important;
    color: inherit !important;
    text-transform: inherit;
}

/* Em Falta usa o mesmo visual do estado Não Pago. */
html body .app-layout .main-content .gf-table-faturas .gf-td-emfalta .gf-em-falta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 76px;
    min-width: 76px;
    height: 23px;
    min-height: 23px;
    vertical-align: middle;
    font-family: inherit;
    font-size: 10.5px !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
    letter-spacing: .2px;
    padding: 4px 8px !important;
    border: 1px solid #bf627373 !important;
    border-radius: 8px !important;
    background: #d66b7433 !important;
    color: #9c3846 !important;
    box-shadow: none !important;
    white-space: nowrap;
}

/* Estados do editor: retângulos iguais e títulos centrados. */
html body .gf-field.gf-editor-estado { width: 100px; min-width: 100px; align-items: center; }
html body .gf-field.gf-editor-estado > label { display: block; width: 100%; text-align: center; }
html body .gf-field.gf-editor-estado > :is(.gf-badge, .btn-pago, .gf-pago-date, .gf-em-falta) {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100px !important;
    min-width: 100px !important;
    height: 32px !important;
    min-height: 32px !important;
    padding: 0 8px !important;
    line-height: 1.3 !important;
    border-radius: 8px !important;
    text-align: center;
}

/* Valor compacto; espaço adicional reservado a €/EF. */
html body .app-layout .main-content .gf-table-faturas :is(.gf-th-valor, td.gf-cell-valor) {
    width: 1%;
    white-space: nowrap;
    padding-left: 3px !important;
    padding-right: 3px !important;
}
html body .app-layout .main-content .gf-table-faturas :is(th.gf-th-ef-valor, td.gf-cell-ef-valor) {
    min-width: 96px;
    padding-left: 10px !important;
    padding-right: 10px !important;
    text-align: center;
}

/* Retira 6 px entre Doc. e Verificação e reserva-os para €/EF. */
html body .app-layout .main-content .gf-table-faturas :is(th, td):nth-child(7) {
    padding-right: 0 !important;
}
html body .app-layout .main-content .gf-table-faturas :is(th, td):nth-child(8) {
    padding-left: 0 !important;
}

/* Número do documento e valor com tipografia uniforme, incluindo o tema. */
html body .app-layout .main-content .gf-table-faturas :is(td.gf-cell-doc, td.gf-cell-valor),
html body .app-layout .main-content .gf-table-faturas td.gf-cell-valor > span:not(.gf-credit-badge) {
    font-family: inherit !important;
    font-size: 14px !important;
    font-weight: 400 !important;
}

/* Motivos e alternativas da sugestão EF, na ficha da fatura. */
.gf-sugestoes-ef { margin: 10px 0; padding: 12px; background: #f1f7fd; border: 1px solid #bfd6ed; border-radius: 10px; }
.gf-sugestoes-ef p { margin: 7px 0; font-size: 12px; line-height: 1.45; }
.gf-sugestao-card { margin-top: 10px; padding: 10px; border: 1px solid #bfd6ed; border-radius: 8px; background: #fff; }
.gf-sugestoes-ef .gf-sugestao-aviso { color: #9a5513; font-size: 12px; }
.gf-sugestoes-ef ul { padding-left: 18px; margin: 8px 0; font-size: 12px; }
.gf-sugestoes-ef summary { cursor: pointer; font-size: 12px; }
.gf-sugestoes-ef blockquote { margin: 8px 0; padding: 8px; border-left: 3px solid #bfd6ed; font-size: 12px; white-space: pre-wrap; overflow-wrap: anywhere; }
.gf-sugestoes-ef button { margin-top: 8px; padding: 6px 10px; border: 1px solid #87b4dd; border-radius: 8px; color: #315c80; background: #eef6ff; }
.gf-sugestoes-ef button:disabled { opacity: .55; cursor: default; }

/* Aplicar a mesma tipografia ao texto, independentemente da célula/tema. */
html body .app-layout .main-content .gf-table-faturas :is(td.gf-cell-doc, td.gf-cell-valor) > span.gf-numero-texto {
    font-family: "Segoe UI", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    font-style: normal !important;
    line-height: 21px !important;
    letter-spacing: normal !important;
}

/* Coluna DOC.: título e botão deslocados 4 px para a esquerda. */
html body .app-layout .main-content .gf-table-faturas :is(.gf-doc-titulo, .gf-doc-link) {
    position: relative;
    left: -4px;
}
html body .app-layout .main-content .gf-table-faturas .gf-doc-titulo {
    font: inherit !important;
    letter-spacing: inherit;
}

/* Tipografia única dos títulos, com e sem botão de filtro. */
html body .app-layout .main-content table.gf-table-faturas > thead > tr > th,
html body .app-layout .main-content table.gf-table-faturas > thead > tr > th .col-filter-btn,
html body .app-layout .main-content table.gf-table-faturas > thead > tr > th .gf-doc-titulo {
    font-family: "Segoe UI", sans-serif !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    font-style: normal !important;
    line-height: 18px !important;
    letter-spacing: .35px !important;
    text-transform: uppercase;
}

/* Verificação 5 px à esquerda; mais 5 px antes da coluna de apagar. */
html body .app-layout .main-content .gf-table-faturas :is(th, td):nth-child(8) > :is(.col-filter-wrap, .gf-badge) {
    position: relative;
    left: -5px;
}
html body .app-layout .main-content .gf-table-faturas td.gf-td-del,
html body .app-layout .main-content .gf-table-faturas thead th:last-child {
    padding-left: 15px !important;
}



/* Faturas pagas: azul de DOC.; PAGO EM mantém o visual original. */
html body .app-layout .main-content table.gf-table.gf-table-faturas > tbody > tr.gf-row-pago > td:not(.gf-td-pagoed),
html body .app-layout .main-content table.gf-table.gf-table-faturas > tbody > tr.gf-row-pago > td:not(.gf-td-pagoed) :is(span, a, button, div, strong, small) {
    color: #426685 !important;
}

/* Ações das faturas pagas sem transparência, tal como PAGO EM. */
html body .app-layout .main-content table.gf-table.gf-table-faturas > tbody > tr.gf-row-pago > td.gf-td-acoes {
    opacity: 1;
}

/* Lista de documentos da encomenda cliente, partilhada pelos dois separadores. */
.gf-ne-modal { width: min(760px, 94vw); max-height: 85vh; }
.gf-ne-lista { list-style: none; padding: 0; margin: 16px 0; }
.gf-ne-lista li { display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #cbddec; flex-wrap: wrap; }
.gf-ne-nome { flex: 1 1 220px; overflow-wrap: anywhere; }
.gf-ne-acoes { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.gf-ne-modal .gf-modal-body { overflow-y: auto; }
.gf-ne-modal .gf-encomenda-controlos { justify-content: flex-start; }
.gf-ne-modal .btn-ver-orc { min-height: 32px; display: inline-flex; align-items: center; padding: 4px 10px; }

/* Faturados: consulta indisponível quando não existem anexos. */
html body .app-layout .main-content .gf-table .gf-ver-encomenda-faturado:disabled { opacity: 0.5 !important; cursor: not-allowed; }

.gf-ne-modal { width: min(1100px, 96vw); }
.gf-ne-documento { display: block; width: 100%; height: 65vh; border: 0; background: white; margin: 10px 0; }


/* Algarismos das referências EF com o mesmo tamanho das letras. */
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-reference-text { display:inline; white-space:nowrap; }
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-digits { font-size:12px !important; }

/* Associação: centrar cada conjunto de elementos na célula, sem desvios laterais. */
html body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) {
    text-align:center;
    vertical-align:middle;
}
html body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) .gf-assoc-layout {
    display:flex;
    align-items:center;
    justify-content:center;
    gap:3px;
    width:max-content;
    margin-inline:auto;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-count {
    position:static;
    margin:0;
    text-align:center;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .col-filter-wrap {
    justify-content:center;
}

/* Mesma altura das etiquetas de Verificação e Digitalização (23 px). */
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout :is(.gf-ef-tag, .gf-badge, .gf-btn-associar-ef) {
    height:23px;
    min-height:23px;
    padding-block:0 !important;
    box-sizing:border-box;
}

/* Texto centrado nos dois eixos dentro de cada retângulo de Associação. */
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout :is(.gf-ef-tag, .gf-badge, .gf-btn-associar-ef) {
    display:inline-flex !important;
    align-items:center !important;
    justify-content:center !important;
    text-align:center !important;
    padding:0 8px !important;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-reference-text {
    display:block;
    margin:0;
    padding:0;
    font:inherit;
    line-height:inherit;
    text-align:center;
}
html body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-digits {
    font:inherit;
    line-height:inherit;
    vertical-align:baseline;
}

/* Data da fatura de cliente, após o número, nas duas listas financeiras. */
.gf-table.standard-table :is(th, td).gf-data-fatura-cliente { text-align:center; white-space:nowrap; }
.gf-table.standard-table .gf-data-fatura-cliente .col-filter-wrap { justify-content:center; }

.gf-table-para-faturar .gf-data-fatura-cliente input[type="date"] { width:135px; min-width:135px; text-align:center; }

/* Editor: associação de EF num setor próprio, ao lado dos dados. */
html body .gef-modal-wide.gef-modal-associacao {
    width: 1440px; max-width: calc(100vw - 32px); max-height: 94vh;
    margin-inline: auto;
}
html body .gef-modal-associacao .gef-modal-body-split {
    display: grid; grid-template-columns: minmax(0, .95fr) minmax(0, 1.05fr) minmax(0, 1.1fr);
    min-height: 0; overflow: hidden;
}
html body .gef-modal-associacao .gef-col-preview {
    width: auto; min-width: 0; box-sizing: border-box;
}
html body .gef-modal-associacao .gef-col-form {
    min-width: 0; padding: 18px; overflow-y: auto;
}
html body .gef-modal-associacao .gef-col-form > div[style] { flex-wrap: wrap; }
html body .gef-modal-associacao .gef-col-associacao {
    min-width: 0; min-height: 0; padding: 18px;
    overflow-y: auto; border-left: 1px solid #bdd4e680;
    background: #f0f8ff80;
}
html body .gef-modal-associacao .gef-ef-search-box { margin: 0; }
html body .gef-modal-associacao .gef-ef-assoc-row { flex-wrap: wrap; }
html body .gef-modal-associacao .gef-ef-assoc-info { min-width: 0; overflow-wrap: anywhere; }
html body .gef-modal-associacao .gef-associacao-rodape {
    flex-shrink: 0; padding: 10px 18px; border-top: 1px solid #bdd4e680;
}
html body .gef-modal-associacao .gef-form-footer {
    position: static; margin: 0; padding: 0; border: 0; background: transparent;
}
html body .gef-modal-associacao .gf-save-err { margin-bottom: 8px; }
@media (max-width: 1100px) {
    html body .gef-modal-associacao .gef-modal-body-split {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); overflow-y: auto;
    }
    html body .gef-modal-associacao .gef-col-associacao {
        grid-column: 1 / -1; overflow: visible; border-left: 0; border-top: 1px solid #bdd4e680;
    }
    html body .gef-modal-associacao .gef-col-form,
    html body .gef-modal-associacao .gef-col-preview { overflow: visible; }
}
@media (max-width: 700px) {
    html body .gef-modal-wide.gef-modal-associacao { max-width: calc(100vw - 16px); }
    html body .gef-modal-associacao .gef-modal-body-split { display: block; }
    html body .gef-modal-associacao .gef-col-associacao { padding: 16px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/GestaoFinanceira.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAO;AACX;;AAEA,eAAe;AACf;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;AACf;AACA,kBAAkB,aAAa,EAAE,QAAQ,EAAE;AAC3C,mBAAmB,aAAa,EAAE,QAAQ,EAAE;AAC5C,yBAAyB,gBAAgB,EAAE,yBAAyB,EAAE,qCAAqC,EAAE;AAC7G,qCAAqC,yBAAyB,EAAE;;AAEhE,4DAA4D;AAC5D;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,gBAAgB,GAAG,iCAAiC;IACpD,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,4BAA4B;AAChC;AACA,8BAA8B,mBAAmB,EAAE;;AAEnD,oBAAoB;AACpB;IACI,iBAAiB,EAAE,WAAW,EAAE,4BAA4B,EAAE,gBAAgB;IAC9E;;;;;;uDAMmD;IACnD,4BAA4B;IAC5B,aAAa,EAAE,sBAAsB;AACzC;AACA;IACI,aAAa,EAAE,eAAe,EAAE,SAAS;IACzC,mBAAmB,EAAE,gCAAgC,EAAE,mBAAmB;IAC1E,qBAAqB;AACzB;AACA,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrE,aAAa,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAClH,iBAAiB,aAAa,EAAE,QAAQ,EAAE;AAC1C;IACI,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;IACxE,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE,eAAe;IAC/E,qBAAqB;AACzB;AACA,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC3E,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChE;IACI,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe;IAChF,cAAc,EAAE,gBAAgB;AACpC;AACA,wBAAwB,qBAAqB,EAAE,aAAa,EAAE;AAC9D;IACI,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe;IACjF,cAAc,EAAE,gBAAgB,EAAE,gBAAgB;AACtD;AACA,oBAAoB,qBAAqB,EAAE,aAAa,EAAE;;AAE1D;;;8EAG8E;AAC9E,aAAa,kBAAkB,EAAE;AACjC;IACI,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,QAAQ;IAC5E,gBAAgB,EAAE,gBAAgB;IAClC,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB;IAChE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe;IAClE,oBAAoB,EAAE,gBAAgB;AAC1C;AACA,uBAAuB,qBAAqB,EAAE;AAC9C,+BAA+B,0BAA0B,EAAE,mBAAmB,EAAE;AAChF,uBAAuB,qBAAqB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAChF,oBAAoB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpF,kBAAkB,cAAc,EAAE,cAAc,EAAE;;AAElD;IACI,kBAAkB,EAAE,qBAAqB,EAAE,OAAO,EAAE,WAAW;IAC/D,YAAY,EAAE,gBAAgB;IAC9B,yBAAyB,EAAE,kBAAkB;IAC7C,6CAA6C;IAC7C,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjE;AACA;IACI,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB;IAC/D,eAAe,EAAE,cAAc,EAAE,oBAAoB;AACzD;AACA,yBAAyB,qBAAqB,EAAE,aAAa,EAAE;AAC/D,mBAAmB,aAAa,EAAE,QAAQ,EAAE;AAC5C;IACI,SAAO,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe;IAC9D,mBAAmB,EAAE,cAAc,EAAE,yBAAyB;IAC9D,eAAe,EAAE,oBAAoB;AACzC;AACA,gCAAgC,mBAAmB,EAAE;AACrD,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACtF;IACI,aAAa,EAAE,uBAAuB,EAAE,QAAQ;IAChD,gBAAgB,EAAE,kBAAkB,EAAE,eAAe;IACrD,cAAc,EAAE,eAAe,EAAE,iBAAiB;AACtD;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC1E;IACI,SAAS,EAAE,gBAAgB,EAAE,eAAe,EAAE,cAAc;AAChE;AACA,kBAAkB,6BAA6B,EAAE;;AAEjD,gFAAgF;AAChF,oBAAoB,aAAa,EAAE,mBAAmB,EAAE;AACxD,0BAA0B,mBAAmB,EAAE;AAC/C;IACI,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;IACxE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,4BAA4B;IAC7F,oBAAoB;AACxB;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE,mBAAmB,EAAE;;AAEpE;IACI,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe;IAC9D,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,mBAAmB;IAC/E,eAAe,EAAE,cAAc;AACnC;AACA,sBAAsB,cAAc,EAAE;AACtC,aAAa,kBAAkB,EAAE,cAAc,EAAE,aAAa,EAAE;;AAEhE;IACI,iBAAiB;IACjB,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;IACxE,mBAAmB,EAAE,cAAc,EAAE,yBAAyB;IAC9D,eAAe,EAAE,mBAAmB,EAAE,4BAA4B;AACtE;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D,kBAAkB,cAAc,EAAE,SAAO,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AAC1F,aAAa,WAAW,EAAE;AAC1B;IACI,mBAAmB,EAAE,6BAA6B;IAClD,iBAAiB,EAAE,eAAe;AACtC;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,qBAAqB;AACzB;AACA,uBAAuB,cAAc,EAAE,iCAAiC,EAAE;AAC1E,wBAAwB,gBAAgB,EAAE,cAAc,EAAE,qCAAqC,EAAE;;AAEjG;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;AACjB;;AAEA,sBAAsB;;AAEtB;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,sBAAsB,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;;AAE/E;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA,mBAAmB,eAAe,EAAE;;AAEpC;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,YAAY;AAChB;AACA,wBAAwB,2CAA2C,EAAE;;AAErE;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,gBAAgB;AACpB;AACA,4BAA4B,kBAAkB,0BAA0B,EAAE,EAAE;;AAE5E,YAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC7D,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AACpH;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA,wBAAwB,aAAa,EAAE,qBAAqB,EAAE;;AAE9D,cAAc;AACd,WAAW,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC7D;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;AACnB;AACA,sDAAsD,qBAAqB,EAAE,mBAAmB,EAAE;AAClG,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE;AACzG,gBAAgB,eAAe,EAAE;AACjC,wBAAwB,cAAc,EAAE,eAAe,EAAE;AACzD,mBAAmB,cAAc,EAAE,eAAe,EAAE,SAAS,EAAE;;AAE/D,iBAAiB;AACjB;IACI,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,oDAAoD;IACpD,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA,mBAAmB,SAAS,EAAE,cAAc,EAAE;AAC9C;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C,sCAAsC;AACtC;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA,sCAAsC,mBAAmB,EAAE;AAC3D,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D,6EAA6E;AAC7E;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,mBAAmB;AACvB;AACA,qDAAqD;AACrD,0BAA0B,0BAA0B,EAAE,mBAAmB,EAAE;;AAE3E;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA,wBAAwB,mBAAmB,EAAE;AAC7C;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IACvC,0BAA0B;AAC9B;AACA,qBAAqB,cAAc,EAAE;AACrC,2CAA2C,mBAAmB,EAAE;AAChE,2CAA2C,2BAA2B,EAAE;;AAExE;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA,sBAAsB,mBAAmB,EAAE;;AAE3C,SAAS;AACT;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,mBAAmB;AACvB;AACA,gCAAgC,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE;;AAE5E;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,YAAY;AACZ,iBAAiB,cAAc,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;;AAEhF;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;AACA,qBAAqB,mBAAmB,EAAE;AAC1C;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;AACA,eAAe,gBAAgB,EAAE,gCAAgC,EAAE,sBAAsB,EAAE;;AAE3F;;;;;;;kBAOkB;AAClB,oBAAoB,kBAAkB,EAAE;;AAExC,UAAU,2BAA2B,EAAE;AACvC,gBAAgB,eAAe,EAAE;AACjC,qCAAqC,mBAAmB,EAAE;;AAE1D,6BAA6B;AAC7B,mBAAmB,mBAAmB,EAAE;AACxC,yBAAyB,mBAAmB,EAAE;AAC9C,wBAAwB,mBAAmB,EAAE;AAC7C,8BAA8B,mBAAmB,EAAE;;AAEnD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW,EAAE,YAAY;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD;sCACsC;AACtC,aAAa,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACpE;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,8CAA8C;AAClD;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA,aAAa,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAE/F,MAAM,kBAAkB,EAAE;AAC1B,MAAM,iBAAiB,EAAE;AACzB,OAAO,cAAc,EAAE,gBAAgB,EAAE;AACzC,OAAO,cAAc,EAAE,gBAAgB,EAAE;;AAEzC;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA,qBAAqB,mBAAmB,EAAE;;AAE1C;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA,wCAAwC,mBAAmB,EAAE;AAC7D,4BAA4B,YAAY,EAAE,eAAe,EAAE;;AAE3D;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX;6DACyD;IACzD,eAAe;IACf,sBAAsB;AAC1B;AACA;kDACkD;AAClD,sCAAsC,eAAe,EAAE;AACvD;4EAC4E;AAC5E,gCAAgC,gBAAgB,EAAE,gBAAgB,EAAE;AACpE;;;;;uEAKuE;AACvE,6DAA6D,kBAAkB,EAAE;AACjF,mEAAmE,cAAc,EAAE;AACnF,yBAAyB,aAAa,EAAE,qBAAqB,EAAE,6BAA6B,EAAE;;AAE9F,8BAA8B;AAC9B;;;uEAGuE;AACvE;8EAC8E;AAC9E,2BAA2B,8CAA8C,EAAE;AAC3E,iCAAiC,8CAA8C,EAAE;AACjF;;;;;;;;6BAQ6B;AAC7B;IACI,uBAAuB;AAC3B;;AAEA;;;;iCAIiC;AACjC;IACI,sBAAsB;IACtB,mFAAmF;AACvF;AACA;IACI,mFAAmF;AACvF;AACA;iEACiE;AACjE,8BAA8B,cAAc,EAAE;AAC9C;;;6BAG6B;AAC7B,2CAA2C,UAAU,EAAE;;AAEvD;;8EAE8E;AAC9E,mBAAmB,8BAA8B,EAAE;AACnD,yBAAyB,8BAA8B,EAAE;AACzD;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,4BAA4B;AAChC;AACA,4BAA4B,mBAAmB,EAAE;AACjD,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AACzG,gBAAgB,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACpG;2EAC2E;AAC3E,sBAAsB,gBAAgB,EAAE;AACxC,sBAAsB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACzJ,0BAA0B,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAClH,cAAc,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACrG,eAAe,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAClE,iBAAiB,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AAEzE;IACI,qBAAqB,EAAE,eAAe,EAAE,gBAAgB;IACxD,gBAAgB,EAAE,mBAAmB;AACzC;AACA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAEpF,iBAAiB,mBAAmB,EAAE;AACtC,iBAAiB,mBAAmB,EAAE;AACtC,iBAAiB,mBAAmB,EAAE;AACtC,iBAAiB,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;;AAEpH;6EAC6E;AAC7E,0EAA0E;AAC1E,aAAa,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChE;;IAEI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;8EAE8E;AAC9E;IACI,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B;;AAEA;;;uBAGuB;AACvB;;;;;;IAMI,kBAAkB;AACtB;;AAEA;;;6EAG6E;AAC7E;;IAEI,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;yDACyD;AACzD;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;;qBAGqB;AACrB;IACI,gBAAgB;IAChB,QAAQ;IACR,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;;AAEA;;;0EAG0E;AAC1E,6CAA6C,QAAQ,EAAE;AACvD;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA,0CAA0C,QAAQ,EAAE;;AAEpD,wCAAwC;AACxC;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;AACA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,sBAAsB,eAAe,EAAE;AACvC,4BAA4B,wBAAwB,EAAE;AACtD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;;AAErD;IACI,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB;IACzE,yBAAyB,EAAE,qBAAqB,EAAE,eAAe;IACjE,yBAAyB,EAAE,mBAAmB,EAAE,cAAc,EAAE,mBAAmB;AACvF;AACA,6CAA6C;AAC7C;IACI,eAAe;IACf,kBAAkB;AACtB;AACA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAClF,sBAAsB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAClF,sBAAsB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAClF,kBAAkB,qBAAqB,EAAE,mBAAmB,EAAE;AAC9D,uBAAuB,mBAAmB,EAAE;AAC5C,2BAA2B,mBAAmB,EAAE;AAChD,4BAA4B,mBAAmB,EAAE;;AAEjD,oBAAoB,YAAY,EAAE;;AAElC;IACI,WAAW,EAAE,YAAY,EAAE,kBAAkB;IAC7C,eAAe,EAAE,gBAAgB,EAAE,cAAc;IACjD,yBAAyB,EAAE,mBAAmB,EAAE,cAAc;IAC9D,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC5E,UAAU,EAAE,cAAc;AAC9B;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD,2EAA2E;AAC3E;IACI,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe;IAC9D,gBAAgB,EAAE,kBAAkB;IACpC,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB;AACtE;AACA,iBAAiB,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AACpE,iBAAiB,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAEtE;IACI,aAAa,EAAE,mBAAmB,EAAE,QAAQ;IAC5C,eAAe,EAAE,iBAAiB;IAClC,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB;AACtE;AACA,uBAAuB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC1E,uBAAuB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,SAAO,EAAE;AACnF;IACI,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB;IACnF,mBAAmB,EAAE,cAAc,EAAE,yBAAyB;IAC9D,mBAAmB,EAAE,gBAAgB;AACzC;;AAEA;IACI,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB;IAClE,kBAAkB,EAAE,mBAAmB;AAC3C;AACA;IACI,eAAe,EAAE,gBAAgB,EAAE,yBAAyB;IAC5D,cAAc,EAAE,qBAAqB,EAAE,kBAAkB;AAC7D;AACA;IACI,aAAa,EAAE,mBAAmB,EAAE,QAAQ;IAC5C,cAAc,EAAE,gCAAgC;IAChD,eAAe;AACnB;AACA,qCAAqC,mBAAmB,EAAE;AAC1D,iBAAiB,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE;AACnE,oBAAoB,cAAc,EAAE,SAAO,EAAE;AAC7C,qBAAqB,gBAAgB,EAAE,cAAc,EAAE;AACvD;IACI,aAAa,EAAE,mBAAmB,EAAE,QAAQ;IAC5C,eAAe,EAAE,gBAAgB,EAAE,6BAA6B;IAChE,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACrD;AACA,4CAA4C,cAAc,EAAE,SAAO,EAAE;AACrE;IACI,gBAAgB,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe;IAC/D,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,cAAc;IACjE,YAAY;AAChB;AACA,yBAAyB,UAAU,EAAE;;AAErC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;AACA,qEAAqE;AACrE;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sEAAsE;IACtE,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,8CAA8C;AAClD;AACA;IACI,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB,EAAE,YAAY,EAAE,eAAe;IAC/C,eAAe,EAAE,gBAAgB,EAAE,cAAc;IACjD,gBAAgB,EAAE,kBAAkB,EAAE,cAAc;IACpD,YAAY;AAChB;AACA,yBAAyB,UAAU,EAAE,mBAAmB,EAAE;;AAE1D;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;;AAE3D,cAAc,mBAAmB,EAAE,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AACpG,wDAAwD;AACxD;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA,sBAAsB,mBAAmB,EAAE;;AAE3C;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,eAAe;AACnB;AACA,cAAc,kBAAkB,EAAE,aAAa,EAAE,WAAW,EAAE;;AAE9D,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA,wBAAwB,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE;AACpE,YAAY,eAAe,EAAE,WAAW,EAAE;;AAE1C,cAAc;AACd,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC3G,cAAc,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE;AACvI,uBAAuB,aAAa,EAAE,eAAe,EAAE;AACvD,eAAe,eAAe,EAAE,WAAW,EAAE;;AAE7C,YAAY;AACZ;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,SAAO,EAAE,gBAAgB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;AACA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D,YAAY,cAAc,EAAE,gBAAgB,EAAE;AAC9C,wBAAwB,WAAW,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE5E,mBAAmB;AACnB,uBAAuB,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC3G,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE;AACnJ,wBAAwB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AAC3E,wBAAwB,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAErH,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,4BAA4B;AAChC;AACA,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;AACnE;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;;AAE/D,iBAAiB;AACjB,qBAAqB,gBAAgB,EAAE;AACvC,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AAChH,0BAA0B,SAAS,EAAE,eAAe,EAAE;AACtD,eAAe,aAAa,EAAE,QAAQ,EAAE;AACxC,YAAY,gBAAgB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACtF,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvG,uBAAuB,kCAAkC,EAAE,qBAAqB,EAAE;AAClF,kBAAkB,OAAO,uBAAuB,EAAE,EAAE,KAAK,yBAAyB,EAAE,EAAE;;AAEtF,iBAAiB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC3F,YAAY,eAAe,EAAE,cAAc,EAAE;AAC7C,kBAAkB,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChI,kBAAkB,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChI,kBAAkB,cAAc,EAAE;;AAElC,oBAAoB,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AACtI,oBAAoB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAE3F,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAE9I,kBAAkB;AAClB;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA,sBAAsB,cAAc,EAAE,eAAe,EAAE;;AAEvD,aAAa;AACb;IACI,eAAe,EAAE,QAAQ;IACzB,4BAA4B;IAC5B,aAAa;IACb,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AAC/D;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,YAAY,EAAE,eAAe;IAC7B,aAAa,EAAE,sBAAsB;IACrC,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;IAClE,uBAAuB;IACvB,gCAAgC;AACpC;AACA,sBAAsB,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE;AAClE;IACI,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,eAAe;IAChE,cAAc,EAAE,cAAc,EAAE,cAAc;AAClD;AACA,wBAAwB,cAAc,EAAE;AACxC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;AACX;AACA;IACI,aAAa,EAAE,8BAA8B;IAC7C,cAAc,EAAE,mBAAmB;AACvC;AACA,4BAA4B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC7E,kBAAkB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACxH,iBAAiB,mBAAmB,EAAE;AACtC,mBAAmB,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACvF,gBAAgB,YAAY,EAAE,6BAA6B,EAAE,cAAc,EAAE;AAC7E,0BAA0B,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC/F,wBAAwB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AACnE,kCAAkC,SAAO,EAAE,gBAAgB,EAAE;AAC7D;IACI,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe;IAC7D,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB;IAClE,iBAAiB,EAAE,gBAAgB;AACvC;AACA,2CAA2C,iBAAiB,EAAE;AAC9D,cAAc,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/I,eAAe,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC9H;IACI,aAAa,EAAE,SAAS,EAAE,yBAAyB,EAAE,oBAAoB;IACzE,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;AACpF;AACA;IACI,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;IACxE,yBAAyB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe;IAC/E,kBAAkB,EAAE,mBAAmB;AAC3C;AACA,+BAA+B,mBAAmB,EAAE;AACpD;IACI,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;IACxE,yBAAyB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe;AACnF;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;;aAEa;AACb;IACI,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,6CAA6C;AACjD;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,2EAA2E;IAC3E,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;IACd,4BAA4B;AAChC;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,2BAA2B,YAAY,EAAE,eAAe,EAAE;;AAE1D;IACI,aAAa;IACb,sBAAsB;IACtB;;sEAEkE;IAClE,mBAAmB;IACnB;+EAC2E;IAC3E,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iEAAiE;IACjE,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB;oFACgF;IAChF,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,mDAAmD;AACnD;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA,sBAAsB;AACtB;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB,qCAAqC,EAAE;AAC7D;AACA;IACI,kBAAkB,qCAAqC,EAAE;AAC7D;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,6CAA6C;AACjD;;;;;AAKA,mDAAmD;AACnD;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;AAEA,0DAA0D;AAC1D;IACI,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;IACxC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA,2CAA2C;AAC3C;IACI,UAAU;IACV,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,6BAA6B,YAAY,EAAE,eAAe,EAAE;;AAE5D;IACI,WAAW;IACX,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,eAAe;AACnB;AACA,mBAAmB,eAAe,EAAE;;AAEpC;IACI,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,4BAA4B;AAChC;AACA,oDAAoD,mBAAmB,EAAE;;AAEzE;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;AACA,4BAA4B,mBAAmB,EAAE;;AAEjD;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA,0DAA0D;AAC1D;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,8CAA8C;AAClD;AACA,0BAA0B,mBAAmB,EAAE;AAC/C;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA,4BAA4B,mBAAmB,EAAE;;AAEjD;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,gCAAgC;AAChC;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;AACA,uBAAuB,SAAO,EAAE,YAAY,EAAE;;AAE9C;IACI,aAAa;IACb,SAAS;AACb;AACA,uBAAuB,SAAO,EAAE,YAAY,EAAE;AAC9C;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;;IAEI,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,4BAA4B;AAChC;AACA,+BAA+B,mBAAmB,EAAE;AACpD,kCAAkC,YAAY,EAAE,eAAe,EAAE;AACjE;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,yCAAyC;AAC7C;AACA,iCAAiC,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;;AAE7F,gCAAgC;AAChC;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,2BAA2B,mBAAmB,EAAE,qBAAqB,EAAE;AACvE,kBAAkB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrF,kBAAkB,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACpF,gBAAgB,cAAc,EAAE,gBAAgB,EAAE;;AAElD;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA,uCAAuC;AACvC;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD,yBAAyB;AACzB;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;IACP,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,WAAW;IACX,SAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;AACA,sBAAsB,aAAa,EAAE,qBAAqB,EAAE;AAC5D;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,2BAA2B;AAC/B;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,qBAAqB,mBAAmB,EAAE;AAC1C,wBAAwB,mBAAmB,EAAE,8BAA8B,EAAE;AAC7E,qCAAqC,YAAY,EAAE;AACnD,iDAAiD,cAAc,EAAE;AACjE,cAAc,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACpF,eAAe,eAAe,EAAE,cAAc,EAAE;AAChD,eAAe,cAAc,EAAE;AAC/B,cAAc,gBAAgB,EAAE,cAAc,EAAE;AAChD,gBAAgB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACtF;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,mEAAmE;AACnE;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;AACA;;;6BAG6B;AAC7B;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;AACA,qFAAqF;AACrF,kBAAkB,cAAc,EAAE,gBAAgB,EAAE;AACpD;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;AACA,iCAAiC,aAAa,EAAE,qBAAqB,EAAE;AACvE;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA,4CAA4C,mBAAmB,EAAE;AACjE,gCAAgC,YAAY,EAAE,mBAAmB,EAAE;;AAEnE;mEACmE;AACnE;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;4CAE4C;AAC5C;qEACqE;AACrE;;;IAGI,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,qBAAqB;IACrB,kCAAkC;AACtC;AACA;yCACyC,iBAAiB,EAAE,mBAAmB,EAAE;AACjF;;+CAE+C;AAC/C,0CAA0C,iBAAiB,EAAE,uBAAuB,EAAE;AACtF,cAAc,gBAAgB,EAAE;AAChC,aAAa,aAAa,EAAE;;AAE5B;;4EAE4E;AAC5E;IACI,eAAe;IACf,gBAAgB;IAChB,yCAAyC;AAC7C;AACA;;iDAEiD;AACjD,qBAAqB,eAAe,EAAE,eAAe,EAAE,YAAY,EAAE;AACrE,yEAAyE;AACzE,oBAAoB,gBAAgB,EAAE;AACtC,wBAAwB,kBAAkB,EAAE,gBAAgB,EAAE,aAAa,EAAE;AAC7E;qEACqE;AACrE;IACI,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,gBAAgB;IAChB,kCAAkC;AACtC;AACA,wBAAwB,gBAAgB,EAAE;AAC1C,mBAAmB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACnF,qBAAqB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACrF,uBAAuB,gBAAgB,EAAE;;AAEzC;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;AACA,wBAAwB,mBAAmB,EAAE;AAC7C;IACI,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;;AAGA;;iEAEiE;AACjE;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,uCAAuC;AAC3C;AACA,wBAAwB,cAAc,EAAE,mBAAmB,EAAE;AAC7D,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,kCAAkC,cAAc,EAAE;AAClD,oBAAoB,cAAc,EAAE,YAAY,EAAE;AAClD;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;IACvC,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA,kEAAkE;AAClE;IACI,0BAA0B;IAC1B,UAAU;IACV,WAAW;IACX,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,YAAY;IAC/D,eAAe,EAAE,gBAAgB,EAAE,gBAAgB;AACvD;AACA,8BAA8B,0BAA0B,EAAE;AAC1D;IACI,aAAa;IACb,QAAQ;IACR,qBAAqB;IACrB,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,SAAO;IACP,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;AACA,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,8BAA8B,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AACvF;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;AACA,2BAA2B,qBAAqB,EAAE;AAClD,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxE;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;IACf,2BAA2B;AAC/B;AACA,yBAAyB,mBAAmB,EAAE;AAC9C;IACI,WAAW,EAAE,YAAY,EAAE,SAAS;IACpC,eAAe,EAAE,qBAAqB;AAC1C;;AAEA,iBAAiB;AACjB,iBAAiB,cAAc,EAAE,gBAAgB,EAAE;AACnD,iBAAiB,cAAc,EAAE,gBAAgB,EAAE;AACnD,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,cAAc,EAAE;;AAEnC,2EAA2E;AAC3E;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,mEAAmE;IACnE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;IACrD,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;AACA,8BAA8B,mBAAmB,EAAE;AACnD;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;AACA,wBAAwB,mBAAmB,EAAE,qBAAqB,EAAE;;AAEpE;;;;;;;iEAOiE;AACjE;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;AACA,gCAAgC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC5F,gCAAgC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC5F,gCAAgC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC5F,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACzE,sBAAsB,SAAO,EAAE,YAAY,EAAE;AAC7C,6BAA6B,cAAc,EAAE,kBAAkB,EAAE;AACjE;uCACuC;AACvC,qBAAqB,eAAe,EAAE,iBAAiB,EAAE,aAAa,EAAE;AACxE;IACI,cAAc;IACd,uBAAuB,EAAE,SAAS,EAAE,eAAe;IACnD,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE,aAAa,EAAE,cAAc;AAClF;AACA,wBAAwB,UAAU,EAAE;;AAEpC;;;;;;iEAMiE;AACjE;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,wCAAwC;IACxC,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,iBAAiB,EAAE,gBAAgB,EAAE,cAAc;IACnD,yBAAyB,EAAE,oBAAoB,EAAE,kBAAkB;AACvE;AACA,gBAAgB,kBAAkB,EAAE;AACpC;IACI,WAAW,EAAE,gBAAgB,EAAE,eAAe;IAC9C,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB;AACnE;AACA,sBAAsB,iBAAiB,EAAE,kCAAkC,EAAE;AAC7E,wEAAwE;AACxE;IACI,6BAA6B,EAAE,gBAAgB,EAAE,eAAe;IAChE,iBAAiB,EAAE,gBAAgB,EAAE,kCAAkC;AAC3E;AACA,mEAAmE,iBAAiB,EAAE;AACtF;IACI,uBAAuB,EAAE,SAAS,EAAE,eAAe;IACnD,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE,UAAU;AAC/D;AACA,kBAAkB,cAAc,EAAE;AAClC;IACI,eAAe,EAAE,gBAAgB,EAAE,0BAA0B;IAC7D,kBAAkB,EAAE,iBAAiB,EAAE,eAAe;IACtD,cAAc,EAAE,eAAe;AACnC;AACA,qBAAqB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACjF;yEACyE;AACzE,qBAAqB,mBAAmB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE;;;;AAInF;;;;;;;iEAOiE;AACjE,eAAe,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC7G;IACI,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;IACnD,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB;IAC/D,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe;AACvE;AACA,yBAAyB,qBAAqB,EAAE,cAAc,EAAE;AAChE,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACvG,oBAAoB,eAAe,EAAE,YAAY,EAAE;AACnD;IACI,uBAAuB,EAAE,SAAS,EAAE,eAAe;IACnD,eAAe,EAAE,cAAc,EAAE,gBAAgB;AACrD;AACA,4BAA4B,cAAc,EAAE;AAC5C;oBACoB;AACpB;IACI,kBAAkB,EAAE,qBAAqB,EAAE,OAAO,EAAE,WAAW;IAC/D,YAAY;IACZ,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB;IAC/D,yCAAyC;IACzC,YAAY;AAChB;AACA;IACI,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,iBAAiB;IACpE,yBAAyB,EAAE,kBAAkB;AACjD;AACA,6BAA6B,aAAa,EAAE,qBAAqB,EAAE,6BAA6B,EAAE;AAClG,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE;AAC1D;IACI,aAAa,EAAE,mBAAmB,EAAE,QAAQ;IAC5C,gBAAgB,EAAE,kBAAkB,EAAE,eAAe;IACrD,iBAAiB,EAAE,cAAc;AACrC;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,8BAA8B,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACrF,0BAA0B,cAAc,EAAE,eAAe,EAAE,SAAS,EAAE;AACtE,oBAAoB,SAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC3G,6EAA6E;AAC7E;IACI,cAAc,EAAE,eAAe,EAAE,cAAc;IAC/C,mBAAmB,EAAE,oBAAoB,EAAE,gBAAgB;IAC3D,kCAAkC;AACtC;AACA,6CAA6C,mBAAmB,EAAE,cAAc,EAAE;AAClF,qBAAqB,cAAc,EAAE,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAE1F;;;;;;;;;;;;;iFAaiF;AACjF,2DAA2D,gBAAgB,EAAE;;AAE7E;;gEAEgE;AAChE,yDAAyD,kBAAkB,EAAE;AAC7E;IACI,iBAAiB;IACjB,SAAS,eAAe,0CAA0C;IAClE,mBAAmB;AACvB;;AAEA;;;;;;;iEAOiE;AACjE,iBAAiB,kBAAkB,EAAE;AACrC;IACI,kBAAkB,EAAE,SAAS,EAAE,OAAO,EAAE,QAAQ,EAAE,WAAW;IAC7D,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB;IAC/D,yCAAyC;IACzC,iBAAiB,EAAE,gBAAgB,EAAE,eAAe;AACxD;AACA;IACI,iBAAiB,EAAE,eAAe,EAAE,cAAc;IAClD,mBAAmB,EAAE,gCAAgC;IACrD,gBAAgB,EAAE,MAAM;AAC5B;AACA;IACI,aAAa,EAAE,qBAAqB,EAAE,SAAS,EAAE,WAAW;IAC5D,iBAAiB,EAAE,SAAS,EAAE,uBAAuB,EAAE,eAAe;IACtE,gBAAgB,EAAE,iBAAiB,EAAE,cAAc;IACnD,gCAAgC;AACpC;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,gBAAgB,SAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACvG;6DAC6D;AAC7D;IACI,cAAc,EAAE,eAAe,EAAE,cAAc;IAC/C,oCAAoC;AACxC;;AAEA;;;;;;iEAMiE;AACjE;IACI,eAAe,EAAE,QAAQ,EAAE,aAAa;IACxC,aAAa,EAAE,mBAAmB;IAClC,iCAAiC;IACjC,aAAa;AACjB;AACA;IACI;;8EAE0E;IAC1E,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB,kBAAkB,6BAA6B;IACjE,4CAA4C;AAChD;;AAEA;IACI,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAS;IACtE,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB;IAC1D,cAAc;IACd,8DAA8D;IAC9D,kDAAkD;AACtD;AACA,gBAAgB,iBAAiB,EAAE,cAAc,EAAE;AACnD;IACI,WAAW,UAAU,EAAE;IACvB,WAAW,WAAW,EAAE;AAC5B;AACA,oFAAoF;AACpF;IACI,iBAAiB,eAAe,EAAE;AACtC;;AAEA;IACI,mBAAmB;IACnB,eAAe,EAAE,iBAAiB,EAAE,cAAc;IAClD,iBAAiB,eAAe,yCAAyC;AAC7E;AACA,uBAAuB,cAAc,EAAE;;AAEvC,iBAAiB,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE;AACpE;IACI,gBAAgB,EAAE,kBAAkB;IACpC,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe;IACxE,6BAA6B;AACjC;AACA,iBAAiB,gBAAgB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC1E,uBAAuB,mBAAmB,EAAE;AAC5C,iBAAiB,mBAAmB,EAAE,WAAW,EAAE;AACnD,uBAAuB,mBAAmB,EAAE;AAC5C,4BAA4B,0BAA0B,EAAE,mBAAmB,EAAE;;AAE7E,qEAAqE;AACrE,yBAAyB,aAAa,EAAE,0BAA0B,EAAE,OAAO,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC/G,+BAA+B,aAAa,EAAE,OAAO,EAAE;AACvD,kBAAkB,iBAAiB,EAAE;AACrC,oBAAoB,mBAAmB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,cAAc,EAAE,WAAW,EAAE,aAAa,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,aAAa,EAAE,wBAAwB,EAAE,cAAc,EAAE,eAAe,EAAE,aAAa,EAAE,eAAe,EAAE,qBAAqB,EAAE;;AAEzS,yBAAyB,UAAU,EAAE;AACrC,yDAAyD,qBAAqB,EAAE;;AAEhF;4EAC4E;AAC5E;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,sFAAsF;AACtF;IACI,aAAa;IACb,2CAA2C;IAC3C,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;;;IAGI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA,iEAAiE;AACjE;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA,oEAAoE;AACpE;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yCAAyC;IACzC,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA,wEAAwE;AACxE;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA,6DAA6D;AAC7D;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,8EAA8E;AAC9E;IACI,4BAA4B;AAChC;AACA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;;AAEA,sEAAsE;AACtE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,uEAAuE;AACvE;IACI,uBAAuB;AAC3B;;AAEA,mDAAmD;AACnD;IACI,kBAAkB;AACtB;;AAEA,0DAA0D;AAC1D;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA,uEAAuE;AACvE;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;;AAEA,wDAAwD;AACxD;IACI,mBAAmB;AACvB;;AAEA,kFAAkF;AAClF;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,kBAAkB;AACtB;;AAEA,uDAAuD;AACvD,kCAAkC,kBAAkB,EAAE;AACtD,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AACjG,uBAAuB,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACtI,wCAAwC,kBAAkB,EAAE,QAAQ,EAAE,UAAU,EAAE,WAAW,EAAE,eAAe,EAAE;;AAEhH,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAClG,uBAAuB,eAAe,EAAE;AACxC,kCAAkC,YAAY,EAAE;;AAEhD,+DAA+D,kBAAkB,EAAE;AACnF,qEAAqE,uBAAuB,EAAE;;AAE9F,iEAAiE;AACjE,2EAA2E,SAAS,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC/H,4FAA4F,sBAAsB,EAAE,0BAA0B,EAAE,0BAA0B,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AACxN,gEAAgE,sBAAsB,EAAE;AACxF,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC3F;8GAC8G,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE,gBAAgB,EAAE,SAAS,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;;AAExQ,qEAAqE;AACrE;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;IACtB,oCAAoC;IACpC,6BAA6B;IAC7B,8BAA8B;IAC9B,yBAAyB;IACzB,gDAAgD;IAChD,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;AACA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,wDAAwD;AACxD;IACI,SAAS;IACT,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;;AAEA,mEAAmE;AACnE;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;;AAGA,wEAAwE;AACxE;IACI,kBAAkB;IAClB,UAAU;AACd;AACA,uBAAuB,qBAAqB,EAAE;;AAE9C,kEAAkE;AAClE;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA,4EAA4E;AAC5E;IACI,wBAAwB;IACxB,kCAAkC;IAClC,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA,oDAAoD;AACpD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,2BAA2B;IAC3B,sCAAsC;IACtC,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA,8DAA8D;AAC9D,uCAAuC,YAAY,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC5F,+CAA+C,cAAc,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAChG;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA,uDAAuD;AACvD;IACI,SAAS;IACT,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA,iEAAiE;AACjE;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;;AAEA,2EAA2E;AAC3E;;IAEI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,+DAA+D;AAC/D,mBAAmB,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE;AACvH,qBAAqB,aAAa,EAAE,eAAe,EAAE,iBAAiB,EAAE;AACxE,oBAAoB,gBAAgB,EAAE,aAAa,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACtH,sCAAsC,cAAc,EAAE,eAAe,EAAE;AACvE,sBAAsB,kBAAkB,EAAE,aAAa,EAAE,eAAe,EAAE;AAC1E,2BAA2B,eAAe,EAAE,eAAe,EAAE;AAC7D,8BAA8B,aAAa,EAAE,YAAY,EAAE,8BAA8B,EAAE,eAAe,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;AAC5J,0BAA0B,eAAe,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAClJ,mCAAmC,YAAY,EAAE,eAAe,EAAE;;AAElE,2EAA2E;AAC3E;IACI,8CAA8C;IAC9C,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA,iEAAiE;AACjE;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA,6DAA6D;AAC7D;;;IAGI,8CAA8C;IAC9C,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,4BAA4B;IAC5B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA,sEAAsE;AACtE;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;;IAEI,6BAA6B;AACjC;;;;AAIA,mEAAmE;AACnE;;IAEI,yBAAyB;AAC7B;;AAEA,iEAAiE;AACjE;IACI,UAAU;AACd;;AAEA,iFAAiF;AACjF,eAAe,uBAAuB,EAAE,gBAAgB,EAAE;AAC1D,eAAe,gBAAgB,EAAE,UAAU,EAAE,cAAc,EAAE;AAC7D,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,gCAAgC,EAAE,eAAe,EAAE;AACrI,cAAc,eAAe,EAAE,uBAAuB,EAAE;AACxD,eAAe,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC9E,8BAA8B,gBAAgB,EAAE;AAChD,uCAAuC,2BAA2B,EAAE;AACpE,4BAA4B,gBAAgB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AAE5G,gEAAgE;AAChE,oFAAoF,uBAAuB,EAAE,mBAAmB,EAAE;;AAElI,eAAe,wBAAwB,EAAE;AACzC,mBAAmB,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,iBAAiB,EAAE,cAAc,EAAE;;;AAG5G,kEAAkE;AAClE,+FAA+F,cAAc,EAAE,kBAAkB,EAAE;AACnI,uFAAuF,yBAAyB,EAAE;;AAElH,oFAAoF;AACpF;IACI,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,OAAO;IACP,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,QAAQ;IACR,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;;AAEA,uEAAuE;AACvE;IACI,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA,0EAA0E;AAC1E;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,iCAAiC;IACjC,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,2EAA2E;AAC3E,8DAA8D,iBAAiB,EAAE,kBAAkB,EAAE;AACrG,oEAAoE,sBAAsB,EAAE;;AAE5F,oEAAoE,WAAW,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AAErH,mEAAmE;AACnE;IACI,aAAa,EAAE,6BAA6B,EAAE,gBAAgB;IAC9D,mBAAmB;AACvB;AACA;IACI,aAAa,EAAE,0EAA0E;IACzF,aAAa,EAAE,gBAAgB;AACnC;AACA;IACI,WAAW,EAAE,YAAY,EAAE,sBAAsB;AACrD;AACA;IACI,YAAY,EAAE,aAAa,EAAE,gBAAgB;AACjD;AACA,6DAA6D,eAAe,EAAE;AAC9E;IACI,YAAY,EAAE,aAAa,EAAE,aAAa;IAC1C,gBAAgB,EAAE,gCAAgC;IAClD,qBAAqB;AACzB;AACA,qDAAqD,SAAS,EAAE;AAChE,oDAAoD,eAAe,EAAE;AACrE,qDAAqD,YAAY,EAAE,uBAAuB,EAAE;AAC5F;IACI,cAAc,EAAE,kBAAkB,EAAE,+BAA+B;AACvE;AACA;IACI,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,SAAS,EAAE,uBAAuB;AAC/E;AACA,+CAA+C,kBAAkB,EAAE;AACnE;IACI;QACI,oDAAoD,EAAE,gBAAgB;IAC1E;IACA;QACI,mBAAmB,EAAE,iBAAiB,EAAE,cAAc,EAAE,+BAA+B;IAC3F;IACA;uDACmD,iBAAiB,EAAE;AAC1E;AACA;IACI,iDAAiD,6BAA6B,EAAE;IAChF,wDAAwD,cAAc,EAAE;IACxE,sDAAsD,aAAa,EAAE;AACzE","sourcesContent":[".gf-page {\n    background: #f5f6fa;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.gf-body {\n    padding: 24px;\n    flex: 1;\n}\n\n/* Sub-navbar */\n.gf-subnav {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 2px;\n    background: #e2e8f0;\n    border-radius: 8px;\n    padding: 3px;\n    margin-bottom: 20px;\n    width: 100%;\n}\n.gf-subnav-left { display: flex; gap: 2px; }\n.gf-subnav-right { display: flex; gap: 2px; }\n.gf-tab-faturar.active { background: #fff; color: #16a34a !important; box-shadow: 0 1px 4px rgba(0,0,0,0.1); }\n.gf-tab-faturar:not(.active):hover { color: #15803d !important; }\n\n/* Linha que contém o subnav + botão Listagens lado a lado */\n.gf-nav-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n.gf-nav-row .gf-subnav {\n    margin-bottom: 0;  /* margem já está no gf-nav-row */\n    flex-shrink: 0;\n}\n.btn-listagens-action {\n    padding: 8px 18px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 6px;\n    background: #3182ce;\n    color: #fff;\n    border: none;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background 0.15s;\n}\n.btn-listagens-action:hover { background: #2b6cb0; }\n\n/* Modal Listagens */\n.lst-modal {\n    max-width: 1550px; width: 98vw; min-width: min(98vw, 1200px); max-height: 92vh;\n    /* Altura mínima para a caixa dos nomes caber aberta.\n\n       A lista de clientes desce 360px por baixo do botão. Antes de se gerar a\n       listagem a janela tinha 193px de altura e o corpo cortava-a a meio: via-se\n       a caixa de procura e meia dúzia de nomes. Escolher vários assim era\n       impossível. O 92vh de cima continua a mandar em ecrãs baixos, e o \"min(\"\n       impede que a janela fique maior do que o ecrã. */\n    min-height: min(560px, 92vh);\n    display: flex; flex-direction: column;\n}\n.lst-filters {\n    display: flex; flex-wrap: wrap; gap: 14px;\n    padding: 4px 0 14px; border-bottom: 1px solid #f1f5f9; margin-bottom: 14px;\n    align-items: flex-end;\n}\n.lst-filter-group { display: flex; flex-direction: column; gap: 5px; }\n.lst-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; color: #64748b; }\n.lst-btn-group { display: flex; gap: 4px; }\n.lst-btn {\n    padding: 5px 12px; border-radius: 6px; font-size: 12px; font-weight: 500;\n    background: #f8fafc; color: #475569; border: 1px solid #e2e8f0; cursor: pointer;\n    transition: all 0.12s;\n}\n.lst-btn:hover  { background: #f1f5f9; }\n.lst-btn.active { background: #3182ce; color: #fff; border-color: #3182ce; }\n.lst-date-row   { display: flex; align-items: center; gap: 6px; }\n.lst-date-input {\n    padding: 5px 8px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 12px;\n    color: #374151; background: #fff;\n}\n.lst-date-input:focus { border-color: #3b82f6; outline: none; }\n.lst-select {\n    padding: 5px 10px; border: 1px solid #e2e8f0; border-radius: 6px; font-size: 12px;\n    color: #374151; background: #fff; min-width: 200px;\n}\n.lst-select:focus { border-color: #3b82f6; outline: none; }\n\n/* Escolha de vários fornecedores nas listagens.\n   O painel abre por cima do resto dos filtros. Fica com altura limitada e\n   rolamento próprio porque a lista de fornecedores passa de uma centena, e um\n   painel a toda a altura sairia fora da janela do modal, que tem rolamento. */\n.lst-multi { position: relative; }\n.lst-multi-btn {\n    display: flex; align-items: center; justify-content: space-between; gap: 8px;\n    min-width: 240px; max-width: 320px;\n    padding: 5px 10px; border: 1px solid #e2e8f0; border-radius: 6px;\n    font-size: 12px; color: #374151; background: #fff; cursor: pointer;\n    font-family: inherit; text-align: left;\n}\n.lst-multi-btn:hover { border-color: #cbd5e1; }\n.lst-multi-btn:focus-visible { outline: 2px solid #3b82f6; outline-offset: 1px; }\n.lst-multi-btn.ativo { border-color: #3182ce; color: #1e429f; font-weight: 600; }\n.lst-multi-rotulo { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.lst-multi-seta { color: #94a3b8; flex: 0 0 auto; }\n\n.lst-multi-painel {\n    position: absolute; top: calc(100% + 4px); left: 0; z-index: 40;\n    width: 320px; background: #fff;\n    border: 1px solid #e2e8f0; border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);\n    padding: 8px; display: flex; flex-direction: column; gap: 6px;\n}\n.lst-multi-busca {\n    padding: 5px 8px; border: 1px solid #e2e8f0; border-radius: 6px;\n    font-size: 12px; color: #374151; font-family: inherit;\n}\n.lst-multi-busca:focus { border-color: #3b82f6; outline: none; }\n.lst-multi-acoes { display: flex; gap: 6px; }\n.lst-multi-acoes button {\n    flex: 1; padding: 4px 6px; border-radius: 5px; font-size: 11px;\n    background: #f8fafc; color: #475569; border: 1px solid #e2e8f0;\n    cursor: pointer; font-family: inherit;\n}\n.lst-multi-acoes button:hover { background: #f1f5f9; }\n.lst-multi-lista { max-height: 280px; overflow-y: auto; overscroll-behavior: contain; }\n.lst-multi-item {\n    display: flex; align-items: flex-start; gap: 7px;\n    padding: 4px 5px; border-radius: 5px; font-size: 12px;\n    color: #374151; cursor: pointer; line-height: 1.35;\n}\n.lst-multi-item:hover { background: #f8fafc; }\n.lst-multi-item input { margin-top: 2px; flex: 0 0 auto; cursor: pointer; }\n.lst-multi-vazio, .lst-multi-nota {\n    margin: 0; padding: 6px 5px; font-size: 11px; color: #94a3b8;\n}\n.lst-multi-nota { border-top: 1px solid #f1f5f9; }\n\n/* O estado \"Não pagos\" não faz sentido quando se lista por data de pagamento. */\n.lst-btn:disabled { opacity: 0.45; cursor: not-allowed; }\n.lst-btn:disabled:hover { background: #f8fafc; }\n.lst-btn-gerar {\n    padding: 7px 20px; border-radius: 7px; font-size: 13px; font-weight: 600;\n    background: #3182ce; color: #fff; border: none; cursor: pointer; transition: background 0.15s;\n    align-self: flex-end;\n}\n.lst-btn-gerar:hover    { background: #2b6cb0; }\n.lst-btn-gerar:disabled { background: #93c5fd; cursor: not-allowed; }\n\n.lst-summary {\n    display: flex; align-items: center; gap: 20px; flex-wrap: wrap;\n    padding: 8px 12px; background: #f8fafc; border-radius: 8px; margin-bottom: 12px;\n    font-size: 13px; color: #475569;\n}\n.lst-em-falta-total { color: #9a3412; }\n.lst-empty { text-align: center; color: #94a3b8; padding: 24px; }\n\n.lst-btn-excel {\n    margin-left: auto;\n    padding: 8px 12px; border-radius: 6px; font-size: 13px; font-weight: 600;\n    background: #f0fdf4; color: #16a34a; border: 1px solid #16a34a;\n    cursor: pointer; white-space: nowrap; transition: background 0.15s;\n}\n.lst-btn-excel:hover    { background: #dcfce7; }\n.lst-btn-excel:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.lst-table-wrap { overflow: auto; flex: 1; border-radius: 8px; border: 1px solid #e5e7eb; }\n.lst-table { width: 100%; }\n.lst-tfoot td {\n    background: #f8f9fb; border-top: 2px solid #e2e8f0;\n    padding: 8px 10px; font-size: 12px;\n}\n\n.gf-subnav-btn {\n    padding: 8px 20px;\n    border: none;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    color: #64748b;\n    background: transparent;\n    transition: all 0.15s;\n}\n.gf-subnav-btn:hover { color: #1e293b; background: rgba(255,255,255,0.6); }\n.gf-subnav-btn.active { background: #fff; color: #3182ce; box-shadow: 0 1px 4px rgba(0,0,0,0.1); }\n\n.gf-content {\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 1px 8px rgba(0,0,0,0.07);\n    padding: 24px;\n}\n\n/* ---- Scanner ---- */\n\n.gf-modo-tabs {\n    display: flex;\n    gap: 6px;\n    margin-bottom: 20px;\n}\n\n.gf-modo-btn {\n    padding: 7px 16px;\n    border: 1px solid #dde1e7;\n    border-radius: 6px;\n    background: #f8f9fb;\n    color: #555;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.15s;\n}\n.gf-modo-btn:hover { background: #e5e7eb; }\n.gf-modo-btn.active { background: #3182ce; color: #fff; border-color: #3182ce; }\n\n.gf-input-area {\n    background: #f8f9fb;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 24px;\n    margin-bottom: 20px;\n}\n\n/* Pistola mode */\n.gf-pistola {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 0;\n}\n\n.gf-pistola-icon { font-size: 40px; }\n\n.gf-pistola-hint {\n    text-align: center;\n    color: #555;\n    font-size: 14px;\n    line-height: 1.5;\n    margin: 0;\n}\n\n.gf-pistola-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    max-width: 560px;\n}\n\n.gf-atcud-input {\n    flex: 1;\n    padding: 12px 16px;\n    border: 2px solid #3182ce;\n    border-radius: 8px;\n    font-size: 15px;\n    font-family: monospace;\n    text-align: center;\n    background: #fff;\n    outline: none;\n    min-width: 0;\n}\n.gf-atcud-input:focus { box-shadow: 0 0 0 3px rgba(49,130,206,0.15); }\n\n.gf-pistola-tip {\n    font-size: 11px;\n    color: #9ca3af;\n    margin: 0;\n}\n\n.gf-scanner-ef-search {\n    width: 100%;\n    max-width: 560px;\n    margin-top: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.gf-scanner-ef-label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #4a5568;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n/* Manual mode */\n.gf-manual-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 14px;\n    margin-bottom: 0;\n}\n@media (max-width: 700px) { .gf-manual-grid { grid-template-columns: 1fr; } }\n\n.gf-field { display: flex; flex-direction: column; gap: 4px; }\n.gf-field label { font-size: 10px; font-weight: 700; color: #888; text-transform: uppercase; letter-spacing: 0.5px; }\n.gf-field input {\n    padding: 8px 10px;\n    border: 1px solid #dde1e7;\n    border-radius: 5px;\n    font-size: 13px;\n    background: #fff;\n}\n.gf-field input:focus { outline: none; border-color: #3182ce; }\n\n/* Bulk mode */\n.gf-bulk { display: flex; flex-direction: column; gap: 20px; }\n.gf-bulk-dropzone {\n    border: 2px dashed #cbd5e1;\n    border-radius: 12px;\n    background: #fff;\n    padding: 40px;\n    text-align: center;\n    transition: all 0.2s;\n    cursor: pointer;\n}\n.gf-bulk-dropzone:hover, .gf-bulk-dropzone.dragging { border-color: #3182ce; background: #f0f9ff; }\n.gf-bulk-label { display: flex; flex-direction: column; align-items: center; gap: 10px; cursor: pointer; }\n.gf-bulk-icon { font-size: 40px; }\n.gf-bulk-label strong { color: #1e293b; font-size: 15px; }\n.gf-bulk-label p { color: #64748b; font-size: 13px; margin: 0; }\n\n/* Progress Bar */\n.gf-bulk-progress-container {\n    background: #e2e8f0;\n    border-radius: 100px;\n    height: 12px;\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n    margin: 10px 0;\n}\n.gf-bulk-progress-bar {\n    height: 100%;\n    background: linear-gradient(90deg, #3b82f6, #3182ce);\n    transition: width 0.3s ease;\n}\n.gf-bulk-progress-text {\n    display: block;\n    text-align: center;\n    font-size: 12px;\n    font-weight: 600;\n    color: #475569;\n    margin-top: 5px;\n}\n\n.gf-bulk-list {\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.gf-bulk-list h4 { margin: 0; color: #334155; }\n.btn-bulk-process {\n    background: #059669;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    padding: 10px 20px;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n}\n.btn-bulk-process:hover { background: #047857; }\n\n/* Botões de ação (modal/formulário) */\n.gf-actions-form {\n    display: flex;\n    gap: 10px;\n    margin-top: 16px;\n    align-items: center;\n}\n\n.btn-gf-search {\n    background: #3182ce;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    padding: 9px 18px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n.btn-gf-search:hover:not(:disabled) { background: #2b6cb0; }\n.btn-gf-search:disabled { opacity: 0.6; cursor: not-allowed; }\n\n/* Pesquisa das Faturas Fornecedor: botão (modo manual) e interruptor Auto. */\n.gf-search-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    height: 40px;\n    white-space: nowrap;\n}\n/* Texto escrito mas ainda não aplicado à listagem. */\n.gf-search-btn.pendente { outline: 2px solid #f0b429; outline-offset: 2px; }\n\n.gf-search-auto {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    height: 40px;\n    padding: 0 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background: #fff;\n    color: #64748b;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    white-space: nowrap;\n}\n.gf-search-auto:hover { background: #f8fafc; }\n.gf-search-auto-track {\n    position: relative;\n    width: 30px;\n    height: 16px;\n    border-radius: 999px;\n    background: #cbd5e1;\n    transition: background .15s;\n    flex: 0 0 auto;\n}\n.gf-search-auto-thumb {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background: #fff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, .2);\n    transition: transform .15s;\n}\n.gf-search-auto.on { color: #1e3a5f; }\n.gf-search-auto.on .gf-search-auto-track { background: #3182ce; }\n.gf-search-auto.on .gf-search-auto-thumb { transform: translateX(14px); }\n\n.btn-gf-clear {\n    background: #f3f4f6;\n    border: 1px solid #dde1e7;\n    color: #555;\n    border-radius: 6px;\n    padding: 9px 16px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n.btn-gf-clear:hover { background: #e5e7eb; }\n\n/* Erro */\n.gf-erro {\n    background: #fee2e2;\n    color: #dc2626;\n    padding: 10px 14px;\n    border-radius: 6px;\n    font-size: 13px;\n    margin-bottom: 16px;\n}\n\n.gf-info {\n    background: #eff6ff;\n    color: #1d4ed8;\n    border: 1px solid #bfdbfe;\n    padding: 10px 14px;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    margin-bottom: 16px;\n}\n\n/* Info da fatura analisada */\n.gf-fatura-info {\n    display: flex;\n    gap: 20px;\n    flex-wrap: wrap;\n    background: #f0f9ff;\n    border: 1px solid #bae6fd;\n    border-radius: 8px;\n    padding: 12px 16px;\n    font-size: 13px;\n    color: #0c4a6e;\n    margin-bottom: 16px;\n}\n\n/* Resultados */\n.gf-resultados-header-bulk {\n    margin-bottom: 15px;\n}\n.gf-resultados-header-bulk h3 { margin: 0; font-size: 15px; color: #1a1a2e; }\n\n.gf-result-hint {\n    font-size: 12px;\n    color: #64748b;\n    margin: 4px 0 0 0;\n    font-style: italic;\n}\n\n/* Tabelas */\n.gf-table-wrap { overflow: auto; border-radius: 8px; border: 1px solid #e5e7eb; }\n\n.gf-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12px;\n}\n.gf-table thead tr { background: #f8f9fb; }\n.gf-table th {\n    padding: 6px 6px;\n    text-align: left;\n    font-weight: 700;\n    color: #555;\n    border-bottom: 1px solid #e5e7eb;\n    font-size: 10px;\n    text-transform: uppercase;\n    white-space: nowrap;\n}\n.gf-table td { padding: 6px 6px; border-bottom: 1px solid #f3f4f6; vertical-align: middle; }\n\n/* Títulos ao centro. Vai com o \"table.\" à frente de propósito: o App.css tem\n   um \".standard-table th { text-align: left }\" que estas tabelas também\n   apanham, e sem o elemento extra as duas regras empatavam — ganhava a que\n   viesse depois, que é a de lá.\n\n   Só os títulos. O conteúdo das células mantém o alinhamento de cada coluna:\n   texto à esquerda, montantes à direita, que é o que os deixa alinhar pela\n   casa decimal. */\ntable.gf-table th { text-align: center; }\n\n.gf-row { transition: background 0.1s; }\n.gf-row-click { cursor: pointer; }\n.gf-row-click:hover, .gf-row:hover { background: #f8f9fb; }\n\n/* Row colors by match type */\n.gf-row.gf-exato { background: #f0fdf4; }\n.gf-row.gf-exato:hover { background: #dcfce7; }\n.gf-row.gf-aproximado { background: #fffbeb; }\n.gf-row.gf-aproximado:hover { background: #fef3c7; }\n\n.match-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px; height: 22px;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: 900;\n}\n.match-exato  { background: #dcfce7; color: #059669; }\n.match-aproximado { background: #fef3c7; color: #d97706; }\n\n/* O nowrap é preciso: sem ele o \"EF-2026-37236\" parte-se no hífen e a coluna\n   fica com o número em duas linhas. */\n.gf-num    { font-weight: 600; color: #3182ce; white-space: nowrap; }\n.gf-orc-badge {\n    background: #eff6ff;\n    border: 1px solid #bfdbfe;\n    color: #1e40af;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-size: 11px;\n    font-weight: 600;\n    white-space: nowrap;\n    display: inline-block;\n}\n.gf-ef-tag {\n    display: inline-block;\n    background: #ede9fe;\n    color: #6d28d9;\n    border: 1px solid #c4b5fd;\n    padding: 3px 8px;\n    border-radius: 12px;\n    font-weight: 700;\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    white-space: nowrap;\n    cursor: pointer;\n}\n.gf-ef-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    align-items: center;\n}\n.gf-ef-carousel {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n.gf-ef-carousel-nav {\n    background: #f1f5f9;\n    border: 1px solid #cbd5e1;\n    color: #475569;\n    width: 18px;\n    height: 18px;\n    border-radius: 4px;\n    font-size: 14px;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    transition: background 0.1s, border-color 0.1s;\n}\n.gf-ef-carousel-nav:hover {\n    background: #e2e8f0;\n    border-color: #94a3b8;\n    color: #1e293b;\n}\n.gf-ef-carousel-count {\n    font-size: 10px;\n    color: #64748b;\n    font-weight: 600;\n    margin-left: 2px;\n    white-space: nowrap;\n}\n.gf-line-tag {\n    color: #64748b;\n    font-size: 11px;\n}\n.gf-proj   { max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n\n.tc { text-align: center; }\n.tr { text-align: right; }\n.pos { color: #059669; font-weight: 600; }\n.neg { color: #dc2626; font-weight: 600; }\n\n.btn-ver-orc {\n    background: #eff6ff;\n    border: 1px solid #bfdbfe;\n    color: #1e40af;\n    padding: 3px 10px;\n    border-radius: 4px;\n    font-size: 11px;\n    font-weight: 600;\n    cursor: pointer;\n    white-space: nowrap;\n}\n.btn-ver-orc:hover { background: #dbeafe; }\n\n.btn-faturar-row {\n    background: #f0fdf4;\n    border: 1px solid #86efac;\n    color: #15803d;\n    padding: 3px 10px;\n    border-radius: 4px;\n    font-size: 11px;\n    font-weight: 600;\n    cursor: pointer;\n    white-space: nowrap;\n}\n.btn-faturar-row:hover:not(:disabled) { background: #dcfce7; }\n.btn-faturar-row:disabled { opacity: 0.5; cursor: default; }\n\n.gf-inline-input {\n    border: 1px solid #d1d5db;\n    border-radius: 4px;\n    padding: 2px 6px;\n    font-size: 11px;\n    width: 100%;\n    /* 78px chegam para \"FT 2026/001\", que é o formato usado. O espaço que sobra\n       vai para o nome do cliente, que é quem precisa dele. */\n    min-width: 78px;\n    box-sizing: border-box;\n}\n/* O campo do numero: o texto que la vai e sempre curto (FT 2026/001), e a\n   largura a mais so afastava a data do cliente. */\n.gf-inline-input:not([type=\"date\"]) { max-width: 84px; }\n/* A data tem de mostrar \"dd/mm/aaaa\" e o ícone do calendário; abaixo dos 112px\n   o browser come o ano ou o ícone. É o mínimo em que ainda se lê inteira. */\n.gf-inline-input[type=\"date\"] { min-width: 126px; max-width: 132px; }\n/* Campo de data por preencher: sem o \"dd/mm/aaaa\" a fazer de marca de água.\n\n   O texto é desenhado pelo próprio browser — não há placeholder que o tire.\n   Torna-se transparente enquanto estiver vazio e volta a aparecer mal se toque\n   no campo, senão quem lá vai escrever não vê onde vai o dia e onde vai o mês.\n   O ícone do calendário fica, que é o que diz que aquilo é uma data. */\n.gf-inline-input[type=\"date\"].vazia::-webkit-datetime-edit { color: transparent; }\n.gf-inline-input[type=\"date\"].vazia:focus::-webkit-datetime-edit { color: inherit; }\n.gf-inline-input:focus { outline: none; border-color: #6366f1; box-shadow: 0 0 0 2px #e0e7ff; }\n\n/* Tabela Faturas Fornecedor */\n/* Faturas pagas: fundo verde, a par do vermelho das não associadas. Substitui o\n   antigo opacity 0.55 — com a linha esbatida, o verde ficava lavado e não se\n   distinguia. O seletor é mais específico do que .gf-row-pendente de propósito:\n   uma fatura paga mas sem encomenda associada deve ler-se como paga. */\n/* Verde mais escuro, mesma transparência: muda-se a cor de base (green-300 →\n   green-500) e mantém-se o alfa, para o grau de esbatimento não se alterar. */\n.gf-table tr.gf-row-pago { background: rgba(34, 197, 94, 0.18) !important; }\n.gf-table tr.gf-row-pago:hover { background: rgba(34, 197, 94, 0.28) !important; }\n/* As células apanham fundos OPACOS em hover vindos de três regras diferentes:\n   .standard-table tr:hover td (App.css:270, #f8fafc), .gf-row-clickable:hover td\n   (linha ~1415 deste ficheiro, #eff6ff) e a variante do tema \"simple\".\n   Na ordem de pintura das tabelas o fundo da CÉLULA fica por cima do fundo da\n   LINHA, logo tapam o verde — e o !important da regra do verde não lhes chega,\n   porque só arbitra declarações no mesmo elemento, e ali são elementos distintos.\n   Repõe-se transparente com especificidade superior às três. A coluna do × fica\n   de fora: precisa de fundo opaco por ser sticky, e já recebe o verde por\n   gradiente logo a seguir. */\n.gf-table tr.gf-row-pago:hover td:not(.gf-td-del) {\n    background: transparent;\n}\n\n/* A coluna do × é sticky com fundo branco opaco (para o conteúdo lhe passar por\n   baixo ao deslizar a tabela), logo não apanha o verde da linha e destacava-se\n   como um retângulo branco — sobretudo ao passar o rato, com o verde mais forte.\n   O gradiente aplica o mesmo verde POR CIMA do branco: a célula continua opaca,\n   mas fica com a cor da linha. */\n.gf-table tr.gf-row-pago td.gf-td-del {\n    background-color: #fff;\n    background-image: linear-gradient(rgba(34, 197, 94, 0.18), rgba(34, 197, 94, 0.18));\n}\n.gf-table tr.gf-row-pago:hover td.gf-td-del {\n    background-image: linear-gradient(rgba(34, 197, 94, 0.28), rgba(34, 197, 94, 0.28));\n}\n/* Conteúdo esbatido, fundo não: o opacity vai nas células e não na linha. Posto\n   na linha, esbateria também o verde e anulava o ajuste acima. */\n.gf-table tr.gf-row-pago td { opacity: 0.525; }\n/* A data de pagamento fica de fora do esbatimento: só existe em linhas pagas,\n   logo apanharia o desvanecimento todo e nunca se leria a preto. Como o opacity\n   está em cada célula, basta repor 1 nesta — de dentro do elemento esbatido não\n   seria possível anulá-lo. */\n.gf-table tr.gf-row-pago td.gf-td-pagoed { opacity: 1; }\n\n/* Não associadas: sem fundo. O vermelho na linha inteira era ruído — o estado\n   já está dito no badge da coluna ASSOCIAÇÃO. A classe continua a ser aplicada\n   no JSX, para bastar repor estas duas linhas se um dia se quiser de volta. */\n.gf-row-sugerida { background: #fefce8 !important; }\n.gf-row-sugerida:hover { background: #fef9c3 !important; }\n.gf-btn-associar-ef {\n    background: #b45309;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    padding: 4px 10px;\n    font-size: 11px;\n    font-weight: 500;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background 0.15s;\n}\n.gf-btn-associar-ef:hover { background: #92400e; }\n.gf-cell-date { font-size: 12px; font-weight: 600; white-space: nowrap; color: #1e293b; max-width: 80px; }\n.gf-cell-time { display: block; font-size: 11px; color: #94a3b8; font-weight: 400; margin-top: 1px; }\n/* Única coluna sem largura fixa: absorve todo o espaço que as outras libertam,\n   até este limite. Subiu de 200px porque muitos nomes ficavam truncados. */\n.gf-fornecedor-cell { max-width: 340px; }\n.gf-fornecedor-nome { display: block; font-size: 13px; font-weight: 600; color: #1e293b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.gf-fornecedor-pendente { display: block; font-size: 13px; font-weight: 600; color: #9a3412; white-space: nowrap; }\n.gf-nif-tag { display: block; font-size: 11px; color: #64748b; margin-top: 2px; white-space: nowrap; }\n.gf-cell-doc { font-size: 13px; font-weight: 700; color: #374151; }\n.gf-cell-valor { font-weight: 700; font-size: 13px; white-space: nowrap; }\n\n.gf-em-falta {\n    display: inline-block; font-size: 12px; font-weight: 700;\n    padding: 2px 7px; border-radius: 10px;\n}\n.gf-em-falta.parc { background: #ffedd5; color: #9a3412; border: 1px solid #fb923c; }\n\n.gf-td-acoes   { white-space: nowrap; }\n.gf-td-pagoed  { white-space: nowrap; }\n.gf-td-emfalta { white-space: nowrap; }\n.gf-td-del     { width: 24px; text-align: center; padding: 0 6px 0 0; position: sticky; right: 0; background: #fff; }\n\n/* Coluna V. EF — cruzamento entre o encomendado e o faturado.\n   Coincide: visto verde discreto. Diverge: o desvio, a vermelho e legível. */\n/* 13px — o mesmo da coluna VALOR, para as duas se lerem ao mesmo nível. */\n.gf-ef-ok  { color: #16a34a; font-size: 13px; font-weight: 700; }\n.gf-ef-dif,\n.gf-ef-sug {\n    color: #b91c1c;\n    font-family: inherit;\n    font-size: 13px;\n    font-weight: 400;\n    white-space: nowrap;\n}\n\n/* Tabela de faturas: todos os títulos centrados, independentemente do\n   alinhamento do conteúdo por baixo. Restringido a esta tabela para não mexer\n   nas outras da Gestão Financeira. O seletor tem precedência sobre .tc/.tr. */\n.gf-table.gf-table-faturas th {\n    text-align: center;\n}\n.gf-table.gf-table-faturas th .col-filter-wrap {\n    justify-content: center;\n}\n\n/* Conteúdo centrado nas colunas de data, nº de documento, estados e ações.\n   Ficam de fora o FORNECEDOR (texto corrido, lê-se melhor à esquerda) e as\n   colunas de montantes, que se mantêm à direita para os valores alinharem\n   pela casa decimal. */\n.gf-table.gf-table-faturas td.gf-cell-date,\n.gf-table.gf-table-faturas td.gf-cell-doc,\n.gf-table.gf-table-faturas td.gf-col-tight,\n.gf-table.gf-table-faturas td.gf-td-acoes,\n.gf-table.gf-table-faturas td.gf-td-pagoed,\n.gf-table.gf-table-faturas td.gf-td-emfalta {\n    text-align: center;\n}\n\n/* Colunas de estado (Doc., Verificação, Digitalização, Associação): encolhem ao\n   conteúdo e com pouco respiro lateral, para os badges ficarem juntos. A largura\n   que sobra vai para as colunas de texto — fornecedor e nº de documento.\n   width:1% + nowrap é a forma de dizer \"só o necessário\" numa tabela auto. */\n.gf-table th.gf-col-tight,\n.gf-table td.gf-col-tight {\n    width: 1%;\n    white-space: nowrap;\n    padding-left: 3px;\n    padding-right: 3px;\n}\n\n/* Checkbox de seleção maior que o tamanho por omissão do browser (~13px): a\n   coluna é estreita e o alvo de clique ficava pequeno. */\n.gf-table.gf-table-faturas input[type=\"checkbox\"] {\n    width: 17px;\n    height: 17px;\n    cursor: pointer;\n    vertical-align: middle;\n}\n\n/* Nestas colunas é o TÍTULO que dita a largura, não o conteúdo: \"DATA REGISTO\"\n   ocupa bem mais do que \"28/07/2026\". Aperta-se tudo o que não é o texto em si —\n   espaçamento entre letras, respiro do botão, intervalo até à seta e o tamanho\n   da própria seta. */\n.gf-table.gf-table-faturas th.gf-col-tight .col-filter-btn {\n    padding: 2px 1px;\n    gap: 1px;\n    letter-spacing: 0;\n}\n.gf-table.gf-table-faturas th.gf-col-tight .col-filter-arrow {\n    font-size: 8px;\n}\n\n/* Associação: quem dita a largura desta coluna é o carrossel de EF das linhas\n   que têm encomendas (‹ EF-2026-0080 › 1/12), e não o título. O título, ao ficar\n   centrado nessa largura, parece afastado da DIGITALIZAÇÃO — por isso o que\n   aproxima as colunas é encolher o carrossel, não mexer no espaçamento. */\n.gf-table.gf-table-faturas .gf-ef-carousel { gap: 1px; }\n.gf-table.gf-table-faturas .gf-ef-carousel-nav {\n    width: 14px;\n    height: 14px;\n    font-size: 11px;\n    border-radius: 3px;\n}\n.gf-table.gf-table-faturas .gf-ef-carousel-count {\n    font-size: 9px;\n    margin-left: 1px;\n}\n.gf-table.gf-table-faturas .gf-ef-chips { gap: 2px; }\n\n/* Pills — mesmo padrão dos orçamentos */\n.gf-badge {\n    display: inline-block;\n    padding: 3px 8px;\n    border-radius: 12px;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    white-space: nowrap;\n}\n.badge-green  { background: #d1fae5; color: #065f46; }\n.badge-yellow { background: #fef3c7; color: #92400e; }\n.gf-badge-clickable { cursor: pointer; }\n.gf-badge-clickable:hover { filter: brightness(0.93); }\n.badge-orange { background: #ffedd5; color: #9a3412; }\n.badge-gray   { background: #f3f4f6; color: #374151; }\n.badge-warn   { background: #fff7ed; color: #9a3412; }\n.badge-red    { background: #fee2e2; color: #991b1b; }\n.badge-blue   { background: #dbeafe; color: #1e40af; }\n\n.btn-pago {\n    padding: 3px 10px; border-radius: 12px; font-size: 10px; font-weight: 700;\n    text-transform: uppercase; letter-spacing: 0.3px; cursor: pointer;\n    border: 1px solid #e2e8f0; background: #f3f4f6; color: #374151; white-space: nowrap;\n}\n/* Largura fixa igual para todos os estados */\n.btn-pago-fixed {\n    min-width: 76px;\n    text-align: center;\n}\n.btn-pago.pago      { background: #d1fae5; color: #065f46; border-color: #6ee7b7; }\n.btn-pago.nao-pago  { background: #fee2e2; color: #991b1b; border-color: #fca5a5; }\n.btn-pago.parc-pago { background: #ffedd5; color: #9a3412; border-color: #fb923c; }\n.btn-pago:hover { border-color: #94a3b8; background: #e2e8f0; }\n.btn-pago.pago:hover { background: #a7f3d0; }\n.btn-pago.nao-pago:hover { background: #fecaca; }\n.btn-pago.parc-pago:hover { background: #fed7aa; }\n\n.gf-row-parc-pago { opacity: 0.7; }\n\n.btn-add-pagamento {\n    width: 18px; height: 18px; border-radius: 50%;\n    font-size: 13px; font-weight: 700; line-height: 1;\n    border: 1px solid #fb923c; background: #fff7ed; color: #9a3412;\n    cursor: pointer; display: flex; align-items: center; justify-content: center;\n    padding: 0; flex-shrink: 0;\n}\n.btn-add-pagamento:hover { background: #fed7aa; }\n\n/* Barra de pagamento em lote — só aparece quando há faturas selecionadas */\n.gf-lote-bar {\n    display: flex; align-items: center; gap: 14px; flex-wrap: wrap;\n    margin: 0 0 10px; padding: 10px 16px;\n    background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px;\n}\n.gf-lote-count { font-weight: 700; color: #1e40af; font-size: 13px; }\n.gf-lote-total { color: #334155; font-size: 13px; margin-right: auto; }\n\n.gf-parc-falta-row {\n    display: flex; align-items: center; gap: 8px;\n    margin-top: 4px; padding: 8px 10px;\n    background: #fff7ed; border: 1px solid #fb923c; border-radius: 6px;\n}\n.gf-parc-falta-label { font-size: 12px; color: #9a3412; font-weight: 600; }\n.gf-parc-falta-val   { font-size: 13px; color: #7c2d12; font-weight: 700; flex: 1; }\n.gf-parc-falta-badge {\n    font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px;\n    background: #ffedd5; color: #9a3412; border: 1px solid #fb923c;\n    border-radius: 10px; padding: 2px 8px;\n}\n\n.gf-pag-historico {\n    background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px;\n    padding: 10px 12px; margin-bottom: 12px;\n}\n.gf-pag-historico-title {\n    font-size: 11px; font-weight: 700; text-transform: uppercase;\n    color: #64748b; letter-spacing: 0.5px; margin-bottom: 8px;\n}\n.gf-pag-historico-row {\n    display: flex; align-items: center; gap: 8px;\n    padding: 4px 0; border-bottom: 1px solid #e2e8f0;\n    font-size: 13px;\n}\n.gf-pag-historico-row:last-of-type { border-bottom: none; }\n.gf-pag-hist-n { color: #94a3b8; font-size: 11px; min-width: 20px; }\n.gf-pag-hist-data { color: #374151; flex: 1; }\n.gf-pag-hist-valor { font-weight: 700; color: #065f46; }\n.gf-pag-historico-total {\n    display: flex; align-items: center; gap: 8px;\n    margin-top: 8px; padding-top: 8px; border-top: 2px solid #e2e8f0;\n    font-size: 12px; font-weight: 700; color: #1e293b;\n}\n.gf-pag-historico-total span:nth-child(2) { color: #065f46; flex: 1; }\n.gf-pag-hist-del {\n    background: none; border: none; color: #dc2626; cursor: pointer;\n    font-size: 14px; font-weight: 700; padding: 0 4px; line-height: 1;\n    opacity: 0.5;\n}\n.gf-pag-hist-del:hover { opacity: 1; }\n\n.gf-pago-cell {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    white-space: nowrap;\n}\n/* Botão pago + data empilhados verticalmente — mantido para compat */\n.gf-pago-stack {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 3px;\n}\n.gf-pago-date {\n    font-size: 10.5px;\n    font-weight: 600;\n    color: #1e293b;\n    /* translúcido: deixa passar o verde da linha paga em vez de o tapar */\n    background: rgba(148, 163, 184, 0.12);\n    border: 1px solid rgba(148, 163, 184, 0.25);\n    border-radius: 4px;\n    padding: 2px 6px;\n    line-height: 1.2;\n    letter-spacing: 0.2px;\n}\n\n.gf-ef-tag-ok {\n    background: #d1fae5;\n    color: #065f46;\n    border-color: #6ee7b7;\n}\n.gf-ef-tag-clickable {\n    cursor: pointer;\n    transition: background 0.12s, box-shadow 0.12s;\n}\n.gf-ef-tag-clickable:hover {\n    background: #a7f3d0;\n    box-shadow: 0 1px 4px rgba(6,95,70,0.18);\n}\n\n.btn-delete-icon {\n    background: none; border: none; cursor: pointer;\n    font-size: 12px; font-weight: 700; color: #ef4444;\n    padding: 2px 5px; border-radius: 4px; line-height: 1;\n    opacity: 0.5;\n}\n.btn-delete-icon:hover { opacity: 1; background: #fee2e2; }\n\n.gf-ef-estado {\n    display: inline-block;\n    font-size: 10px;\n    font-weight: 700;\n    margin-left: 5px;\n    padding: 1px 5px;\n    border-radius: 3px;\n    width: fit-content;\n}\n.ef-estado-pendente { background: #fef9c3; color: #854d0e; }\n.ef-estado-enviada  { background: #dbeafe; color: #1e40af; }\n.ef-estado-recebida { background: #dcfce7; color: #166534; }\n.ef-estado-cancelada{ background: #fee2e2; color: #991b1b; }\n\n.gf-actions { white-space: nowrap; display: flex; gap: 4px; align-items: center; flex-wrap: nowrap; }\n/* Linha única: [status] [data pago em] [em falta] [×] */\n.gf-actions-row {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    white-space: nowrap;\n    flex-wrap: nowrap;\n}\n.btn-assoc-ef {\n    background: #f0fdf4;\n    border: 1px solid #86efac;\n    color: #166534;\n    padding: 3px 8px;\n    border-radius: 4px;\n    font-size: 11px;\n    font-weight: 600;\n    cursor: pointer;\n    white-space: nowrap;\n}\n.btn-assoc-ef:hover { background: #dcfce7; }\n\n.gf-no-result, .gf-empty {\n    text-align: center;\n    color: #9ca3af;\n    padding: 30px;\n    font-size: 14px;\n}\n.gf-loading { text-align: center; padding: 30px; color: #888; }\n\n/* Secção header */\n.gf-section-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 14px;\n}\n.gf-section-header h3 { margin: 0; font-size: 15px; color: #1a1a2e; }\n.gf-count { font-size: 12px; color: #888; }\n\n/* Paginação */\n.gf-pagination { display: flex; align-items: center; gap: 10px; margin-top: 12px; justify-content: center; }\n.gf-pag-btn { background: #f0f0f0; border: 1px solid #d0d0d0; border-radius: 4px; padding: 4px 12px; font-size: 15px; cursor: pointer; }\n.gf-pag-btn:disabled { opacity: 0.35; cursor: default; }\n.gf-pag-info { font-size: 13px; color: #555; }\n\n/* Filtros */\n.gf-filtros {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 12px;\n    flex-wrap: wrap;\n}\n.gf-input-f {\n    flex: 1; min-width: 180px;\n    padding: 7px 10px;\n    border: 1px solid #dde1e7;\n    border-radius: 6px;\n    font-size: 13px;\n}\n.gf-select {\n    padding: 7px 10px;\n    border: 1px solid #dde1e7;\n    border-radius: 6px;\n    font-size: 13px;\n    min-width: 140px;\n}\n\n/* EF estado badges */\n.ef-estado {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    white-space: nowrap;\n}\n.ef-estado-aguarda    { background: #fef3c7; color: #92400e; }\n.ef-estado-associada  { background: #dcfce7; color: #15803d; }\n\n.txt-warn { color: #dc2626; font-weight: 600; }\n.gf-fatura-info small { color: #888; margin-left: 5px; font-weight: normal; }\n\n/* Pendentes bulk */\n.bulk-pendentes-wrap { margin-top: 18px; border: 1px solid #fed7aa; border-radius: 10px; overflow: hidden; }\n.bulk-pendentes-header { display: flex; align-items: center; gap: 10px; padding: 10px 16px; background: #fff7ed; border-bottom: 1px solid #fed7aa; }\n.bulk-pendentes-title { font-weight: 700; font-size: 13px; color: #92400e; }\n.bulk-pendentes-count { font-size: 12px; color: #b45309; background: #fef3c7; border-radius: 10px; padding: 1px 8px; }\n\n/* Última importação bulk */\n.bulk-last-import {\n    margin-top: 18px;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    overflow: hidden;\n}\n.bulk-last-import-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 14px;\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n    gap: 12px;\n}\n.bulk-last-import-header > div:first-child {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n.bulk-last-import-title {\n    font-size: 13px;\n    font-weight: 700;\n    color: #374151;\n}\n.bulk-last-import-date {\n    font-size: 11.5px;\n    color: #64748b;\n    background: #e2e8f0;\n    border-radius: 4px;\n    padding: 2px 7px;\n}\n.bulk-last-import-count {\n    font-size: 11px;\n    color: #94a3b8;\n}\n.bulk-last-import-actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n}\n.btn-bulk-undo {\n    padding: 5px 12px;\n    background: #fff7ed;\n    border: 1px solid #fed7aa;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #c2410c;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n.btn-bulk-undo:hover { background: #ffedd5; border-color: #fb923c; }\n.btn-bulk-dismiss {\n    padding: 4px 8px;\n    background: none;\n    border: 1px solid #e2e8f0;\n    border-radius: 5px;\n    font-size: 13px;\n    color: #94a3b8;\n    cursor: pointer;\n    line-height: 1;\n}\n.btn-bulk-dismiss:hover { background: #f1f5f9; color: #475569; }\n\n/* Bulk results */\n.bulk-results-wrap { margin-top: 18px; }\n.bulk-results-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }\n.bulk-results-header h4 { margin: 0; font-size: 14px; }\n.bulk-legend { display: flex; gap: 8px; }\n.bulk-leg { padding: 2px 8px; border-radius: 10px; font-size: 11px; font-weight: 700; }\n.bulk-leg.matched  { background: #d1fae5; color: #065f46; }\n.bulk-leg.warning  { background: #fef3c7; color: #92400e; }\n.bulk-leg.new      { background: #ffedd5; color: #9a3412; }\n.bulk-leg.duplicate{ background: #fee2e2; color: #991b1b; }\n.bulk-leg.manual   { background: #f1f5f9; color: #475569; }\n\n.bulk-row-matched    { background: #f0fdf4; }\n.bulk-row-new        { background: #fff7ed; }\n.bulk-row-warning    { background: #fefce8; }\n.bulk-row-duplicate  { background: #fef2f2; }\n.bulk-row-manual     { background: #f8fafc; }\n.bulk-row-erro       { background: #fef2f2; }\n.bulk-row-pending    { background: #f8fafc; color: #94a3b8; }\n.bulk-row-processing { background: #eff6ff; }\n.bulk-progress-label { display: flex; align-items: center; gap: 8px; font-weight: 600; color: #1d4ed8; }\n.bulk-spinner        { animation: spin 1s linear infinite; display: inline-block; }\n@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }\n\n.bulk-filename { font-size: 12px; color: #475569; max-width: 200px; word-break: break-all; }\n.bulk-msg { font-size: 11px; color: #64748b; }\n.bulk-atcud-tag { background: #dbeafe; color: #1d4ed8; padding: 2px 6px; border-radius: 4px; font-size: 10px; font-weight: 700; }\n.bulk-nif-tag   { background: #f3e8ff; color: #7c3aed; padding: 2px 6px; border-radius: 4px; font-size: 10px; font-weight: 700; }\n.bulk-none-tag  { color: #94a3b8; }\n\n.bulk-manual-file { font-size: 12px; color: #64748b; background: #f8fafc; border-radius: 4px; padding: 6px 10px; margin-bottom: 14px; }\n.bulk-manual-note { margin-top: 12px; font-size: 12px; color: #64748b; font-style: italic; }\n\n.gf-bulk-list { display: flex; align-items: center; gap: 14px; margin-top: 12px; padding: 10px 14px; background: #f8fafc; border-radius: 6px; }\n\n/* EF fatura tag */\n.ef-fatura-tag {\n    display: inline-block;\n    background: #dcfce7;\n    color: #15803d;\n    border-radius: 4px;\n    padding: 2px 7px;\n    font-size: 11px;\n    font-weight: 600;\n}\n.ef-fatura-pendente { color: #94a3b8; font-size: 13px; }\n\n/* Modal EF */\n.gf-modal-overlay {\n    position: fixed; inset: 0;\n    background: rgba(0,0,0,0.45);\n    z-index: 1000;\n    display: flex; align-items: center; justify-content: center;\n}\n.gf-modal {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 8px 40px rgba(0,0,0,0.18);\n    width: 860px; max-width: 95vw;\n    display: flex; flex-direction: column;\n    max-height: 90vh;\n    overflow: hidden;\n}\n.gf-modal-header {\n    display: flex; align-items: center; justify-content: space-between;\n    padding: 18px 22px 14px;\n    border-bottom: 1px solid #e2e8f0;\n}\n.gf-modal-header h3 { margin: 0; font-size: 16px; color: #1e293b; }\n.gf-modal-close {\n    background: none; border: none; font-size: 22px; cursor: pointer;\n    color: #64748b; line-height: 1; padding: 0 4px;\n}\n.gf-modal-close:hover { color: #dc2626; }\n.gf-modal-body {\n    padding: 18px 22px;\n    overflow-y: auto;\n    flex: 1;\n}\n.gf-modal-info-grid {\n    display: grid; grid-template-columns: 1fr 1fr;\n    gap: 10px 20px; margin-bottom: 14px;\n}\n.gf-modal-info-grid > div { display: flex; flex-direction: column; gap: 2px; }\n.gf-modal-label { font-size: 11px; color: #64748b; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; }\n.gf-modal-desc { margin-bottom: 12px; }\n.gf-modal-desc p { margin: 4px 0 0; font-size: 13px; color: #334155; line-height: 1.5; }\n.gf-modal-sep { border: none; border-top: 1px solid #e2e8f0; margin: 14px 0; }\n.gf-modal-section-title { margin: 0 0 12px; font-size: 13px; color: #3182ce; font-weight: 700; }\n.gf-modal-fatura-form { display: flex; gap: 14px; flex-wrap: wrap; }\n.gf-modal-fatura-form .gf-field { flex: 1; min-width: 160px; }\n.gf-modal-despesa-status {\n    display: flex; align-items: center; gap: 8px; flex-wrap: wrap;\n    background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px;\n    padding: 8px 12px; margin-top: 10px;\n}\n.gf-modal-despesa-status .gf-modal-label { margin-right: 4px; }\n.gf-save-ok { margin-top: 12px; background: #dcfce7; color: #15803d; border-radius: 6px; padding: 8px 14px; font-size: 13px; font-weight: 600; }\n.gf-save-err { margin-top: 12px; background: #fee2e2; color: #991b1b; border-radius: 6px; padding: 8px 14px; font-size: 13px; }\n.gf-modal-footer {\n    display: flex; gap: 10px; justify-content: flex-end; align-items: stretch;\n    padding: 14px 22px;\n    border-top: 1px solid #e2e8f0;\n    background: #f8fafc;\n}\n.gf-modal-footer button {\n    white-space: nowrap; display: flex; align-items: center; justify-content: center;\n}\n.gf-modal-btn-desassoc {\n    padding: 9px 16px; border-radius: 6px; font-size: 13px; font-weight: 600;\n    border: 1px solid #fecaca; background: #fff1f2; color: #dc2626; cursor: pointer;\n    margin-right: auto; white-space: nowrap;\n}\n.gf-modal-btn-desassoc:hover { background: #fee2e2; }\n.gf-modal-btn-orc {\n    padding: 9px 16px; border-radius: 6px; font-size: 13px; font-weight: 600;\n    border: 1px solid #bfdbfe; background: #eff6ff; color: #1d4ed8; cursor: pointer;\n}\n.gf-modal-btn-orc:hover { background: #dbeafe; }\n\n.gf-status-pending {\n    background: #fff7ed;\n    color: #c2410c;\n    padding: 3px 8px;\n    border-radius: 4px;\n    font-size: 11px;\n    border: 1px solid #ffedd5;\n    font-weight: 500;\n}\n\n.btn-action-s {\n    padding: 5px 10px;\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    border-radius: 4px;\n    font-size: 11px;\n    color: #475569;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-action-s:hover {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.btn-action-s:hover {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.gf-btn-group {\n    display: flex;\n    gap: 2px;\n    background: #fff;\n    padding: 3px;\n    border-radius: 8px;\n    width: fit-content;\n    border: 1px solid #e2e8f0;\n}\n\n.gf-btn-s {\n    padding: 6px 14px;\n    border: none;\n    background: transparent;\n    font-size: 12px;\n    font-weight: 600;\n    color: #64748b;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n/* Filtros de estado de pagamento: largura igual entre si, ditada pelo rótulo\n   mais comprido (\"Faturas por Pagar\"), para o grupo não dançar ao mudar de\n   seleção. */\n.gf-btn-pag {\n    min-width: 150px;\n    text-align: center;\n    justify-content: center;\n}\n\n.gf-btn-s.active {\n    background: #3182ce;\n    color: #fff;\n    box-shadow: 0 2px 4px rgba(49, 130, 206, 0.2);\n}\n\n/* Dashboard Mini */\n.gf-dashboard-mini {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #fff;\n    padding: 14px 20px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n.gf-summary-cards {\n    display: flex;\n    gap: 24px;\n    align-items: center;\n    /* Em ecrã estreito passam para a linha de baixo em vez de se espremerem. */\n    flex-wrap: wrap;\n}\n\n.gf-btn-refresh {\n    padding: 6px 10px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n    font-size: 16px;\n    line-height: 1;\n    transition: background 0.15s;\n}\n.gf-btn-refresh:hover { background: #f1f5f9; }\n.gf-btn-refresh:disabled { opacity: 0.5; cursor: default; }\n\n.gf-card-mini {\n    display: flex;\n    flex-direction: column;\n    /* Valor centrado sob o seu título. Alinhados à direita, o título e o número\n       tinham larguras diferentes e só as pontas coincidiam — \"TOTAL COMPRA\"\n       ficava visivelmente desencontrado do \"74.831,01 €\" por baixo. */\n    align-items: center;\n    /* O cartão encolhia até ao ponto de partir o valor em duas linhas —\n       \"23.396,82\" numa e o \"€\" na seguinte. Não encolher abaixo do conteúdo. */\n    flex-shrink: 0;\n}\n\n.gf-card-label {\n    font-size: 10px;\n    font-weight: 700;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 2px;\n}\n\n.gf-card-val {\n    font-size: 20px;\n    font-weight: 700;\n    color: #1e293b;\n    /* Valor e símbolo da moeda são uma coisa só: nunca se separam. */\n    white-space: nowrap;\n}\n\n/* Date Range Filter Group */\n.gf-filter-date-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: #fff;\n    padding: 0 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    height: 40px;\n}\n\n.gf-filter-date-group label {\n    font-size: 11px;\n    font-weight: 700;\n    color: #64748b;\n    text-transform: uppercase;\n    margin-right: 4px;\n    /* line-height 1 + flex: em maiúsculas não há descendentes, e com a entrelinha\n       por omissão o texto assenta no topo da caixa e parece subido face às datas. */\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    align-self: stretch;\n}\n\n.gf-filter-date-group .orc-input-date {\n    border: none !important;\n    padding: 0 !important;\n    height: auto !important;\n    font-size: 13px !important;\n    width: 120px !important;\n    box-shadow: none !important;\n}\n\n.gf-dash {\n    color: #cbd5e1;\n    font-weight: 400;\n}\n\n/* Common quick filter buttons (matching budgets) */\n.orc-ano-btn {\n    padding: 6px 18px;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    color: #64748b;\n    background: #fff;\n    transition: all 0.15s;\n    white-space: nowrap;\n    margin-right: 6px;\n}\n\n.orc-ano-btn:hover {\n    color: #1e293b;\n    border-color: #94a3b8;\n}\n\n.orc-ano-btn.active {\n    background: #3182ce;\n    color: #fff;\n    border-color: #3182ce;\n}\n\n/* Quick Filter Rows */\n.gf-quick-filter-container {\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.gf-quick-row {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.gf-mode-row {\n    background: #f1f5f9;\n    padding: 4px;\n    border-radius: 10px;\n    width: fit-content;\n    margin-bottom: 4px;\n    border: 1px solid #e2e8f0;\n}\n\n.gf-mode-btn-s {\n    padding: 6px 20px;\n    border: none;\n    background: transparent;\n    font-size: 12px;\n    font-weight: 700;\n    color: #64748b;\n    border-radius: 7px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.gf-mode-btn-s.active {\n    background: #3182ce;\n    color: #fff;\n    box-shadow: 0 2px 5px rgba(49, 130, 206, 0.2);\n}\n\n.gf-months-grid {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    gap: 5px;\n    width: 100%;\n}\n\n@media (max-width: 1100px) {\n    .gf-months-grid { grid-template-columns: repeat(6, 1fr); }\n}\n@media (max-width: 600px) {\n    .gf-months-grid { grid-template-columns: repeat(4, 1fr); }\n}\n\n.gf-month-btn {\n    padding: 7px 4px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: #fff;\n    font-size: 11px;\n    font-weight: 600;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.15s;\n    text-align: center;\n    white-space: nowrap;\n}\n\n.gf-month-btn:hover {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #1e293b;\n}\n\n.gf-month-btn.active {\n    background: #3182ce;\n    color: #fff;\n    border-color: #3182ce;\n    box-shadow: 0 2px 4px rgba(49, 130, 206, 0.2);\n}\n\n\n\n\n/* Linha clicável na tabela de faturas fornecedor */\n.gf-row-clickable {\n    cursor: pointer;\n}\n.gf-row-clickable:hover td {\n    background: #eff6ff;\n}\n\n/* ── Modal edição de fatura — layout largo 2 colunas ── */\n.gef-modal-wide {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0,0,0,0.18);\n    width: 920px;\n    max-width: 97vw;\n    max-height: 92vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.gef-modal-body-split {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n    min-height: 0;\n}\n\n/* Coluna esquerda — preview do documento */\n.gef-col-preview {\n    width: 46%;\n    background: #f8fafc;\n    border-right: 1px solid #e2e8f0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 16px;\n    gap: 10px;\n    overflow-y: auto;\n}\n\n.gef-img-wrap {\n    flex: 1;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    width: 100%;\n    min-height: 0;\n}\n\n.gef-img-large {\n    max-width: 100%;\n    max-height: 60vh;\n    object-fit: contain;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: #fff;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n\n.gef-pdf-placeholder {\n    width: 100%;\n    padding: 40px 0;\n    text-align: center;\n    font-size: 40px;\n    color: #94a3b8;\n    border: 2px dashed #e2e8f0;\n    border-radius: 8px;\n    line-height: 1.4;\n}\n\n.gef-open-doc-btn {\n    width: 100%;\n    background: #3182ce;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    padding: 8px 12px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n.gef-open-doc-btn:hover { background: #2563eb; }\n.gef-open-doc-btn:disabled { opacity: 0.6; cursor: default; }\n\n.gef-no-doc {\n    width: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    color: #94a3b8;\n    font-size: 13px;\n}\n.gef-no-doc span { font-size: 36px; }\n\n.gef-upload-label, .gef-replace-label {\n    display: inline-block;\n    padding: 6px 14px;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    font-size: 12px;\n    color: #3182ce;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n.gef-upload-label:hover, .gef-replace-label:hover { background: #eff6ff; }\n\n.gef-replace-file {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n    position: sticky;\n    bottom: 0;\n    background: #f8fafc;\n    padding: 10px 0 2px;\n    margin-top: auto;\n    z-index: 2;\n}\n\n.gef-btn-apagar-doc {\n    padding: 6px 12px;\n    border: 1px solid #fca5a5;\n    border-radius: 6px;\n    font-size: 12px;\n    color: #dc2626;\n    background: #fff;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n.gef-btn-apagar-doc:hover { background: #fef2f2; }\n\n.gef-preview-hint {\n    text-align: center;\n    font-size: 11px;\n    color: #3182ce;\n    font-weight: 500;\n    margin: 4px 0 0;\n}\n\n/* Lista de ficheiros pendentes de upload (multi-página) */\n.gef-pending-files {\n    width: 100%;\n    border: 1px solid #c4b5fd;\n    background: #f5f3ff;\n    border-radius: 6px;\n    padding: 8px 10px;\n    margin-top: 6px;\n    box-sizing: border-box;\n}\n.gef-pending-header {\n    font-size: 11px;\n    font-weight: 700;\n    color: #6d28d9;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    margin-bottom: 6px;\n}\n.gef-pending-list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n.gef-pending-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 5px 8px;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 5px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background 0.1s, border-color 0.1s;\n}\n.gef-pending-item:hover { background: #f8fafc; }\n.gef-pending-item.selected {\n    background: #eff6ff;\n    border-color: #3182ce;\n}\n.gef-pending-num {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: #6d28d9;\n    color: #fff;\n    font-size: 10px;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n.gef-pending-name {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: #1e293b;\n}\n.gef-pending-remove {\n    background: #fee2e2;\n    color: #b91c1c;\n    border: 1px solid #fca5a5;\n    border-radius: 4px;\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n.gef-pending-remove:hover { background: #fecaca; }\n\n.gef-file-chosen {\n    display: block;\n    font-size: 11px;\n    color: #64748b;\n    margin-top: 4px;\n    text-align: center;\n    word-break: break-all;\n}\n\n/* Coluna direita — formulário */\n.gef-col-form {\n    flex: 1;\n    padding: 20px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    min-height: 0;\n}\n\n.gef-row-2 {\n    display: flex;\n    gap: 10px;\n}\n.gef-row-2 .gf-field { flex: 1; min-width: 0; }\n\n.gef-row-3 {\n    display: flex;\n    gap: 10px;\n}\n.gef-row-3 .gf-field { flex: 1; min-width: 0; }\n.gef-row-3 select {\n    width: 100%;\n    padding: 8px 10px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-size: 13px;\n    background: #fff;\n    box-sizing: border-box;\n}\n.gef-col-form .gf-field input,\n.gef-col-form .gf-field select {\n    width: 100%;\n    box-sizing: border-box;\n    min-width: 0;\n}\n.gef-field-readonly {\n    background: #f8fafc !important;\n    color: #64748b !important;\n}\n\n/* Auto-match */\n.gef-automatch-box {\n    border: 1px solid #f59e0b;\n    border-radius: 8px;\n    padding: 10px 12px;\n    background: #fffbeb;\n}\n.gef-automatch-title {\n    font-size: 12px;\n    font-weight: 600;\n    color: #92400e;\n    margin: 0 0 8px;\n}\n.gef-btn-fundir-inline {\n    display: block;\n    width: 100%;\n    margin-top: 6px;\n    background: #e53e3e;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    padding: 5px 10px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n.gef-btn-fundir-inline:hover { background: #c53030; }\n.gef-btn-fundir-inline:disabled { opacity: 0.6; cursor: default; }\n.gef-btn-desassoc-inline {\n    display: block;\n    width: 100%;\n    margin-top: 6px;\n    background: #fff;\n    color: #c05621;\n    border: 1px solid #c05621;\n    border-radius: 4px;\n    padding: 5px 10px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background 0.15s, color 0.15s;\n}\n.gef-btn-desassoc-inline:hover { background: #fff7ed; color: #9a3412; border-color: #9a3412; }\n\n/* Fusão — estilos partilhados */\n.gef-fusao-item {\n    padding: 8px 12px;\n    cursor: pointer;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    margin-top: 4px;\n    transition: background 0.1s;\n}\n.gef-fusao-item:hover { background: #f8fafc; }\n.gef-fusao-item.selected { background: #eff6ff; border-color: #3182ce; }\n.gef-fusao-nome { display: block; font-size: 13px; font-weight: 600; color: #1e293b; }\n.gef-fusao-meta { display: block; font-size: 11px; color: #64748b; margin-top: 2px; }\n.gef-fusao-ef { color: #3182ce; font-weight: 600; }\n\n.gef-form-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: auto;\n    padding: 12px 0 2px;\n    border-top: 1px solid #f1f5f9;\n    position: sticky;\n    bottom: 0;\n    background: #fff;\n    z-index: 2;\n}\n\n/* Botão ícone de documento na tabela */\nbutton.gf-doc-link {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n    padding: 2px 4px;\n    border-radius: 4px;\n    transition: background 0.15s;\n}\nbutton.gf-doc-link:hover { background: #e2e8f0; }\n\n/* Zoom hover na imagem */\n.gef-img-zoom-wrap {\n    width: 100%;\n    overflow: hidden;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: #fff;\n    flex: 1;\n    min-height: 200px;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n.gef-img-zoom-wrap .gef-img-large {\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n    width: 100%;\n    max-height: none;\n    display: block;\n}\n.gef-pdf-wrap {\n    width: 100%;\n    flex: 1;\n    min-height: 500px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    overflow: hidden;\n    background: #fff;\n    display: flex;\n}\n.gef-pdf-iframe {\n    width: 100%;\n    height: 100%;\n    min-height: 500px;\n    border: none;\n    display: block;\n}\n\n/* Pesquisa EF */\n.gef-ef-search-box {\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 10px 12px;\n    background: #f8fafc;\n}\n.gef-ef-search-label {\n    display: block;\n    font-size: 11px;\n    font-weight: 700;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    margin-bottom: 8px;\n}\n.gef-ef-input {\n    width: 100%;\n    padding: 7px 10px;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    font-size: 13px;\n    box-sizing: border-box;\n    background: #fff;\n}\n.gef-ef-input:focus { outline: none; border-color: #3182ce; }\n.gef-ef-results {\n    margin-top: 6px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    overflow: hidden;\n    background: #fff;\n    max-height: 200px;\n    overflow-y: auto;\n}\n.gef-ef-item {\n    padding: 8px 10px;\n    cursor: pointer;\n    border-bottom: 1px solid #f1f5f9;\n    transition: background 0.1s;\n}\n.gef-ef-item:last-child { border-bottom: none; }\n.gef-ef-item:hover { background: #f8fafc; }\n.gef-ef-item.selected { background: #eff6ff; border-left: 3px solid #3182ce; }\n.gef-ef-item.gef-ef-item-associada { opacity: 0.7; }\n.gef-ef-item.gef-ef-item-associada .gef-ef-num { color: #92400e; }\n.gef-ef-num { font-size: 12px; font-weight: 700; color: #3182ce; margin-right: 6px; }\n.gef-ef-info { font-size: 12px; color: #475569; }\n.gef-ef-proj { color: #64748b; }\n.gef-ef-val { font-weight: 600; color: #1e293b; }\n.gef-ef-vazio { font-size: 12px; color: #94a3b8; margin: 6px 0 0; text-align: center; }\n.gef-ef-atual {\n    font-size: 13px;\n    color: #16a34a;\n    padding: 4px 0;\n}\n\n/* Multi-EF picker (nova fatura) */\n.gef-pre-ef-box {\n    border: 1px solid #bae6fd;\n    border-radius: 8px;\n    padding: 10px 12px;\n    background: #f0f9ff;\n    margin-bottom: 10px;\n}\n.gef-pre-ef-list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 6px;\n}\n.gef-pre-ef-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 8px;\n    background: #fff;\n    border: 1px solid #bae6fd;\n    border-radius: 6px;\n    font-size: 13px;\n}\n\n/* Associação M:N — lista de EFs, valor em falta, botão adicionar */\n.gef-ef-assoc-list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-bottom: 8px;\n}\n.gef-ef-assoc-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 10px;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n}\n.gef-ef-assoc-info {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    overflow: hidden;\n}\n/* Sem ellipsis: o valor da encomenda vem no fim da linha e era o primeiro a\n   ser cortado — \"EF 271…\" em vez de \"EF 271.000,00 €\", que deixava o valor\n   real da EF invisível precisamente no ecrã que o compara. A linha parte-se\n   em duas quando não cabe. */\n.gef-ef-assoc-info .gef-ef-info {\n    white-space: normal;\n    overflow-wrap: anywhere;\n}\n/* Consumo global da EF pelas várias faturas — informativo, não compete com o valor */\n.gef-ef-consumo { color: #64748b; font-weight: 400; }\n.gef-ef-assoc-aloc {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 11px;\n    color: #64748b;\n}\n.gef-ef-assoc-aloc label {\n    text-transform: uppercase;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n}\n.gef-ef-assoc-aloc input {\n    width: 90px;\n    padding: 5px 7px;\n    border: 1px solid #cbd5e1;\n    border-radius: 5px;\n    font-size: 13px;\n    font-weight: 600;\n    text-align: right;\n    color: #1e293b;\n    background: #fff;\n}\n.gef-ef-assoc-aloc input:focus { outline: none; border-color: #3182ce; }\n.gef-ef-assoc-remove {\n    background: #fee2e2;\n    color: #b91c1c;\n    border: 1px solid #fca5a5;\n    border-radius: 6px;\n    width: 26px;\n    height: 26px;\n    font-size: 16px;\n    font-weight: 700;\n    cursor: pointer;\n    line-height: 1;\n}\n.gef-ef-assoc-remove:hover:not(:disabled) { background: #fecaca; }\n.gef-ef-assoc-remove:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* Em coluna: o comparativo fatura/EF em cima, a conclusão por baixo. Antes era\n   uma linha com os valores espalhados, o que impedia alinhá-los. */\n.gef-ef-falta {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    padding: 10px 14px;\n    border-radius: 6px;\n    font-size: 12.5px;\n    line-height: 1.45;\n    margin-bottom: 8px;\n}\n\n/* Grelha das duas linhas de valores. As colunas dos números têm largura\n   automática mas partilhada, o que põe os algarismos uns por baixo dos outros\n   e torna a diferença visível de relance. */\n/* Rótulo à esquerda, números à direita — a mesma régua nos dois blocos, para\n   os valores caírem uns por baixo dos outros e se lerem em coluna. */\n.gef-ef-comparativo,\n.gef-ef-enc-topo,\n.gef-ef-enc-linhas {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    gap: 3px 12px;\n    align-items: baseline;\n    font-variant-numeric: tabular-nums;\n}\n.gef-ef-enc-topo > *:nth-child(even),\n.gef-ef-enc-linhas > *:nth-child(even) { text-align: right; white-space: nowrap; }\n/* A conta da fatura fica à direita como os outros valores, mas SEM nowrap: é a\n   linha mais comprida da caixa e num modal estreito tinha de transbordar para\n   não partir. Aqui parte, que é o mal menor. */\n.gef-ef-comparativo > *:nth-child(even) { text-align: right; overflow-wrap: anywhere; }\n.gef-ef-lbl { font-weight: 600; }\n.gef-ef-op { opacity: 0.55; }\n\n/* A encomenda é um bloco à parte, separado por um traço: são factos de outra\n   natureza que os da fatura, e sem a divisória liam-se como continuação.\n   Traço a preto translúcido — assenta tanto no fundo verde como no âmbar. */\n.gef-ef-encomenda {\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid rgba(0, 0, 0, 0.10);\n}\n/* Alinhados à esquerda com \"Encomenda\", sem indentação: a hierarquia já se lê\n   pelo peso do rótulo de cima e pelo corpo mais pequeno destas linhas, e a\n   margem só desencontrava o início dos textos. */\n.gef-ef-enc-linhas { margin-top: 3px; font-size: 12px; opacity: 0.9; }\n/* O que resta por faturar é o número que interessa reter da encomenda. */\n.gef-ef-enc-resto { font-weight: 600; }\n.gef-ef-enc-linhas em { font-style: normal; font-weight: 400; opacity: 0.75; }\n/* Conclusão fora da grelha: se lá estivesse, o comprimento do texto ditava a\n   largura das primeiras colunas e afastava o \"+\" do valor da base. */\n.gef-ef-conclusao {\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid rgba(0, 0, 0, 0.10);\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n}\n.gef-ef-conclusao-val { margin-left: 8px; }\n.gef-ef-falta-ok { background: #dcfce7; color: #166534; border: 1px solid #86efac; }\n.gef-ef-falta-pend { background: #fef3c7; color: #92400e; border: 1px solid #fcd34d; }\n.gef-ef-falta strong { font-weight: 700; }\n\n.gef-ef-add-btn {\n    width: 100%;\n    padding: 8px 12px;\n    background: #eff6ff;\n    color: #1e40af;\n    border: 1px dashed #93c5fd;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n.gef-ef-add-btn:hover { background: #dbeafe; }\n.gef-ef-add-cancel {\n    margin-top: 6px;\n    padding: 5px 10px;\n    background: transparent;\n    color: #64748b;\n    border: none;\n    font-size: 11px;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n\n/* ============================================================\n   FILTROS DE COLUNA - Para Faturar\n   ============================================================ */\n.col-filter-wrap {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n    cursor: pointer;\n    user-select: none;\n    white-space: nowrap;\n}\n.col-filter-btn {\n    background: none;\n    border: none;\n    padding: 2px 4px;\n    cursor: pointer;\n    border-radius: 3px;\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    font-size: 10.5px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    color: #94a3b8;\n    transition: color 0.1s, background 0.1s;\n}\n.col-filter-btn:hover { color: #475569; background: #f1f5f9; }\n.col-filter-btn.filtered { color: #3182ce; }\n.col-filter-btn.sorted   { color: #7c3aed; }\n.col-filter-btn.filtered.sorted { color: #3182ce; }\n.col-filter-arrow { font-size: 9px; opacity: 0.7; }\n.col-filter-dropdown {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    z-index: 500;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0,0,0,0.14);\n    padding: 8px 0;\n    min-width: 180px;\n    max-width: 260px;\n}\n/* Versão fixed — escapa ao overflow:auto do container da tabela */\n.col-filter-dropdown-fixed {\n    position: fixed !important;\n    top: unset;\n    left: unset;\n    z-index: 2000;\n}\n.col-filter-footer {\n    padding: 6px 10px 2px;\n    border-top: 1px solid #f1f5f9;\n    margin-top: 4px;\n}\n.col-filter-clear-btn {\n    font-size: 11px; color: #ef4444; background: none; border: none;\n    cursor: pointer; padding: 2px 4px; font-weight: 600;\n}\n.col-filter-clear-btn:hover { text-decoration: underline; }\n.col-filter-sort {\n    display: flex;\n    gap: 4px;\n    padding: 4px 10px 8px;\n    border-bottom: 1px solid #f1f5f9;\n    margin-bottom: 4px;\n}\n.col-filter-sort-btn {\n    flex: 1;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 5px;\n    padding: 4px 8px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.1s;\n}\n.col-filter-sort-btn:hover { background: #e2e8f0; color: #1e293b; }\n.col-filter-sort-btn.active { background: #7c3aed; color: #fff; border-color: #7c3aed; }\n.col-filter-search {\n    width: calc(100% - 20px);\n    margin: 0 10px 6px;\n    padding: 5px 8px;\n    border: 1px solid #e2e8f0;\n    border-radius: 5px;\n    font-size: 12px;\n    outline: none;\n    box-sizing: border-box;\n}\n.col-filter-search:focus { border-color: #3182ce; }\n.col-filter-list { max-height: 200px; overflow-y: auto; padding: 2px 0; }\n.col-filter-item {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    padding: 4px 12px;\n    font-size: 12px;\n    color: #374151;\n    cursor: pointer;\n    transition: background 0.1s;\n}\n.col-filter-item:hover { background: #f0f4ff; }\n.col-filter-item input[type=\"checkbox\"] {\n    width: 13px; height: 13px; margin: 0;\n    cursor: pointer; accent-color: #3182ce;\n}\n\n/* Cores margem */\n.gf-table .pos { color: #16a34a; font-weight: 600; }\n.gf-table .neg { color: #dc2626; font-weight: 600; }\n.gf-card-val.pos { color: #16a34a; }\n.gf-card-val.neg { color: #dc2626; }\n\n/* Caixa de confirmação de apagar (substitui o window.confirm do browser) */\n.gf-conf-box {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 8px 40px rgba(0,0,0,0.22);\n    /* A largura acompanha a frase em vez de a partir em duas linhas. */\n    width: max-content; min-width: 380px; max-width: 92vw;\n    padding: 26px 32px 20px;\n    text-align: center;\n}\n.gf-conf-titulo {\n    color: #dc2626;\n    font-weight: 800;\n    font-size: 18px;\n    letter-spacing: 0.5px;\n    margin-bottom: 10px;\n}\n.gf-conf-texto {\n    color: #111827;\n    font-size: 14px;\n    line-height: 1.5;\n    margin-bottom: 22px;\n    white-space: nowrap;\n}\n.gf-conf-botoes {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n}\n.gf-conf-botoes button {\n    min-width: 104px;\n    padding: 8px 18px;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n.gf-conf-btn-cancelar {\n    border: 1px solid #cbd5e1;\n    background: #fff;\n    color: #475569;\n}\n.gf-conf-btn-cancelar:hover { background: #f1f5f9; }\n.gf-conf-btn-ok {\n    border: 1px solid #dc2626;\n    background: #dc2626;\n    color: #fff;\n}\n.gf-conf-btn-ok:hover { background: #b91c1c; border-color: #b91c1c; }\n\n/* ============================================================\n   AVISO DE POSSÍVEL DUPLICAÇÃO\n\n   Avisa, não impede: há faturas do mesmo fornecedor com o mesmo número que\n   são legítimas — a de várias taxas de IVA lançada em linhas separadas é o\n   caso desta casa. Três graus de gravidade, com cores distintas, porque um\n   aviso que grita por tudo deixa de ser lido.\n   ============================================================ */\n.gf-aviso-dup {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin: 12px 0;\n    padding: 12px 16px;\n    border-radius: 8px;\n    border: 1px solid;\n    font-size: 13.5px;\n    line-height: 1.5;\n}\n.gf-aviso-dup.nivel-duplicado { background: #fef2f2; border-color: #fca5a5; color: #991b1b; }\n.gf-aviso-dup.nivel-provavel  { background: #fff7ed; border-color: #fdba74; color: #9a3412; }\n.gf-aviso-dup.nivel-confirmar { background: #fffbeb; border-color: #fcd34d; color: #92400e; }\n.gf-aviso-dup-icone { font-size: 19px; line-height: 1.2; flex-shrink: 0; }\n.gf-aviso-dup-texto { flex: 1; min-width: 0; }\n.gf-aviso-dup-texto strong { display: block; margin-bottom: 2px; }\n/* A garantia de que a fatura ficou gravada, em tom menor: é o que evita que o\n   aviso seja lido como \"não gravou\". */\n.gf-aviso-dup-nota { margin-top: 6px; font-size: 12.5px; opacity: 0.85; }\n.gf-aviso-dup-x {\n    flex-shrink: 0;\n    background: transparent; border: 0; cursor: pointer;\n    font-size: 20px; line-height: 1; color: inherit; opacity: 0.55; padding: 0 2px;\n}\n.gf-aviso-dup-x:hover { opacity: 1; }\n\n/* ============================================================\n   LINHAS DE IVA — faturas com mais do que uma taxa\n\n   Transportes sobretudo: portagens isentas ao lado do serviço a 23%. Só\n   aparece quando a fatura o exige; com uma taxa só, o formulário mantém os\n   três campos de sempre.\n   ============================================================ */\n.gf-iva-linhas {\n    border: 1px solid #cbd5e1;\n    border-radius: 7px;\n    padding: 9px 11px;\n    background: #f8fafc;\n    margin-bottom: 10px;\n}\n.gf-iva-cab, .gf-iva-linha, .gf-iva-total {\n    display: grid;\n    grid-template-columns: 96px 1fr 1fr 26px;\n    gap: 8px;\n    align-items: center;\n}\n.gf-iva-cab {\n    font-size: 10.5px; font-weight: 700; color: #64748b;\n    text-transform: uppercase; letter-spacing: .3px; margin-bottom: 4px;\n}\n.gf-iva-linha { margin-bottom: 5px; }\n.gf-iva-linha select, .gf-iva-linha input {\n    width: 100%; padding: 5px 7px; font-size: 13px;\n    border: 1px solid #cbd5e1; border-radius: 5px; background: #fff;\n}\n.gf-iva-linha input { text-align: right; font-variant-numeric: tabular-nums; }\n/* A soma fecha o bloco: é ela que tem de bater com o total da fatura. */\n.gf-iva-total {\n    border-top: 1px solid #cbd5e1; padding-top: 6px; margin-top: 2px;\n    font-size: 12.5px; font-weight: 700; font-variant-numeric: tabular-nums;\n}\n.gf-iva-total span:nth-child(2), .gf-iva-total span:nth-child(3) { text-align: right; }\n.gf-iva-x {\n    background: transparent; border: 0; cursor: pointer;\n    font-size: 17px; line-height: 1; color: #94a3b8; padding: 0;\n}\n.gf-iva-x:hover { color: #b91c1c; }\n.gf-iva-mais {\n    margin-top: 7px; background: #fff; border: 1px dashed #94a3b8;\n    border-radius: 5px; padding: 4px 10px; font-size: 12px;\n    color: #475569; cursor: pointer;\n}\n.gf-iva-mais:hover { background: #eff6ff; border-color: #3182ce; color: #1e40af; }\n/* Fora do bloco, quando ainda não há linhas: discreto, para não sugerir que é\n   o caminho normal — a esmagadora maioria das faturas tem uma taxa só. */\n.gf-iva-mais-solto { margin: -4px 0 10px; font-size: 11.5px; border-style: dotted; }\n\n\n\n/* ============================================================\n   ESCOLHA DE CLIENTES — Orçamentos Faturados\n\n   Fechada é uma linha só; abre em lista suspensa quando se vai escolher. Ter a\n   lista sempre aberta enchia o ecrã de nomes que na maior parte do tempo não\n   se está a usar. Escreve no mesmo filtro do cabeçalho da coluna Cliente, por\n   isso os dois nunca discordam.\n   ============================================================ */\n.gf-clientes { position: relative; display: inline-flex; align-items: center; gap: 6px; margin-bottom: 10px; }\n.gf-clientes-btn {\n    display: inline-flex; align-items: center; gap: 8px;\n    background: #fff; border: 1px solid #cbd5e1; border-radius: 7px;\n    padding: 6px 12px; font-size: 13px; color: #334155; cursor: pointer;\n}\n.gf-clientes-btn:hover { border-color: #3182ce; color: #1e40af; }\n.gf-clientes-btn.ativo { background: #eff6ff; border-color: #3182ce; color: #1e40af; font-weight: 600; }\n.gf-clientes-seta { font-size: 11px; opacity: 0.6; }\n.gf-clientes-limpar {\n    background: transparent; border: 0; cursor: pointer;\n    font-size: 12px; color: #94a3b8; padding: 2px 4px;\n}\n.gf-clientes-limpar:hover { color: #b91c1c; }\n/* Sobreposta à tabela, não a empurrar: abrir a lista não deve mexer no que\n   está por baixo. */\n.gf-clientes-lista {\n    position: absolute; top: calc(100% + 4px); left: 0; z-index: 40;\n    width: 340px;\n    background: #fff; border: 1px solid #cbd5e1; border-radius: 8px;\n    box-shadow: 0 8px 22px rgba(0, 0, 0, .14);\n    padding: 8px;\n}\n.gf-clientes-procura {\n    width: 100%; padding: 5px 9px; margin-bottom: 6px; font-size: 12.5px;\n    border: 1px solid #cbd5e1; border-radius: 6px;\n}\n.gf-clientes-procura:focus { outline: none; border-color: #3182ce; box-shadow: 0 0 0 2px #bee3f8; }\n.gf-clientes-itens { max-height: 260px; overflow-y: auto; }\n.gf-clientes-item {\n    display: flex; align-items: center; gap: 8px;\n    padding: 4px 6px; border-radius: 5px; cursor: pointer;\n    font-size: 12.5px; color: #334155;\n}\n.gf-clientes-item:hover { background: #f1f5f9; }\n.gf-clientes-item.escolhido { background: #eff6ff; color: #1e40af; font-weight: 600; }\n.gf-clientes-item input { flex-shrink: 0; cursor: pointer; margin: 0; }\n.gf-clientes-nome { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n/* Quantos orçamentos tem cada cliente no período — diz onde está o volume. */\n.gf-clientes-n {\n    flex-shrink: 0; font-size: 11px; color: #64748b;\n    background: #f1f5f9; border-radius: 999px; padding: 1px 7px;\n    font-variant-numeric: tabular-nums;\n}\n.gf-clientes-item.escolhido .gf-clientes-n { background: #dbeafe; color: #1e40af; }\n.gf-clientes-vazio { display: block; font-size: 12.5px; color: #94a3b8; padding: 6px 2px; }\n\n/* Coluna Cliente dos Orçamentos Faturados. Reserva-lhe largura própria: a\n   tabela dava-lhe o que sobrava e apertava-a contra a coluna do projeto.\n\n   340px sai da medição do texto renderizado, e não da contagem de letras: o\n   \"GASIB - SOCIEDAD IBÉRICA DE GAS LIQUEFEITO LDA\" ocupa 302px e a célula leva\n   14px de margem de cada lado, o que dá 330. Com os 310 de antes partia-se em\n   duas linhas por 20px.\n\n   (A medição antiga, mantida por história: 95% dos nomes têm até 47 caracteres,\n   o que a 12px dá ~296px — e 47 é precisamente o comprimento do \"MEO -\n   Serviços de Comunicações Eletrónicas, S.A\". Cobrir o nome mais comprido que\n   existe (81 caracteres, a Acessomatic) exigiria mais de 500px e roubava o\n   ecrã às restantes colunas; esses poucos passam a duas linhas, que se leem\n   bem.) Mínimo e não fixo, para as outras colunas continuarem a poder crescer. */\n.gf-table th.gf-col-cliente, .gf-table td.gf-col-cliente { min-width: 340px; }\n\n/* Margem e Margem % lado a lado, quase encostadas: são o mesmo facto dito de\n   duas maneiras e leem-se em conjunto. Com o espaçamento normal da tabela a\n   percentagem parecia pertencer à coluna do número de fatura. */\n.gf-table th.gf-col-margem, .gf-table td.gf-col-margem { padding-right: 2px; }\n.gf-table th.gf-col-margem-pct, .gf-table td.gf-col-margem-pct {\n    padding-left: 6px;\n    width: 1%;              /* encolhe ao conteúdo em vez de esticar */\n    white-space: nowrap;\n}\n\n/* ============================================================\n   SUGESTÃO DE FORNECEDOR — só em faturas sem QR\n\n   Com QR o nome e o NIF vêm lidos do documento; sem QR (as estrangeiras,\n   tipicamente) escreve-se tudo à mão, e é aí que a lista poupa o trabalho e\n   evita o NIF mal copiado. Continua a poder escrever-se livremente, para os\n   fornecedores que ainda não estão registados.\n   ============================================================ */\n.gf-forn-campo { position: relative; }\n.gf-forn-lista {\n    position: absolute; top: 100%; left: 0; right: 0; z-index: 60;\n    background: #fff; border: 1px solid #cbd5e1; border-radius: 8px;\n    box-shadow: 0 8px 22px rgba(0, 0, 0, .16);\n    max-height: 260px; overflow-y: auto; margin-top: 3px;\n}\n.gf-forn-cab {\n    padding: 6px 10px; font-size: 11px; color: #64748b;\n    background: #f8fafc; border-bottom: 1px solid #e2e8f0;\n    position: sticky; top: 0;\n}\n.gf-forn-item {\n    display: flex; align-items: baseline; gap: 10px; width: 100%;\n    padding: 6px 10px; border: 0; background: transparent; cursor: pointer;\n    text-align: left; font-size: 12.5px; color: #334155;\n    border-bottom: 1px solid #f1f5f9;\n}\n.gf-forn-item:hover { background: #eff6ff; }\n.gf-forn-nome { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n/* O NIF à vista na própria lista: é ele que vai ser preenchido, e ver-se antes\n   de escolher evita o clique errado entre nomes parecidos. */\n.gf-forn-nif {\n    flex-shrink: 0; font-size: 11px; color: #64748b;\n    font-family: ui-monospace, monospace;\n}\n\n/* ============================================================\n   DUPLICAÇÃO — a decisão antes de gravar\n\n   Não é um aviso a posteriori: nada foi gravado quando isto aparece. Fica por\n   cima do modal da fatura de propósito, para não haver dúvida de que o gravar\n   está suspenso à espera de resposta.\n   ============================================================ */\n.gf-dup-overlay {\n    position: fixed; inset: 0; z-index: 4000;\n    display: grid; place-items: center;\n    background: rgba(15, 23, 42, .55);\n    padding: 20px;\n}\n.gf-dup-caixa {\n    /* A caixa encolhe até ao texto em vez de ter largura fixa: a mediana das\n       frases reais dá 464px e o pior caso 709px, portanto uma largura fixa\n       deixava metade da caixa vazia quase sempre. O tecto vem do pior caso. */\n    width: max-content;\n    max-width: min(800px, calc(100vw - 32px));\n    background: #fff;\n    border: 2px solid #dc2626;\n    border-radius: 12px;\n    padding: 20px 26px 18px;\n    text-align: center;                 /* título e texto ao centro */\n    box-shadow: 0 18px 45px rgba(15, 23, 42, .3);\n}\n\n.gf-dup-titulo {\n    display: flex; align-items: center; justify-content: center; gap: 12px;\n    font-size: 1.5rem; font-weight: 800; letter-spacing: .04em;\n    color: #b91c1c;\n    /* A piscar, com os sinais de sentido proibido de cada lado. */\n    animation: gf-dup-piscar 1.1s ease-in-out infinite;\n}\n.gf-dup-sinal { font-size: 1.5rem; line-height: 1; }\n@keyframes gf-dup-piscar {\n    0%, 100% { opacity: 1; }\n    50%      { opacity: .3; }\n}\n/* Quem tenha o sistema configurado para reduzir movimento não leva o pisca-pisca. */\n@media (prefers-reduced-motion: reduce) {\n    .gf-dup-titulo { animation: none; }\n}\n\n.gf-dup-texto {\n    margin: 14px 0 20px;\n    font-size: 1rem; line-height: 1.45; color: #1e293b;\n    text-wrap: pretty;              /* se algum dia quebrar, que quebre bem */\n}\n.gf-dup-texto strong { color: #0f172a; }\n\n.gf-dup-botoes { display: flex; justify-content: center; gap: 10px; }\n.gf-dup-btn {\n    min-width: 150px; padding: 10px 18px;\n    border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;\n    border: 1px solid transparent;\n}\n.gf-dup-apagar { background: #fff; color: #b91c1c; border-color: #fca5a5; }\n.gf-dup-apagar:hover { background: #fef2f2; }\n.gf-dup-lancar { background: #dc2626; color: #fff; }\n.gf-dup-lancar:hover { background: #b91c1c; }\n.gf-dup-btn:focus-visible { outline: 2px solid #1d4ed8; outline-offset: 2px; }\n\n/* Keep all five work areas adjacent; list exports remain separate. */\n.gf-nav-row .gf-subnav { flex:0 1 auto; justify-content:flex-start; gap:4px; flex-wrap:wrap; overflow:visible; }\n.gf-nav-row .gf-subnav-right { margin-left:0; gap:4px; }\n.gf-tab-faturar { position:relative; }\n.gf-pending-count { display:inline-flex; align-items:center; justify-content:center; min-width:19px; height:19px; padding:0 5px; border-radius:7px; background:#fcf1d8; color:#885a12; border:1px solid #e1bf7b; font-size:10px; font-weight:600; line-height:1; margin-left:7px; box-sizing:border-box; }\n\n.gf-nav-row .gf-subnav { width:auto; }\n[data-maquetes-theme=\"liquido\"] .gf-tab-faturar.active { color:#fff !important; }\n\n/* Coluna da associação: todas as etiquetas com a mesma largura (EF e Consumo\n   interno), para a coluna não ficar com pastilhas de tamanhos diferentes. */\n.gf-td-assoc .gf-ef-tag {\n    min-width: 118px;\n    text-align: center;\n    box-sizing: border-box;\n}\n\n/* Associação: etiqueta fixa na segunda coluna; setas e contador têm espaço próprio. */\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout {\n    display: grid;\n    grid-template-columns: 24px 145px 24px 32px;\n    gap: 4px;\n    align-items: center;\n    width: max-content;\n    margin-inline: auto;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout > :not(.gf-ef-carousel) {\n    grid-column: 2;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel {\n    display: contents;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-tag,\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout > .gf-badge,\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout > .gf-btn-associar-ef {\n    grid-column: 2;\n    width: 145px;\n    min-width: 145px;\n    box-sizing: border-box;\n    min-height: 24px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-nav {\n    grid-row: 1;\n    grid-column: 1;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-nav ~ .gf-ef-carousel-nav {\n    grid-column: 3;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-count {\n    position: relative;\n    left: 3px;\n    grid-row: 1;\n    grid-column: 4;\n    margin: 0;\n    text-align: left;\n}\n\n/* Tipografia da etiqueta EF usada em toda a coluna Associação. */\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout :is(.gf-ef-tag, .gf-badge, .gf-btn-associar-ef) {\n    font-family: inherit !important;\n    font-size: 12px !important;\n    font-weight: 600 !important;\n    line-height: 1.3 !important;\n    letter-spacing: 1px !important;\n}\n\n/* Espaço junto à Associação, medido a partir do conteúdo visível. */\nhtml body .app-layout .main-content .gf-table-faturas :is(th, td):has(+ :is(.gf-th-assoc, .gf-td-assoc)) {\n    padding-right: 0 !important;\n    text-align: center;\n}\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) {\n    padding-left: 0 !important;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout {\n    grid-template-columns: 6px 145px 18px 1px;\n    column-gap: 0;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-nav {\n    width: 18px !important;\n    min-width: 18px !important;\n    padding: 1px !important;\n}\n\n/* Todos os títulos da tabela de faturas com o mesmo tamanho de letra. */\nhtml body .app-layout .main-content table.gf-table-faturas > thead > tr > th,\nhtml body .app-layout .main-content table.gf-table-faturas > thead > tr > th .col-filter-btn {\n    font-size: 12px !important;\n}\n\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-nav:first-child {\n    width: 18px !important;\n    min-width: 18px !important;\n}\n\n/* Mantém o título alinhado com as etiquetas de Associação. */\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) .gf-assoc-layout {\n    margin-left: -10px;\n    margin-right: -20px;\n}\n\n/* Margens iguais nas fronteiras Digitalização/Associação e Associação/€/EF. */\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) {\n    padding-inline: 0 !important;\n}\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) + :is(th, td) {\n    padding-left: 0 !important;\n    text-align: center;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-nav:first-child {\n    justify-self: end;\n}\n\n/* A data de pagamento e o estado têm as mesmas dimensões na tabela. */\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-td-acoes .btn-pago-fixed, .gf-td-pagoed .gf-pago-date) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    width: 76px;\n    min-width: 76px;\n    height: 23px;\n    min-height: 23px;\n    vertical-align: middle;\n}\n\n/* Título e retângulos de Digitalização partilham o centro da coluna. */\nhtml body .app-layout .main-content .gf-table-faturas th:has(+ .gf-th-assoc) .col-filter-wrap {\n    justify-content: center;\n}\n\n/* Valores de €/EF centrados na respetiva coluna. */\nhtml body .app-layout .main-content .gf-table-faturas td.gf-cell-ef-valor {\n    text-align: center;\n}\n\n/* A seta seguinte usa o desenho da anterior, espelhado. */\n.gf-ef-carousel-nav .gf-ef-next-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transform: scaleX(-1);\n}\n\n/* Reduz 6 px entre Verificação e Digitalização: 3 px de cada célula. */\nhtml body .app-layout .main-content .gf-table-faturas :is(th, td):has(+ :is(th, td) + :is(.gf-th-assoc, .gf-td-assoc)) {\n    padding-right: 0 !important;\n}\nhtml body .app-layout .main-content .gf-table-faturas :is(th, td):has(+ :is(.gf-th-assoc, .gf-td-assoc)) {\n    padding-left: 0 !important;\n}\n\n/* Aproxima mais 11 px a Digitalização da Verificação. */\nhtml body .app-layout .main-content .gf-table-faturas :is(th, td):has(+ :is(th, td) + :is(.gf-th-assoc, .gf-td-assoc)) > :is(.col-filter-wrap, .gf-badge) {\n    margin-right: -11px;\n}\n\n/* Aproxima €/EF e Ações em 16 px: 6 px de margens internas e 10 px no conteúdo. */\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) + :is(th, td) {\n    padding-right: 0 !important;\n}\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) + :is(th, td) + :is(th, td) {\n    padding-left: 0 !important;\n}\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) + :is(th, td) + :is(th, td) > :is(.col-filter-wrap, .btn-pago-fixed) {\n    margin-left: -10px;\n}\n\n/* Documento da encomenda do cliente em Para Faturar. */\n.gf-table .gf-encomenda-cliente { text-align: center; }\n.gf-encomenda-controlos { display: flex; align-items: center; justify-content: center; gap: 4px; }\n.gf-encomenda-upload { position: relative; display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; cursor: pointer; }\n.gf-encomenda-upload input[type=file] { position: absolute; inset: 0; opacity: 0; width: 100%; cursor: pointer; }\n\n.gf-procura-id { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin: 0 0 12px; }\n.gf-procura-id label { font-size: 12px; }\n.gf-procura-id .gf-inline-input { width: 160px; }\n\n.gf-table.standard-table :is(th, td).gf-numero-fatura-centro { text-align: center; }\n.gf-table.standard-table .gf-numero-fatura-centro .col-filter-wrap { justify-content: center; }\n\n/* Campos compactos e ações centradas na linha de Para Faturar. */\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-pf-numero { width: 1%; white-space: nowrap; text-align: center; }\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-pf-numero .gf-inline-input { width: 85px !important; min-width: 85px !important; max-width: 85px !important; box-sizing: border-box; text-align: center; }\nhtml body .app-layout .main-content .gf-table-para-faturar td { vertical-align: middle; }\n.gf-pf-acoes-conteudo { display: flex; align-items: center; gap: 4px; white-space: nowrap; }\nhtml body .app-layout .main-content .gf-table .gf-encomenda-controlos .btn-ver-orc,\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-pf-acoes-conteudo :is(.btn-ver-orc, .fr-btn) { display: inline-flex; align-items: center; justify-content: center; height: 32px; min-height: 32px; margin: 0; padding: 3px 10px; box-sizing: border-box; }\n\n/* Visual comum dos controlos, com Rascunho Fatura como referência. */\nhtml body .app-layout .main-content .gf-table :is(.gf-pf-numero .gf-inline-input, .gf-encomenda-controlos .btn-ver-orc, .gf-pf-acoes-conteudo .btn-ver-orc, .gf-pf-acoes-conteudo .fr-btn) {\n    height: 32px !important;\n    min-height: 32px !important;\n    max-height: 32px !important;\n    box-sizing: border-box;\n    border: 1px solid #bfd6ed !important;\n    border-radius: 9px !important;\n    background: #f4f9ff !important;\n    color: #315c80 !important;\n    font: 500 12px 'Segoe UI', sans-serif !important;\n    padding: 3px 10px !important;\n    box-shadow: none !important;\n    letter-spacing: normal;\n}\nhtml body .app-layout .main-content .gf-table :is(.gf-pf-numero .gf-inline-input, .gf-encomenda-controlos .btn-ver-orc, .gf-pf-acoes-conteudo .btn-ver-orc, .gf-pf-acoes-conteudo .fr-btn):hover:not(:disabled) {\n    background: #e1effc !important;\n    border-color: #87b4dd !important;\n}\nhtml body .app-layout .main-content .gf-table :is(.gf-pf-numero .gf-inline-input, .gf-encomenda-controlos .btn-ver-orc, .gf-pf-acoes-conteudo .btn-ver-orc, .gf-pf-acoes-conteudo .fr-btn):focus-within {\n    outline: 2px solid #327bb4;\n    outline-offset: 2px;\n}\n\n/* Aproxima a encomenda do cliente das ações da linha. */\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-encomenda-cliente {\n    width: 1%;\n    white-space: nowrap;\n    padding-right: 0 !important;\n}\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-pf-acoes {\n    width: 1%;\n    padding-left: 0 !important;\n}\n\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-pf-acoes-conteudo {\n    margin-left: 0;\n}\n\n/* Aproxima Nº Fatura e Encomenda Cliente. */\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-pf-numero {\n    padding-right: 0 !important;\n}\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-encomenda-cliente {\n    padding-left: 0 !important;\n}\n\n/* Redução adicional de 5 px entre Nº Fatura e Encomenda Cliente. */\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-pf-numero .gf-inline-input {\n    margin-right: -5px;\n}\nhtml body .app-layout .main-content .gf-table-para-faturar th.gf-pf-numero {\n    text-indent: 5px;\n}\n\n\n/* Desloca só o conteúdo, sem sobrepor o fundo da célula ao botão Ver. */\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-encomenda-cliente > :is(.gf-encomenda-titulo, .gf-encomenda-controlos) {\n    position: relative;\n    left: -4px;\n}\n.gf-encomenda-titulo { display: inline-block; }\n\n/* Desloca apenas Ver, preservando a posição de Rascunho Fatura. */\nhtml body .app-layout .main-content .gf-table-para-faturar .gf-pf-acoes-conteudo > .btn-ver-orc {\n    position: relative;\n    left: -8px;\n}\n\n/* O título Encomenda Cliente herda a tipografia dos restantes cabeçalhos. */\nhtml body .app-layout .main-content .gf-table th.gf-encomenda-cliente .gf-encomenda-titulo {\n    font: inherit !important;\n    letter-spacing: inherit !important;\n    color: inherit !important;\n    text-transform: inherit;\n}\n\n/* Em Falta usa o mesmo visual do estado Não Pago. */\nhtml body .app-layout .main-content .gf-table-faturas .gf-td-emfalta .gf-em-falta {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    width: 76px;\n    min-width: 76px;\n    height: 23px;\n    min-height: 23px;\n    vertical-align: middle;\n    font-family: inherit;\n    font-size: 10.5px !important;\n    font-weight: 600 !important;\n    line-height: 1.2 !important;\n    letter-spacing: .2px;\n    padding: 4px 8px !important;\n    border: 1px solid #bf627373 !important;\n    border-radius: 8px !important;\n    background: #d66b7433 !important;\n    color: #9c3846 !important;\n    box-shadow: none !important;\n    white-space: nowrap;\n}\n\n/* Estados do editor: retângulos iguais e títulos centrados. */\nhtml body .gf-field.gf-editor-estado { width: 100px; min-width: 100px; align-items: center; }\nhtml body .gf-field.gf-editor-estado > label { display: block; width: 100%; text-align: center; }\nhtml body .gf-field.gf-editor-estado > :is(.gf-badge, .btn-pago, .gf-pago-date, .gf-em-falta) {\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    width: 100px !important;\n    min-width: 100px !important;\n    height: 32px !important;\n    min-height: 32px !important;\n    padding: 0 8px !important;\n    line-height: 1.3 !important;\n    border-radius: 8px !important;\n    text-align: center;\n}\n\n/* Valor compacto; espaço adicional reservado a €/EF. */\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-th-valor, td.gf-cell-valor) {\n    width: 1%;\n    white-space: nowrap;\n    padding-left: 3px !important;\n    padding-right: 3px !important;\n}\nhtml body .app-layout .main-content .gf-table-faturas :is(th.gf-th-ef-valor, td.gf-cell-ef-valor) {\n    min-width: 96px;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    text-align: center;\n}\n\n/* Retira 6 px entre Doc. e Verificação e reserva-os para €/EF. */\nhtml body .app-layout .main-content .gf-table-faturas :is(th, td):nth-child(7) {\n    padding-right: 0 !important;\n}\nhtml body .app-layout .main-content .gf-table-faturas :is(th, td):nth-child(8) {\n    padding-left: 0 !important;\n}\n\n/* Número do documento e valor com tipografia uniforme, incluindo o tema. */\nhtml body .app-layout .main-content .gf-table-faturas :is(td.gf-cell-doc, td.gf-cell-valor),\nhtml body .app-layout .main-content .gf-table-faturas td.gf-cell-valor > span:not(.gf-credit-badge) {\n    font-family: inherit !important;\n    font-size: 14px !important;\n    font-weight: 400 !important;\n}\n\n/* Motivos e alternativas da sugestão EF, na ficha da fatura. */\n.gf-sugestoes-ef { margin: 10px 0; padding: 12px; background: #f1f7fd; border: 1px solid #bfd6ed; border-radius: 10px; }\n.gf-sugestoes-ef p { margin: 7px 0; font-size: 12px; line-height: 1.45; }\n.gf-sugestao-card { margin-top: 10px; padding: 10px; border: 1px solid #bfd6ed; border-radius: 8px; background: #fff; }\n.gf-sugestoes-ef .gf-sugestao-aviso { color: #9a5513; font-size: 12px; }\n.gf-sugestoes-ef ul { padding-left: 18px; margin: 8px 0; font-size: 12px; }\n.gf-sugestoes-ef summary { cursor: pointer; font-size: 12px; }\n.gf-sugestoes-ef blockquote { margin: 8px 0; padding: 8px; border-left: 3px solid #bfd6ed; font-size: 12px; white-space: pre-wrap; overflow-wrap: anywhere; }\n.gf-sugestoes-ef button { margin-top: 8px; padding: 6px 10px; border: 1px solid #87b4dd; border-radius: 8px; color: #315c80; background: #eef6ff; }\n.gf-sugestoes-ef button:disabled { opacity: .55; cursor: default; }\n\n/* Aplicar a mesma tipografia ao texto, independentemente da célula/tema. */\nhtml body .app-layout .main-content .gf-table-faturas :is(td.gf-cell-doc, td.gf-cell-valor) > span.gf-numero-texto {\n    font-family: \"Segoe UI\", sans-serif !important;\n    font-size: 14px !important;\n    font-weight: 400 !important;\n    font-style: normal !important;\n    line-height: 21px !important;\n    letter-spacing: normal !important;\n}\n\n/* Coluna DOC.: título e botão deslocados 4 px para a esquerda. */\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-doc-titulo, .gf-doc-link) {\n    position: relative;\n    left: -4px;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-doc-titulo {\n    font: inherit !important;\n    letter-spacing: inherit;\n}\n\n/* Tipografia única dos títulos, com e sem botão de filtro. */\nhtml body .app-layout .main-content table.gf-table-faturas > thead > tr > th,\nhtml body .app-layout .main-content table.gf-table-faturas > thead > tr > th .col-filter-btn,\nhtml body .app-layout .main-content table.gf-table-faturas > thead > tr > th .gf-doc-titulo {\n    font-family: \"Segoe UI\", sans-serif !important;\n    font-size: 12px !important;\n    font-weight: 600 !important;\n    font-style: normal !important;\n    line-height: 18px !important;\n    letter-spacing: .35px !important;\n    text-transform: uppercase;\n}\n\n/* Verificação 5 px à esquerda; mais 5 px antes da coluna de apagar. */\nhtml body .app-layout .main-content .gf-table-faturas :is(th, td):nth-child(8) > :is(.col-filter-wrap, .gf-badge) {\n    position: relative;\n    left: -5px;\n}\nhtml body .app-layout .main-content .gf-table-faturas td.gf-td-del,\nhtml body .app-layout .main-content .gf-table-faturas thead th:last-child {\n    padding-left: 15px !important;\n}\n\n\n\n/* Faturas pagas: azul de DOC.; PAGO EM mantém o visual original. */\nhtml body .app-layout .main-content table.gf-table.gf-table-faturas > tbody > tr.gf-row-pago > td:not(.gf-td-pagoed),\nhtml body .app-layout .main-content table.gf-table.gf-table-faturas > tbody > tr.gf-row-pago > td:not(.gf-td-pagoed) :is(span, a, button, div, strong, small) {\n    color: #426685 !important;\n}\n\n/* Ações das faturas pagas sem transparência, tal como PAGO EM. */\nhtml body .app-layout .main-content table.gf-table.gf-table-faturas > tbody > tr.gf-row-pago > td.gf-td-acoes {\n    opacity: 1;\n}\n\n/* Lista de documentos da encomenda cliente, partilhada pelos dois separadores. */\n.gf-ne-modal { width: min(760px, 94vw); max-height: 85vh; }\n.gf-ne-lista { list-style: none; padding: 0; margin: 16px 0; }\n.gf-ne-lista li { display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid #cbddec; flex-wrap: wrap; }\n.gf-ne-nome { flex: 1 1 220px; overflow-wrap: anywhere; }\n.gf-ne-acoes { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }\n.gf-ne-modal .gf-modal-body { overflow-y: auto; }\n.gf-ne-modal .gf-encomenda-controlos { justify-content: flex-start; }\n.gf-ne-modal .btn-ver-orc { min-height: 32px; display: inline-flex; align-items: center; padding: 4px 10px; }\n\n/* Faturados: consulta indisponível quando não existem anexos. */\nhtml body .app-layout .main-content .gf-table .gf-ver-encomenda-faturado:disabled { opacity: 0.5 !important; cursor: not-allowed; }\n\n.gf-ne-modal { width: min(1100px, 96vw); }\n.gf-ne-documento { display: block; width: 100%; height: 65vh; border: 0; background: white; margin: 10px 0; }\n\n\n/* Algarismos das referências EF com o mesmo tamanho das letras. */\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-reference-text { display:inline; white-space:nowrap; }\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-digits { font-size:12px !important; }\n\n/* Associação: centrar cada conjunto de elementos na célula, sem desvios laterais. */\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) {\n    text-align:center;\n    vertical-align:middle;\n}\nhtml body .app-layout .main-content .gf-table-faturas :is(.gf-th-assoc, .gf-td-assoc) .gf-assoc-layout {\n    display:flex;\n    align-items:center;\n    justify-content:center;\n    gap:3px;\n    width:max-content;\n    margin-inline:auto;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-carousel-count {\n    position:static;\n    margin:0;\n    text-align:center;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .col-filter-wrap {\n    justify-content:center;\n}\n\n/* Mesma altura das etiquetas de Verificação e Digitalização (23 px). */\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout :is(.gf-ef-tag, .gf-badge, .gf-btn-associar-ef) {\n    height:23px;\n    min-height:23px;\n    padding-block:0 !important;\n    box-sizing:border-box;\n}\n\n/* Texto centrado nos dois eixos dentro de cada retângulo de Associação. */\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout :is(.gf-ef-tag, .gf-badge, .gf-btn-associar-ef) {\n    display:inline-flex !important;\n    align-items:center !important;\n    justify-content:center !important;\n    text-align:center !important;\n    padding:0 8px !important;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-reference-text {\n    display:block;\n    margin:0;\n    padding:0;\n    font:inherit;\n    line-height:inherit;\n    text-align:center;\n}\nhtml body .app-layout .main-content .gf-table-faturas .gf-assoc-layout .gf-ef-digits {\n    font:inherit;\n    line-height:inherit;\n    vertical-align:baseline;\n}\n\n/* Data da fatura de cliente, após o número, nas duas listas financeiras. */\n.gf-table.standard-table :is(th, td).gf-data-fatura-cliente { text-align:center; white-space:nowrap; }\n.gf-table.standard-table .gf-data-fatura-cliente .col-filter-wrap { justify-content:center; }\n\n.gf-table-para-faturar .gf-data-fatura-cliente input[type=\"date\"] { width:135px; min-width:135px; text-align:center; }\n\n/* Editor: associação de EF num setor próprio, ao lado dos dados. */\nhtml body .gef-modal-wide.gef-modal-associacao {\n    width: 1440px; max-width: calc(100vw - 32px); max-height: 94vh;\n    margin-inline: auto;\n}\nhtml body .gef-modal-associacao .gef-modal-body-split {\n    display: grid; grid-template-columns: minmax(0, .95fr) minmax(0, 1.05fr) minmax(0, 1.1fr);\n    min-height: 0; overflow: hidden;\n}\nhtml body .gef-modal-associacao .gef-col-preview {\n    width: auto; min-width: 0; box-sizing: border-box;\n}\nhtml body .gef-modal-associacao .gef-col-form {\n    min-width: 0; padding: 18px; overflow-y: auto;\n}\nhtml body .gef-modal-associacao .gef-col-form > div[style] { flex-wrap: wrap; }\nhtml body .gef-modal-associacao .gef-col-associacao {\n    min-width: 0; min-height: 0; padding: 18px;\n    overflow-y: auto; border-left: 1px solid #bdd4e680;\n    background: #f0f8ff80;\n}\nhtml body .gef-modal-associacao .gef-ef-search-box { margin: 0; }\nhtml body .gef-modal-associacao .gef-ef-assoc-row { flex-wrap: wrap; }\nhtml body .gef-modal-associacao .gef-ef-assoc-info { min-width: 0; overflow-wrap: anywhere; }\nhtml body .gef-modal-associacao .gef-associacao-rodape {\n    flex-shrink: 0; padding: 10px 18px; border-top: 1px solid #bdd4e680;\n}\nhtml body .gef-modal-associacao .gef-form-footer {\n    position: static; margin: 0; padding: 0; border: 0; background: transparent;\n}\nhtml body .gef-modal-associacao .gf-save-err { margin-bottom: 8px; }\n@media (max-width: 1100px) {\n    html body .gef-modal-associacao .gef-modal-body-split {\n        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); overflow-y: auto;\n    }\n    html body .gef-modal-associacao .gef-col-associacao {\n        grid-column: 1 / -1; overflow: visible; border-left: 0; border-top: 1px solid #bdd4e680;\n    }\n    html body .gef-modal-associacao .gef-col-form,\n    html body .gef-modal-associacao .gef-col-preview { overflow: visible; }\n}\n@media (max-width: 700px) {\n    html body .gef-modal-wide.gef-modal-associacao { max-width: calc(100vw - 16px); }\n    html body .gef-modal-associacao .gef-modal-body-split { display: block; }\n    html body .gef-modal-associacao .gef-col-associacao { padding: 16px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
